const en = {
  valuesScenarioLoading: {"continue": "Continue assessment", "unavailable": "You can continue without the remaining scenarios. Your selected values and answers will be kept.", "notice": "Values consistency is unavailable because some scenarios could not be prepared. This is not a candidate error.", "saveError": "We couldn’t save your progress. Please try continuing again.", "first": "Preparing your first scenario…", "next": "Preparing your next scenario…", "paused": "Your timer is paused while you wait.", "error": "We couldn’t prepare the next scenario.", "retry": "Try again"},
  conversion: {
    selectedPlan: "Selected plan: {plan}",
    setupProgress: "{done} of {total} steps complete",
    valuesRequired: "Choose at least one core value to continue.",
    reviewPlan: "Selected plan: {plan}. Review the options below before purchasing.",
    "step": "Step {current} of 3",
    "step1": "Account",
    "step2": "Your workspace",
    "step3": "Values and branding",
    "plan": "You chose {plan}. Create your workspace, then review plan options. No payment is taken during signup.",
    "continueEmail": "Continue with email",
    "createWorkspace": "Create workspace",
    "report": "Assessment report",
    "workspaceTitle": "Your workspace details",
    "workspaceDescription": "Tell us who you are and which organization you are hiring for."
},
  resultsActions: {
    "openReport": "Open report",
    "candidateView": "Candidate view",
    "options": "Results options",
    "interviewQuestions": "Interview questions",
    "hideGuidance": "Hide interviewer guidance",
    "copyLink": "Copy candidate link",
    "sendResults": "Send results to {name}"
},

  workStylePresentation: {
    peopleProcess: "Responses suggest a preference for collaborative work with clear responsibilities and consistent processes.",
    "contributions": "How this preference can help",
    "considerations": "Balancing this preference",
    "conditions": "Conditions that support this style",
    "peopleShort": "Collaboration and relationships",
    "processShort": "Structure and consistency",
    "productShort": "Outcomes and delivery",
    "peopleContribution": "May help build shared understanding and coordinate with others.",
    "processContribution": "May bring structure and consistency to how work gets done.",
    "productContribution": "May help keep attention on priorities and tangible outcomes.",
    "peopleConsideration": "Balance shared decisions and supportive relationships with timely action and direct feedback.",
    "processConsideration": "Balance planning and consistency with flexibility when priorities or information change.",
    "productConsideration": "Balance speed and delivery with quality, sustainable ways of working and input from others.",
    "peopleCondition": "Opportunities to collaborate and exchange feedback.",
    "processCondition": "Clear ownership and agreed ways of working.",
    "productCondition": "Clear goals and room to decide how to achieve them.",

    "preferences": "Work preferences",
    "balanced": "All three preferences are equally represented in these responses; no single style takes the lead.",
    "shared": "Joint strongest preferences in these responses. Neither style takes the lead.",
    "leading": "Strongest preference in these responses. Other styles still contribute to the overall profile.",
    "people": "May prefer collaboration, supportive relationships and shared decisions.",
    "process": "May prefer clear responsibilities, careful planning and consistent ways of working.",
    "product": "May prefer tangible outcomes, clear goals and progress toward delivery.",
    "explore": "Reflect and discuss together",
    "question": "When has this profile felt accurate, and when has the situation called for a different approach? Use an example to discuss what helped and what support would be useful.",
    "note": "Percentages show the relative emphasis on each work style in these responses, not ability or performance. A lower percentage does not mean a lack of skill. Use this profile as a starting point for conversation about working together; preferences can vary by situation.",
    "unavailable": "Work style results are not available yet."
},

  lang_code: "en",
  f_thai: "ไทย",
  thai: "Thai",
  f_english: "english",
  English: "English",
  test: "test",
  Name: "Name",
  Purpose: "Purpose",
  Purpose_with_role_varaiables:
    "{Purpose} for {RoleFocus} in {OrganizationType}",
  Purpose_with_none_role_varaiables: "{Purpose} in {OrganizationType}",
  Language: "Language",
  Add: "Add",
  Detail: "Detail",
  Overall: "Overall",
  Rate: "Rate",
  Yes: "Yes",
  No: "No",
  Generate: "Generate",
  Clear: "Clear",
  Copy_Text: "Copy Text",
  Error: "Error",
  min_remaining: "min remaining",
  Step_n: "Step {step}",
  Assessment: "Assessment",
  Warning: "Warning",
  main: {
    dot: ".",
    Values_and_Traits: "Values Alignment",
    Values_Alignment: "Values Alignment",
    Culture_Profile: "Culture Profile",
    Acceptable_Behaviors: "Acceptable Behaviors",
    Work_Style_Identifier: "Work Style Identifier",
    Human_Skills: "Human Skills",
    Logic_Test: "Logic Test",
    Custom_Survey: "Custom Survey",
    Big5: "BIG 5 Personality Test",
    AI_Use_Evaluator: "AI Readiness Assessment",
    Role_Skills_Evaluator: "Role Skills Assessment",
  },

  // Big Five section
  bigFive: {
    title: "Big Five Personality Assessment",
    summary_title: "Big Five Personality",
    openness: "Openness",
    conscientiousness: "Conscientiousness",
    extraversion: "Extraversion",
    agreeableness: "Agreeableness",
    neuroticism: "Neuroticism",
  },

  placeholder: {
    full_name: "Full name",
    email: "Email",
    email_email_com: "email@email.com",
    Work_email: "Work email",
    First_name: "First name",
    Last_name: "Last name",
    Company_name: "Company name",
    What_is_your: "What is your job title",
    The_number_of_hires: "The number of hires per year (estimate)?",
    What_level_are_you: "What level are you at with your culture development?",
    Coupon_code: "Coupon code",
    Code: "Code",
    Key: "Key",
    Enter_coupon_code: "Enter coupon code",
    Email_Address_start: "Email Address*",
    Search_by_name_or: "Search by name or email address",
    Assessment: "Assessment",
    Your_rating: "Your rating",
    Select: "Select",
    Search: "Search",
    Name_your_assessment: "Name your assessment",
    What_is_this_assessment_for: "What is this assessment for?",
    Number_of_employees: "Number of employees",
    Enter_your_email: "Enter your email",
    Enter_your_name: "Enter your name",
    Your_full_name: "Your full name",
    Your_email_address: "Your email address",
    Your_first_name: "Your first name",
    Your_last_name: "Your last name",
    Search_by_name: "Search by name",
    Search_by_name_or_email: "Search by name or email",
    Choose_Assessment: "Choose Assessment",
    Choose_Status: "Choose Status",
  },
  btn: {
    Continue: "Continue",
    Get_started: "Get started",
    Email: "Email",
    ADD: "ADD",
    Next: "Next",
    Skip: "Skip",
    Save: "Save",
    Edit: "Edit",
    Clone: "Clone",
    Duplicate: "Duplicate",
    Delete: "Delete",
    ShareWithTeam: "Share with Team",
    Share: "Share",
    Unshare: "Unshare",
    Invite: "Invite",
    Quick_Invite: "Quick Invite",
    Get_Started: "Get Started",
    Close: "Close",
    Previous: "Previous",
    Finish: "Finish",
    Complete: "Complete",
    Confirm: "Confirm",
    Submit: "Submit",
    Remove: "Remove",
    Leave: "Leave",
    Do_it_later: "Do it later",
    Copy: "Copy",
    Copied: "Copied",
    Send: "Send",
    Re_send_Invit: "Re-send Invite",
    Clear_Results: "Clear Results",
    Cancel: "Cancel",
    Copy_link: "Copy link",
    Share_Analytics: "Share Analytics",
    Copy_key: "Copy key",
    Regenerate: "Regenerate",
    Close_Window: "Close Window",
    Refer: "Refer",
    Yes: "Yes",
  },
  optional: {
    Hiring_candidates: "Hiring",
    New_Hires: "Onboarding",
    Current_team_members: "Team Development",
    Invited: "Invited",
    Started: "Started",
    Incompleted: "Incomplete",
    Completed: "Completed",
    personal: "Personal",
    shared: "Shared",
  },
  login: {
    Assessment_time: "About {minutes} minutes · {count} sections",
    Please_confirm_who_you: "Please confirm who you are",
    I_have_read_and: "I have read and I accept the ",
    terms_of_use: "terms and conditions",
    Send_me_free_stuff:
      "Send me free stuff and occasional emails about MyCulture's services",
    Excited_to_learn_about_you: "We're excited to learn more about you",
    Confirm_details_below:
      "Please confirm your details below to begin your assessment",
    I_agree_to_terms: "I agree to the ",
  },
  timeout: {
    No_time_remaining: "No time remaining",
    The_allocated_time_for_this_section:
      "The allocated time for this section has run out. Please continue to the next step.",
    Session_Time_Out: "Session Time Out",
    Please_proceed_to_the_next_section:
      "Please proceed to the next section of the assessment to complete your submission. Otherwise, you are at risk of losing your responses and may have to re-take the assessment.",
  },
  pincode: {
    Enter_your_PIN_code: "Enter your PIN-code sent to",
    Sign_in_using_a: "Sign in using a different account",
  },
  createAccount: {
    Otp_service_error: "We couldn't finish verification. Check your connection, then request a new code and try again. This did not use an attempt.",
    Get_started_with_your: "Get started with your free assessment.",
    Create_my_free_account: "Create my free account",
    Already_have_a: "Already have a MyCulture account?",
    Log_in_to: "Log in to MyCulture",
    Log_in_to_company: "Log in to {company}",
    // Log_in_to: "Log in to your account",
    Log_in: "Log In",
    Sending_code: "Sending code...",
    Sign_up: "Sign up",
    Do_not_have: "Don't have an account yet?",
    OR: "OR",
    Continue_with_Google: "Continue with Google",
    Continue_with_Microsoft: "Continue with Microsoft Account",
    By_signing_up: "By signing up, I've read the",
    Terms_and_Conditions: "Terms and Conditions",
    Tell_us_a_bit: "Tell us a bit about yourself and your company.",
    Give_your_assessments:
      "Give your assessments your company's look and feel.",
    Upload_your_Logo: "Upload your Logo",
    Finish_sign_up: "Finish sign-up",
    more_than: "more than",
    // new ui
    Let_s_get_started_with:
      "You're minutes away from an assessment you can use. Please enter the details below to get started.",
    Sign_in_with: "Sign in with:",
    Sign_up_to_My_culture: "Sign up to MyCulture",
    Sign_up_to_company: "Sign up to {company}",
    Verify_your_email: "Verify your email",
    Create_My_Free_Account: "Create My Free Account",
    Creating_account: "Creating account...",
    Invalid_email: "This is not a valid email",
    Enter_pin_code_send: "Enter pin-code sent to your email",
    Language: "Language",
    Choose_language: "Choose language",
    Select_your_language: "Select your language",
    Join_Over_Companies: "Join Over 1,000 Companies",
    Trust_Line: "companies trust MyCulture",
    Youre_In_Good_Company_Message:
      "You're in good company. See why leading teams trust MyCulture.ai to build happier, more productive workplaces.",
    Name: "Name",
    Enter_your_first_name: "Enter your first name",
    Last_Name: "Last Name",
    Enter_your_last_name: "Enter your last name",
    Job_title: "Job title",
    Enter_your_job_title: "Enter your job title",
    Enter_your_code_color: "Enter your code color",
    Company_name: "Company name",
    Enter_company_name: "Enter company name",
    Number_of_employees: "Number of employees",
    Choose_quantity: "Choose quantity",
    Drag_drop_or: "Drag&drop or",
    choose_file: "choose file",
    to_upload: "to upload",
    Upload_your_company_logo: "Upload your company logo",
    to_uplChoose_brand_coloroad: "Choose brand color",
    Upload_your_Logo_optional: "Upload your logo (optional)",
    Choose_brand_color_optional: "Choose brand color (optional)",
    Branding_optional_hint:
      "Add them now or anytime from your account settings.",
    Branding_label: "Branding",
    Optional_label: "Optional",
    Logo_label: "Logo",
    Brand_color_label: "Brand color",
    Choose_color: "Choose",
    Company_Values_n_Branding: "Company Values & Branding",
    Please_help_us_with_the_final_details:
      "You're almost done. Please help us with the final details so that we can generate tailor-made assessments for you.",
    Enter_your_core_values_n_max:
      "Select or enter your core values ({max} max)",
    Resend_pin_code_available_in_second:
      "Resend pin-code (available in {seconds} second)",
    Resend_pin_code_available_in_seconds:
      "Resend pin-code (available in {seconds} seconds)",
    Resend_code: "Resend code",
    Code_sent_to: "We sent a code to {email}",
    Change_email: "Change",
    Verify_later: "I'll verify later",
    Core_values_helper:
      "Choose from the list, or type your own value and press Enter to add it. Up to 8 values.",
    Custom_core_value_hint: "Your value isn’t listed? Type it above, then press Enter to add it.",
    Add_custom_core_value: "Add “{value}”",
    Otp_wrong_code: "That code is not right. {count} attempts left.",
    Otp_locked:
      "Too many attempts. Tap Resend to get a new code, or sign in with Google or Microsoft.",
    email_registered: "This email ({email}) has already been registered",
    almost_ready_to_send_your_assessment:
      "Almost Ready to Send Your<br /> Assessment!",
    we_need_some_information_about_you:
      "Add a personal touch by sharing some brief details about yourself. This helps candidates feel more connected when they receive your assessment.",
    Choose_How_to_Verify_Your_Account: "Choose How to Verify Your Account",
    Secure_your_data_and_simplify_future_access:
      "Secure your data and simplify future access.",
    Verify_with_Email_Code: "Verify with Email Code",
    Personal_Information: "Personal Information",
  },
  loginError: {
    no_account: "We couldn't find an account with this email. Check it for typos, or create a new account.",
    // Login form only: followed by the create_account link.
    no_account_lead: "We couldn't find an account with this email. Check it for typos, or",
    use_google: "This email signs in with Google. Use the Google button below.",
    use_microsoft: "This email signs in with Microsoft. Use the Microsoft button below.",
    send_failed: "We couldn't send your code just now. Please try again in a moment.",
    create_account: "create an account.",
  },
  deleteAccount: {
    heading: "Delete account",
    section_desc: "Permanently close your account. This can't be undone.",
    warning_title: "Before you go, here is what happens:",
    warning_1: "Your account will be closed and you'll be signed out.",
    warning_2: "You'll stop receiving emails from us.",
    warning_3: "You won't be able to log back in with this account.",
    warning_4: "This can't be undone.",
    delete_button: "Delete my account",
    modal_title: "Delete your account?",
    modal_body:
      "This closes your account for good. There is no way to bring it back.",
    modal_input_label: "Type your email address to confirm",
    modal_confirm: "Delete account",
    modal_cancel: "Cancel",
    error:
      "Something went wrong while closing your account. Please try again.",
    login_rejected: "This account has been closed and can no longer be used.",
  },
  compare: {
    Selected: "{count} selected",
    Compare: "Compare",
    Clear: "Clear",
    Title: "Compare candidates",
    Overall: "Overall score",
    Max_selected: "You can compare up to 4 candidates",
  },
  upgrade: {
    credits_left: "{remaining} of {total} free credits remaining",
    credits_left_total: "{remaining} of {total} credits left",
    credits_left_paid: "{remaining} credits left",
    out_title: "You're out of credits",
    out_body:
      "Upgrade for more assessments, or refer a friend to earn 10 extra credits.",
    out_banner:
      "You're out of credits. Upgrade to keep inviting candidates, or refer a friend to earn 10 more.",
    bulk_title: "Bulk invites come with paid plans",
    bulk_body:
      "Upgrade to send invites to up to 100 candidates at once and get more assessment credits.",
    see_plans: "See plans",
    upgrade: "Upgrade",
    refer_friend: "Refer a friend, earn 10 credits",
    maybe_later: "Maybe later",
  },
  myAccount: {
    Log_out: "Log out",
    My_Account: "My Account",
    Help_n_Support: "Help & Support",
    Need_Help: "Need Help?",
    Please_leave_us_a_message:
      "Send us a message and we'll reply to your email inbox.",
    Message: "Message",
    Write_your_message_here: "Write your message here",
    Upload_an_attachment: "Upload an attachment",
    Thank_you_for_submitting_your_messasge:
      "Thank you for submitting your message. Our team will be getting back to you within the next 3-48 hours.",
    My_Profile: "My Profile",
    My_Company: "My Company",
    Plan_and_Billing: "Plan & Billing",
    Payment_received_title: "Payment received",
    Payment_received_body:
      "Thank you. Your payment went through. We are setting up your plan now, and it will be ready in a few moments.",
    Payment_whats_next: "What happens next",
    Payment_next_1: "Your plan and credits are being activated.",
    Payment_next_2: "You can keep using MyCulture while this finishes.",
    Payment_go_to_assessments: "Go to my assessments",
    Payment_view_billing: "View plan and billing",
    Out_of_credits_title: "You are out of credits",
    Out_of_credits_body:
      "You have used all your credits. Upgrade your plan to keep generating.",
    Upgrade_plan: "Upgrade plan",
    Not_now: "Not now",
    Team: "Team",
    Teams: "Teams",
    My_Team: "My Team",
    Team_Info: "Team Info",
    Team_Member: "Member",
    Team_Members: "Members ({total})",
    Personal: "Personal",
    Create_a_new_team: "Create a new team",
    Create_a_team: "Create a team",
    Edit_a_team: "Edit Team Name",
    Please_enter_a_name_that_is_unique_and_recognizable:
      "Please enter a name that is unique and recognizable",
    To_invite_members_to_a_team:
      "To invite members to a team, you need to create a team.",
    Team_name: "Team name",
    Copy_from_Personal_Account: "Copy from Personal Account",
    company_and_branding: "Company & Branding Info",
    all_assessments_and_responses: "All Assessments & Responses",
    Invite_Members: "Invite Members",
    role_admin: "Admin",
    role_member: "Member",
    Invite_a_Member: "Invite a Member",
    Add_a_member_to_your_team_by_email_address:
      "Add a member to your team by email address",
    Member_Email: "Member Email",
    You_do_not_have_permission_to_access_the_requested_page:
      "You do not have permission to access the requested page",
    Pending: "Pending",
    Refer_a_friend: "Refer a friend",
    API_Key: "API Key",
    API_Key_intro:
      "This is your unique API key. It's like a personal handshake between your apps and our software. Keep it safe!",
    API_Key_generating_warning:
      "Regenerating your API Key is irreversible and any integration using the key will no longer work. Are you sure you want to proceed?",
    First_Name: "First Name",
    Last_Name: "Last Name",
    Language: "Language",
    Company_Name: "Company Name",
    Logo: "Logo",
    Upload_your_Logo: "Upload your Logo",
    Brand_Color: "Brand Color",
    Brand_Assets: "Brand Assets",
    Unlimited: "Unlimited",
    __remaining: "",
    credit: "credit",
    credits: "credits",
    remaining: "remaining",
    quota_n_remaining: "{value} credit remaining",
    quota_n_remaining_plural: "{value} credits remaining",
    this_month: "this month",
    Add_Credit: "Add Credits",
    Company_Info: "Company Info",
    Email_Preferences: "Email preferences",
    Email_Tracking_Description:
      "Choose how emails sent from this workspace work.",
    Email_Engagement_Tracking: "Track email opens and link clicks",
    Email_Engagement_Tracking_Help:
      "Applies to assessment invitations, result emails, and team invitations. Login, sign-up, and verification emails are never tracked.",
    Email_Candidate_Reply: "Let candidates reply to the assessment's creator",
    Email_Candidate_Reply_Help: "Invitation and result emails show your company as the sender. When this is on, replies go to whoever created the assessment, so candidates will see that person's email address.",
    Email_Preferences_Saving: "Saving...",
    Email_Preferences_Saved: "Email preferences saved.",
    Country: "Country",
    AI_Country_placeholder: "Select country (optional)",
    AI_Country_hint: "Default country for AI requests from your team. Used when regional routing is enabled.",
    AI_Country_user_hint: "Overrides your team's country for your account when regional routing is enabled.",
    Enter_your_company_name: "Enter your company name",
    Switch_to_Team: "Switch to Team",
    Switch_to_Personal: "Switch to Personal",
    Switch_to_Team_Variable: "Switch to {teamName}",
    You_have_been_removed_from_the_team: "You have been removed from the team.",
    refer_a_friend: {
      Special_offer: "Special offer",
      Refer_a_friend_and: "Refer a friend and you both earn +10 free credits!",
      When_a_friend_signs:
        "When a friend signs up for MyCulture and creates an assessment, you'll both earn 10 free credits.",
      Your_unique_referral_link: "Your unique referral link",
      Email_your_invite: "Email your invite",
      we_do_not_recognise: "Sorry, we don't recognize this email address.",
      Successful_Referrals: "Successful Referrals",
      refer_a_friend_success: "Email {email} has been invited",
      Assessment_created: "Assessment created",
      Signed_up: "Signed up",
      Pending: "Pending",
      Pending_credits: "Pending",
      Total_credits_earned: "Total credits earned",
      No_referrals_yet: "No referrals yet",
      Start_inviting: "Start inviting friends to earn credits!",
      Invalid_email: "Please enter a valid email address",
      Email_already_invited: "This email has already been invited",
    },
    planAndBill: {
      Your_current_plan: "Your current plan",
      Free_Plan: "Free Plan",
      Growth_Plan: "Growth",
      Business_Plus_Plan: "Business Plus",
      Unlimited_credits: "Unlimited assessments",
      Unlimited_credits_used: "Unlimited assessments used",
      You_are_used: "You've used",
      out_of: "out of",
      credits: "credits",
      credits_remaining: "credits remaining",
      this_mounth: "this month",
      A_credit_gets_used:
        "An assessment gets used up when a respondent completes an assessment.",
      You_must_have_available:
        "You must have available assessments to send out invitations.",
      All_plans_have_access_to_the_same_benefit:
        "All plans have access to the same benefit",
      Unlimited_assessment_variations: "Unlimited assessment variations",
      Access_to_all_available:
        "Access to all available sections (regularly updated)",
      Group_analytics: "Group analytics",
      Bulk_invites: "Bulk invites",
      Custom_branding: "Custom branding",
      Email_Support: "Email support",
      Continue: "Continue",
      Downgrade_to: "Downgrade to",
      Upgrade_to: "Upgrade to",
      Pay_as_you_go: "Pay as you go",
      Unlimited: "Unlimited",
      For_businesses_that_occasionally:
        "For businesses that hire occasionally and want flexibility.",
      A_one_time_purchase_to_get_unlimited_credits:
        "A one-time purchase to get unlimited credits towards assessments and the manager toolbox.",
      Pay_one_per_credit: " Pay THB 35 per credit.",
      Buy_credit: "Buy credits",
      Buy_credit_n: "Buy credits {price}",
      Buy_for_n: "Buy for {price}",
      Cancel_Subscription: "Cancel Subscription",
      Minimum_purchase_10_credits: "Minimum purchase 10 credits",
      Limited_time_offer: "Limited time offer",
      Manage_your_plan: "Manage your plan",
      Annual_Subscriptionogo: "Annual Subscription",
      Monthly_Subscription: "Monthly Subscription",
      For_businesses_wiht_high: "For organizations that need it all.",
      // ---
      _49_per_month: " Pay $89 per month",
      for_unlimited_credits: "for unlimited assessments.",
      Subscribe: "Subscribe",
      Change_to_Annual: "Change to Annual",
      Change_to_Monthly: "Change to Monthly",
      Select_the_annual_plan: "Billed annually",
      PAY_AS_YOU_GO: "Pay As You Go",
      Available_credits_allow_you:
        "Buy credits send out additional assessment invites and generate templates from your toolbox.",
      Buy_10_for_S10: "Buy 10 for $10",
      Buy_20_for_S18: "Buy 20 for $18 (10% off)",
      Buy_30_for_S24: "Buy 30 for $24 (20% off)",
      Buy_40_for_S28: "Buy 40 for $28 (30% off)",
      Buy_n_credits: "Buy {credits} credits",
      Buy_n_credits_discount: "Buy {credits} credits ({discount}% discount)",
      Price_per_credits: "{currency} {price} per credit",
      Price_with_currency: "{currency} {price}",
      Redeem: "Redeem",
      SUBSCRIPTION: "SUBSCRIPTION",
      Access_unlimited_credits_during:
        "Access unlimited assessments during your subscription period. Cancel at any time to ensure your selected plan doesn't renew.",
      Monthly_for_S49: "Annual for $1,068",
      Billed_today_and_on: "Billed today and on the 6th of each month",
      Annual_for_S441: "Annual for $1,068",
      Billed_today_and_next: "Billed today and next on Dec 6, 2023",
      Coupon: "Coupon",
      Redeem_Free_Credits: "Redeem Coupon Code",
      Enter_your_coupon:
        "Have a coupon code? Enter it below to add assessments to your account.",
      sales_happily_ai: "",
      Coupon_Code: "Coupon Code",
      We_re_sorry: "We're sorry, this code is invalid.",
      credits_redeemed_1: "",
      credits_redeemed_2: "credits redeemed",
      You_have_successfully:
        "You have successfully redeemed credits using your coupon code.",
      Failed_redeem: "Failed redeem",
      credits_used: "assessments used",
      Automatically_renews_on_date: "Automatically renews on {date}",
      Unsubscribe: "Unsubscribe",
      Unsubscribed: "Unsubscribed",
    },
    paymentInteruptPopup: {
      title: "Payments coming soon",
      body: "Thank you for your interest to purchase credits. It's coming soon. In the meantime, refer a friend to earn +10 free credits.",
      confirmButtonText: "Refer a friend",
      cancelButtonText: "Cancel",
    },
    Verified: "Verified",
    Pending_Verification: "Pending Verification",
  },
  fourZeroFour: {
    Looks_like_something: "Looks like something went wrong",
    the_page_or: "the page or link you are looking for is not available!",
    Our_Website: "Our Website",
  },
  assessments: {
    Retry_list: "Try again",
    List_unavailable: "We could not finish loading your assessment list. Please try again.",
    No_matching_assessments: "No assessments match your search. Try another name.",
    My_Core_Values: "My Core Values",
    My_assessments: "My Assessments",
    My_respondents: "My Respondents",
    Create_new_assessment: "Create new assessment",
    Create_assessment: "Create assessment",
    New_Assessment: "New Assessment",
    Get_started: "Get started",
    by_creating_a_new: "by creating a new assessment",
    We_re_generating_your_first_assessment:
      "Sit back and relax. We're generating your first assessment.",
    Our_AI_is_working_with_your_organization_type:
      "Our AI is working with your organization type and set of core values to set up an assessment tailor-made fo you.",
    My_Toolbox: "My Toolbox",
  },
  assessmentsDetails: {
    sections: "sections",
    about_minutes: "About {minutes} min",
    time_estimate_hint: "Most candidates finish in about {typical} minutes. The time limits add up to {max} minutes.",
    Upload_CSV: "Upload CSV",
    Bulk_skipped_no_email: "{count} rows had no valid email and were skipped",
    Bulk_skipped_duplicates: "{count} duplicate emails were skipped",
    Bulk_cap_reached:
      "The list holds up to 100 contacts per batch. {count} contacts did not fit. Send this batch first, then paste the rest again.",
    Bulk_sent_success: "1 invite sent",
    Bulk_sent_success_plural: "{count} invites sent",
    Bulk_sent_partial: "{sent} of {total} invites sent",
    Bulk_partial_note:
      "{sent} of {total} invites sent. The rest are kept below. Check them and send again.",
    Quick_start_modal_title: "Your assessment is ready",
    Quick_start_modal_subtitle: "Saved to My Assessments. You can find it there anytime.",
    Quick_start_modal_built_for: "Built for a {role}.",
    Quick_start_modal_built_for_org: "Built for a {role} at a {org}.",
    Quick_start_modal_values_intro: "Tuned to the values you picked",
    Quick_start_modal_includes: "What's inside",
    Quick_start_modal_confidence:
      "Take it yourself first, then share the link with anyone you'd like to assess.",
    Quick_start_modal_preview: "Preview as a candidate",
    Invite_Candidates: "Invite Candidates ",
    By_public_link: "By public link",
    Public_link: "Public link",
    By_Email: "By Email",
    Invite_in_Bulk: "Invite in Bulk",
    INVITE_MULTIPLE_CANDIDATES: "INVITE MULTIPLE CANDIDATES",
    by_Email: "by Email",
    emails_detected: " emails detected",
    Comma_separate_multiple: "Comma separate multiple email addresses",
    Advanced_Invite_Sender: "Advanced Invite Sender",
    ADVANCED_INVITE_SENDER: "ADVANCED INVITE SENDER",
    Email_Subject: "Email Subject",
    Email_Body: "Email Body",
    Email_Sender: "Email Sender",
    Recipient_s: "Recipient(s)",
    Tip_Paste_contact: "Tip: Paste contact info from a spreadsheet",
    First_Name: "First Name",
    Last_Name: "Last Name",
    Email: "Email",
    Send_Test_Email: "Send Test Email",
    Send_Invite: "Send Invite",
    The_email_will_include: "The email will include a header and footer",
    Scenario: "Scenario",
    Scenario_Alignment: "Scenario Alignment",
    Created_by: "Created by",
    Include_individual_results: "Include Individual Candidate Results",
    Allow_access_to_individual:
      "Allow recipients to view individual candidate results",
    Share_link: "Share Link",
  },
  create: {
    Setup_open_failed: "We could not open the setup. Please try again. Your assessment is still here.",
    Setup_window_blocked: "Your browser blocked the setup window. Allow pop-ups for this site, then select Continue again.",
    Create_new_assessment: "Create new assessment",
    Edit_assessment: "Edit assessment",
    Untitled_assessment: "Untitled assessment",
    Next_Step: "Next Step",
    Next: "Next",
    Previous: "Previous",
    Your_Sections: "Your Sections",
    Add_a_Section: "Add a Section",
    SET_UP_REQUIRED: "SET UP REQUIRED",
    PREPARING_SECTIONS: "PREPARING SECTIONS",
    Culture_Specific: "Culture Specific",
    Role_Specific: "Role Specific",
    General: "General",
    STEP_1: "STEP 1",
    STEP_2: "STEP 2",
    STEP_3: "STEP 3",
    Default_Thank_You_Page: "Default Thank You Page",
    Custom_Page: "Custom Page",
    Name_Assessment: "Set Up Your Assessment",
    Add_Section: "Add Section",
    Remove: "Remove",
    Fill_necessary_info: "Fill necessary information of your new assessment",
    Lets_set_up_your_assessment:
      "Tell us about your assessment so we can tailor it for your team. Fields marked * are required.",
    Assessment_Name: "Assessment Name",
    Assessment_Name_Placeholder: "E.g., Sales Team - Q1 2026",
    Assessment_Name_Hint: "Leave blank to auto-name",
    Select_Sections: "Select Sections",
    Your_Culture_Model: "Your Culture Model",
    Publish: "Publish",
    Review_and_Publish: "Review & Publish",
    Details: "Details",
    Selected: "Selected",
    Select: "Select",
    Values_and_Traits: "Values Alignment",
    Values_and_traits_influence:
      "Values and traits influence behavior. When our values are aligned, working together is easy and natural. And when our desired traits are aligned, we can exercise these values in daily work.",
    Values_Alignment: "Values Alignment",
    Values_Alignment_Description:
      "Values determine behavior. See how personal and company values align.",
    Culture_Profile: "Culture Profile",
    Organizational_culture_is_driven:
      "Identify and match ideal organizational culture profiles.",
    Clan_Create_Collaborate_and: "",
    // ---
    across_six_dimensions_of: "",
    Determine_culture_profile: "Determine culture profile fit",
    Determine_values_traits: "Determine value & trait fit",
    Determine_value_alignment: "Determine value alignment",
    // ---
    Behaviors_are_considered_toxic:
      "Behaviors are considered toxic when they don't align with what's expected.",
    Determine_expected_behaviors_and:
      "Determine expected behaviors and consequences",
    Acceptable_Behaviors: "Acceptable Behaviors",
    Work_Style_Identifier: "Work Style Identifier",
    Identify_a_candidate_work_style:
      "Identify a candidate's work style based on the 3P framework.",
    Product_Process_or_People: "Are you a Product, Process, or People person?",
    // ---
    Understanding_the_inclination_for: "",
    Setup_your_company_values:
      "Setup your company values and traits to identify the attributes that makes your workplace unique.",
    Setup_your_culture_profile:
      "Setup your culture profile by identifying your balance between competing values across 6 dimensions of work.",
    Setup_your_acceptable_behaviors:
      "Setup your acceptable behaviors by going through workplace scenarios and deciding what is acceptable and what's not.",
    No_set_up_required:
      "No set up required to assess work styles according to the 3P framework.",
    We_recommend_selecting_core_values_to_help_configure_your_assessment:
      "Your core values shape the assessment content. Teams that define values see more accurate culture-fit results.",
    Please_specify_organization_type_to_tailor_your_assessment_appropriately:
      "Your organization type helps us generate more relevant questions and scoring.",
    Purpose_Placeholder: "Select purpose",
    Role_Focus_Placeholder: "Type or select a role, e.g. Software Engineer",
    Org_Type_Placeholder: "Type or select, e.g. Technology Startup",
    Company_Values_Placeholder: "Type or select your values (up to 8)",
    Personalization_Section_Label: "Personalize your assessment",
    Personalization_Section_Desc:
      "These details help us generate more relevant questions and scoring criteria.",
    Communication_Styles: "Communication Styles",
    Ready: "Ready",
    Set_up: "Set up",
    SECTIONS: "SECTIONS",
    Sections: "Sections",
    DURATION: "DURATION",
    Assessment_Languages_Label: "Candidate Languages",
    Languages_required_to_support: "Languages candidates can take the assessment in",
    Advanced_Options: "Advanced Options",
    Additional_configurations_to:
      "Additional configurations to apply to your assessment.",
    Extra_Time: "Extra Time",
    min: "min",
    Sharing_Results: "Auto-share Results with Candidate",
    Auto_send_assessment: "Auto-send assessment results to the respondent",
    Open_ended_Feedback: "Open-ended Feedback",
    Allow_Comments: "Allow Comments",
    Allow_respondents_to:
      "Allow respondents to share open-ended feedback after each section",
    Human_Skills: "Human Skills",
    Human_skills_soft_skills:
      "Evaluate written communication, critical thinking, empathy, and situational awareness.",
    Evaluate_human_skills: "Evaluate human skills",
    No_set_up_required_to_assess_written:
      "No set up required to assess written communication, empathy, situational awareness, and critical thinking.",
    Your_Core_Values: "Your Core Values",
    Define_your_organizational:
      "Define your organizational core values as parameters of your Culture Model. Each section will be set up and evaluated based on your values.",
    AI_is_setting_up_your_assessment: "AI is setting up your assessment",
    AI_is_analyzing_your_inputs_and_configuring_assessment_sections:
      "AI is analyzing your organization details and automatically configuring the assessment sections based on your role, organization type, and core values.",
    You_can_click_on_any_section_to_customize_after_AI_setup_completes:
      "You can click on any section to customize it after the AI setup completes.",
    AI_configuring_sections: "AI is configuring assessment sections",
    Click_any_section_to_customize:
      "Click any section to customize after setup",
    AI_task_analyzing: "Analyzing role and values",
    AI_task_selecting: "Selecting assessment sections",
    AI_task_configuring: "Configuring section parameters",

    Quick_Select_or_Add: "Quick Select or Add New Core Values",
    Start_AI_Assisted_Setup: "Start AI-Assisted Setup",
    Proceed_with_Manual_Setup: "Proceed with Manual Setup",
    Pending_Review: "Pending Review",
    Generate: "Generating..",
    Redirect_respondents_to: "Redirect Link",
    Carefully_check_all: "Carefully check all information that you provide.",
    If_something_is_incorrect: "If something is incorrect go back and edit it.",
    Assessment_Permissions: "Team Access",
    TeamAccess: {
      personal:
        "<strong>Only me</strong>: No one else can view or edit",
      shared:
        "<strong>Shared with team</strong>: All team members can view and use",
    },
    Logic_Test: "Logic Test",
    Logical_reasoning_is_key_to_problem_solving:
      "Logical reasoning is key to problem-solving and decision-making.",
    Determine_logical_reasoning_proficiency:
      "Determine logical reasoning proficiency",
    Full_Details: `The Logic Test encompasses various types of logical puzzles, including pattern recognition, logical deduction, and spatial reasoning challenges. Each question is designed to probe the candidate's ability to process information, draw conclusions, and apply logical thinking to different scenarios.

      Candidates will encounter a range of problems, from identifying patterns in data sequences to deducing outcomes based on given premises. The test also includes visual logic questions, adding a layer of spatial and visual-spatial reasoning, essential for roles demanding high-level analytical skills.
      
      This module not only assesses a candidate's raw logical aptitude but also provides insights into their approach to complex problem-solving, a key skill in today's dynamic work environment.`,
    Custom_Survey: "Custom Survey",
    Custom_Survey_Description: `Custom Survey allows you to create a tailored questionnaire for your organization.`,
    Custom_Survey_Description_Footer: `Design your custom survey`,
    are_you_sure_you_want_to_edit_your_configurations_assessment_results_will_be_recalculated_based_on_your_new_parameters:
      "Are you sure you want to edit your configurations? Assessment results will be recalculated based on your new parameters.",
    Big5: "Big5 Personality",
    Big5_Description: `Personality traits influence workplace behavior and team dynamics.`,
    Big5_Description_Footer: `Assess personality dimensions and compatibility`,
    Big5_Strongly_Disagree: "Strongly Disagree",
    Big5_Strongly_Agree: "Strongly Agree",
    Big5_Quick_Hint: "Press <kbd>1-5</kbd> or click to answer",
    AI_Use_Evaluator: "AI Readiness Assessment",
    AI_Use_Evaluator_Description: `Assess the critical thinking, communication, and judgment skills that determine AI effectiveness. Identify who's ready to use AI tools well, and where to invest in development.`,
    AI_Use_Evaluator_Description_Footer: `Determine AI readiness for teams and candidates`,
    Role_Skills_Evaluator: "Role Skills Evaluator",
    Role_Skills_Evaluator_Description: `Evaluates job-specific technical and professional skills through a collaborative, AI-guided work task.`,
    Role_Skills_Evaluator_Description_Footer: `Assess proficiency in role-relevant skills`,

    // AI Readiness Quick Start
    Want_quick_AI_assessment: "Just need to assess AI readiness?",
    Start_AI_Proficiency_Only: "Create AI Readiness Assessment",

    // Assessment Type Selection Modal
    assessment_type_modal: {
      title: "How would you like to build your assessment?",
      subtitle: "Choose how to get started based on your needs.",
      recommended: "Recommended",
      ai_readiness_title: "AI Readiness Only",
      ai_readiness_desc: "Create a focused assessment to evaluate how well candidates or team members use AI tools.",
      auto_build_title: "Auto-build Full Assessment",
      auto_build_desc: "AI will select the best sections and generate content based on your role, organization, and values.",
      manual_title: "Build from Scratch",
      manual_desc: "Start with a blank slate. Pick your own sections and configure everything yourself.",
      or_choose: "or choose manually",
    },
    Setup_title: "Set up your assessment",
    Setup_subtitle: "Tell us who it's for and we'll write questions that fit.",
    Purpose_label: "What is it for?",
    Role_label: "Role (recommended)",
    Role_placeholder: "e.g. Software Engineer",
    Company_heading: "Your company",
    Org_type_label: "Organization type",
    Values_label: "Company values",
    Settings_heading: "Settings",
    Name_label: "Assessment name (optional)",
    Languages_label: "Languages candidates can use",
    Access_label: "Who can see it",
    Field_edit: "Edit",
    Field_done: "Done",
    Access_shared: "My team",
    Access_personal: "Only me",
    Jd_prompt: "Have a job description? Upload it to fill in the role.",
    Jd_upload: "Upload file",
    Jd_reading: "Reading your job description…",
    Jd_done: "Used to fill in the role and tailor the questions.",
    Jd_replace: "Replace",
    Jd_remove: "Remove",
    Jd_error_type: "Upload a PDF or Word file under 5 MB.",
    Jd_error_not_jd: "This doesn't look like a job description. Try another file or type the role.",
    Jd_error_unreadable: "We couldn't read text from this file. Try a Word file or type the role.",
    Jd_error_generic: "Something went wrong. Try again, or type the role.",
  },
  setup: {
    Setup_Complete: "Setup Completed",
    Thank_you_for_setting: "Thank you for setting up the",
    You_can_now_close_this_window: "You can now close this window",
    _Use_the_same_setup: "- Use the same setup as a previous assessment -",
    Proceed_with_a_new_setup: "Proceed with a New Setup",
    Auto_generated_for_form_name: "Auto-generated for {formName}",
    Resume_setup: "Resume setup",
    Use_the_same_setup_as_a_previous_assessment:
      "Use the same setup as a previous assessment",
    create_new_setup: "Proceed with a new setup",
    Create_your_first_assessment_to_get_started:
      "Create your first assessment to get started",
    Create_an_assessment_and_invite_candidates_or_team_members_to_align_on_your_culture_amp_values: `Create an assessment and invite candidates or team members to align
            on your culture &amp; values`,
    Get_Started_by_Creating_a_New_Assessment:
      "Get Started by Creating a New Assessment",
    Youre_just_10_minutes_away_from_evaluating_cultural_fit_for_your_next_hire_new_team_member_or_team_alignment: `Build your dream team in just 10 minutes with data-driven cultural insights`,
    Almost_there_Just_2_quick_steps_to_go:
      "Almost there! Just 2 quick steps to go",
    Account_Created: "Account Created",
    Done: "Done!",
    Build_Your_Assessment: "Build Your Assessment",
    You_are_here: "You are here",
    Start_Evaluating: "Start Evaluating",
    Coming_next: "Coming next",
    Create_First_Assessment: "Create First Assessment",
    See_Sample_Report: "See Sample Report",
    Quick_start_my_assessment: "Quick start my assessment",
    Build_one_from_scratch: "Build one from scratch",
    Welcome_name: "Welcome, {name}",
    Welcome_generic: "Welcome to MyCulture",
    Steps_subtitle:
      "Create an assessment covering culture fit, AI readiness, and role skills.",
    Active_step_detail:
      "Tell us the role you are hiring for to get started, then choose the culture, AI readiness, and skill tests you need.",
    Whats_next: "Your path to a first report",
    Checklist_progress: "About 2 minutes left",
    Checklist_time_quick: "1 min",
    Checklist_auto: "Automatic",
    Checklist_create_account: "Create your account",
    Checklist_create_assessment: "Create your first assessment",
    Checklist_invite_candidate: "Invite your first candidate",
    Checklist_view_report: "Review your first candidate report",
    Quick_start_back: "Back",
    Quick_start_role_step: "Step 2 of 4",
    Quick_start_role_title: "Who are you hiring for?",
    Quick_start_role_subtitle:
      "Tell us the role and we'll tailor every question and the culture-fit scoring.",
    Quick_start_role_placeholder: "e.g. Sales Manager",
    Quick_start_role_chips_label: "Common roles",
    Quick_start_generate: "Generate my assessment",
    Quick_start_role_hint:
      "Takes under a minute. Make changes anytime.",
    Quick_start_building: "Building your {role} assessment",
    Quick_start_building_sub: "This usually takes less than a minute.",
    Quick_start_status_tailoring: "Tailoring questions to {role}",
    Quick_start_status_calibrating: "Calibrating culture-fit scoring",
    Quick_start_status_writing: "Writing answer options",
    Quick_start_status_finalizing: "Finalizing your assessment",
    Quick_start_while_you_wait: "While you wait",
    Quick_start_tip1_title: "Share one link",
    Quick_start_tip1_body:
      "Send one link to every candidate. They can take it on any device, whenever suits them.",
    Quick_start_tip2_title: "Compare fairly",
    Quick_start_tip2_body:
      "Every candidate gets a culture-fit score, so you can compare them side by side.",
    Quick_start_tip3_title: "Invite your whole shortlist",
    Quick_start_tip3_body:
      "Culture fit often surprises you, so invite more than just your top pick.",
    Quick_start_tip4_title: "Make it yours",
    Quick_start_tip4_body:
      "Edit any question or add your own once your assessment is ready.",
    // AI Readiness Quick Start
    Quick_Start: "Quick Start",
    AI_Readiness_Assessment: "AI Readiness Assessment",
    AI_Readiness_Description:
      "Evaluate candidates' critical thinking, communication, and AI collaboration skills in 15 minutes.",
    Create_Now: "Create Now",
    valuesV4: {
      intro: "Your values from step 1 are already set up, so this step is optional. Add detail to sharpen how we compare candidates with your values. There are two short parts:",
      nudge_one: "{values} could be read more than one way. A short description helps us match it well.",
      nudge_many: "{values} could be read more than one way. Short descriptions help us match them well.",
      nudge_action: "Add descriptions (optional)",
      switch_intro:
        "This assessment uses the previous Values Alignment setup, with values sorted into categories. The new version compares candidates with your company's values in your own words. There are two short parts:",
      switch_note: "We'll start from your company values. Candidates who already took this assessment keep their current results.",
      switch_action: "Switch to the new version",
      intro_values_desc_switch:
        "Start from your company values, carried over from the current setup. Rename, add or remove any, and describe the ones that could be read more than one way.",
      guidance_switch:
        "These are your company values, carried over from the current setup. You can rename, add or remove them here. If a value could be read more than one way, add a short description so we understand what it means at your organization.",
      keep_action: "Keep the current setup",
      intro_values_title: "Check your values",
      intro_values_desc:
        "Start from the values you added in step 1. Rename, add or remove any, and describe the ones that could be read more than one way.",
      intro_not_fit_title: "Add values that don't fit (optional)",
      intro_not_fit_desc: "Name values that would clash with the role, and say why. If a candidate picks one, we'll flag it in their results. It lowers their score only when you give a reason.",
      step_name: "Step 1",
      step_title: "Your values",
      step_desc: "Check your values and add any that don't fit",
      count: "{count} values",
      heading: "Your values",
      guidance:
        "These are the company values from step 1. You can rename, add or remove them here. If a value could be read more than one way, add a short description so we understand what it means at your organization.",
      name_placeholder: "Value",
      description_placeholder: "What it means here (optional)",
      description_label: "What {name} means here (optional)",
      add_value_placeholder: "Add a value",
      max_values: "You can have up to {count} values.",
      no_values: "You haven't added any company values yet. Add your first one below.",
      not_fit_title: "Values that don't fit here (optional)",
      not_fit_hint: "Say why each one doesn't fit this role, for example “Regular weekend on-call”. We show the reason in the results and turn it into an interview question. A value lowers the score only when it has a reason.",
      not_fit_suggestions: "Suggestions",
      not_fit_placeholder: "Add your own",
      not_fit_add: "Add",
      not_fit_reason_placeholder: "Why it doesn't fit this role",
      not_fit_reason_label: "Why {name} doesn't fit this role",
      not_fit_no_reason: "No reason yet: it will be flagged in results but won't lower the score.",
      rescore_note: "Candidates who already finished ({count}) will have their results updated a few minutes after you save the assessment on the final step.",
      publish_matching: "Matching your values",
      remove: "Remove {name}",
      save: "Save",
      saving: "Saving",
      error_save: "We couldn't save your values. Please try again.",
      error_load: "We couldn't load your values. Please refresh the page.",
      error_duplicate: "Two of your values have the same name. Rename or remove one.",
      modal_desc:
        "We'll start with the company values you added in step 1. You can change them, describe each one, and add values that don't fit your organization.",
      step_one_hint:
        "Candidates are matched against these values. Use your own words; you can describe each one later.",
      Brief_Description:
        "Values guide how people act and make decisions. This module shows how closely a candidate's personal values match your company's values, written in your own words.",
      Full_Details: `Candidates choose the six values that matter most to them from a list of 24 value cards, then put them in order. The cards are neutral and don't show your company's wording, so candidates can't simply repeat it back.

      Each of your company values is matched to the cards that express it. A value counts in full when a candidate picks the card that expresses it, and half when they pick a related card. Values the cards only partly express count half as much, and values no card can express are left out of the score for you to explore in the interview.

      Short scenarios then test whether the candidate's chosen values hold up when two good options compete. The result is not about excluding people with different values. It shows where you share common ground, and where a conversation in the interview would help.
      `,
    },
    valueAndTraits: {
      Setup_your_Values_and_Traits: "Set up Values Alignment",
      Setup_your_Values: "Setup your Values",
      Select_Core_Values: "Select Core Values",
      Identify_your_most_important_values:
        "Identify your most important values",
      Select_Permission_to_play_values: "Select Minimum Standards",
      Identify_your_basic_ethical_values: "Identify your basic ethical values",
      Select_Non_essential_Values: "Select Non-essential Values",
      Identify_values_that_do_not_guide_behaviors_here:
        "Identify values that do not guide behaviors here",
      // v2 step descriptions (reordered flow)
      v2_desc_permission_to_play: "Permission-to-play values",
      v2_desc_core_values: "Identify what makes you unique",
      v2_desc_non_essential:
        "Identify values that don't guide decisions here",
      v2_get_start_intro:
        "You'll identify three types of values that define your organizational culture:",
      v2_get_start_ptp:
        "Permission-to-play values are the baseline everyone must meet.",
      v2_get_start_core:
        "The few principles you prioritize even when there is a real trade-off.",
      v2_get_start_non:
        "Positive values that are not central to how decisions are made here.",
      v2_guide_ptp_heading: "The baseline for everyone",
      v2_guide_ptp_body:
        "Choose values every person must demonstrate. If a value makes your organization distinctive, save it for Core.",
      v2_guide_core_heading: "What wins when priorities compete",
      v2_guide_core_body:
        "Choose only values you will protect when there is a real trade-off or cost.",
      v2_guide_non_heading: "Positive, but not defining",
      v2_guide_non_body:
        "Choose values you respect but do not consistently use to guide decisions.",
      Review: "Review",
      Confirm_your_value_assignments: "Confirm your value assignments",
      Not_at_all_important: "Not at all important",
      Very_important: "Very important",
      Your_company_core_values:
        "Your company's core values are unique to you, and they provide you with a competitive advantage. Traits are characteristics that make it possible for people to act and behave according to a set of values.",
      In_the_next_steps_do:
        "In the next steps, do your best to select the values and traits that are most important to your organization.",
      Your_company_s_core_values_are:
        "Your company's values define your culture. Permission-to-play values set the boundaries everyone must meet. Core values are what make you unique and drive how people are valued and rewarded. Non-essential values are important to identify because they reveal potential value conflicts with candidates.",
      Remember_that_every_value:
        "Classify values by how work happens today, not by what looks good on paper.",
      Defining_your_values: "Defining your values",
      Select_and_manage_value:
        "Select and manage a set of values that you would like to have available to evaluate and candidates select from.",
      You_can_add_values: "You can add values to the list too.",
      Values_Library: "Values Library",
      Do_not_include: "Do not include",
      Add_Value: "Add Value",
      Add_a_value: "Add a value",
      Add_a_value_to_the:
        "Add a value to the library of values. Please check to ensure it's not too similar to an existing value.",
      New_Value_English: "New Value (English)",
      New_Value_Thai: "New Value (Thai)",
      Enter_value_here: "Enter value here",
      Identifying_key_traits: "Identifying key traits",
      Select_and_manage_traits:
        "Select and manage a set of traits that you would like to have available to evaluate and candidates select from.",
      You_can_add_traits: "You can add traits to the list too.",
      Traits_Library: "Traits Library",
      Add_traits: "Add traits",
      Add_a_trait: "Add a trait",
      Add_a_trait_to:
        "Add a trait to the library of traits. Please check to make sure it's not too similar to an existing trait.",
      New_Trait_English: "New Trait (English)",
      New_Trait_Thai: "New Trait (Thai)",
      Enter_trait_here: "Enter trait here",
      core_values: "Your Core Values",
      permission_to_play: "Your Permission-To-Play Values",
      non_essential: "Your Non-Essential Values",
      moderately_important: "Your Moderately Important values",
      Setup_Completed: "Setup Completed",
      CORE_VALUE: "CORE VALUE",
      PERMISSION_TO_PLAY: "PERMISSION-TO-PLAY",
      ALREADY_CORE_VALUE: "Already classified · Core value",
      ALREADY_MINIMUM_STANDARD: "Already classified · Minimum standard",
      Thank_you_for_setting_up:
        "Thank you for setting up your values. You can now use it to assess values fit with your candidates.",
      What_are_your_core_values_that_set:
        "What are your <u>core values</u> that set you apart?",
      These_are_the_unique_values_that:
        "These are the values you <b>go all-in on</b>. Unlike minimum standards, a core value wins when priorities compete and shapes how people are <b>valued, rewarded, and promoted</b>. Only choose values you are willing to uphold when there is a real cost. <u>Select up to six.</u>",
      What_are_your_permission_to_play:
        "Which values are your <u>minimum standards</u>?",
      These_are_basic_ethical_values:
        "These are the <b>permission-to-play values</b> everyone must demonstrate. If a value primarily differentiates your organization, <b>save it for the Core Values step</b>. <u>Select up to six.</u>",
      What_are_non_essential_values_that_do_not:
        "What are <u>non-essential values</u> that do not guide decisions and actions here?",
      These_are_values_that_do_not_significantly:
        "These may still be <b>positive values</b>, but your organization does not consistently prioritize them when making trade-offs. Choose values that are genuinely outside how work gets done today, not values you dislike. <u>Select at least one.</u>",
      Review_your_values_selection:
        "Review your values selection and importance ratings",
      Confirm_the_assignment_of_each_value:
        "Confirm the assignment of each value to each category that represent the level of importance that value has to your organizational culture. Drag-and-drop to make final adjustments.",
      Set_up_Values_n_Traits: "Set up Values Alignment",
      Set_up_Values_Alignment: "Set up Values Alignment",
      Identify_the_attributes:
        "Identify the attributes that create a high-performing culture by rating a selection of values and traits by importance",
      Identify_your_values:
        "Identify the core, permission-to-play, and non-essential values that guide your decisions and actions",
      Description: "Description",
      Details: "Details",
      Covered_Skills: "Covered Skills",
      This_test_is_relevant_for: "This test is relevant for",
      Brief_Description:
        "Values act as the compass that guide our actions and behavior. The Values assessment module scrutinizes how a candidate's personal values align with the company's core, non-essential, and permission-to-play values, setting the groundwork for efficient, harmonious collaboration.",
      Full_Details: `This comprehensive Values assessment module is designed to gauge the degree of alignment between a candidate's personal values and those that the company holds dear. It isn't about finding the "right" or "wrong" values - instead, the focus is on discovering compatibility and alignment. A match between a candidate's values and the company's values can pave the way for a more seamless integration into the team, smoother collaboration, and a higher likelihood of job satisfaction.


      This module uses a carefully curated list of values with descriptions to allow candidates to reveal their values. The list is designed to be non-leading, unbiased, and neutral to ensure authenticity in responses. The results from this module are then cross-referenced with the company's core values (those that are non-negotiable and intrinsic to the company's identity), permission-to-play values (those that employees must meet to be a part of the organization), and non-essential values (those that, while appreciated, are not mandatory for successful integration).
      
      The process is not about excluding candidates with different values, but about identifying those who would feel at home within the company's culture and contribute to it positively. Ultimately, our Values module aims to predict how candidates will interact with the existing team, how they will handle decision-making, and how they will respond to company culture.
      `,
      Covered_Skills_Text: `- Identifying personal values
      - Self-reflection and introspection
      - Understanding the role of values in decision-making
      - Compatibility with company culture and team dynamics`,
      This_test_is_relevant_for_Text: `- C-Level
      - Business Leaders
      - HR Leaders
      - HR Managers`,
    },
    cultureProfile: {
      Setup_your_Culture_Profile: "Setup your Culture Profile",
      The_Happily_Culture_Profile:
        "The Culture Profile is adapted from the Competing Values Framework and used by over 10,000 companies worldwide.",
      Identify_the_culture_type:
        "Identify the culture type that should dominate 6 different aspects of your organization. Do you want more focus on collaboration, control, competition, or creativity?",
      Setup_Completed: "Setup Completed",
      Thank_you_for_setting_up:
        "Thank you for setting up the Culture Profile. You can now publish it as part of your assessment.",
      Rate: "Rate",
      Overall: "Overall",
      Description: "Description",
      Details: "Details",
      Covered_Skills: "Covered Skills",
      This_test_is_relevant_for: "This test is relevant for",
      Brief_Description:
        "Culture is the backbone of an organization, shaped by a matrix of competing values. The Culture Profile module helps you identify and match candidates with the ideal culture types across six critical work dimensions: Collaborate, Create, Compete, and Control.",
      Full_Details: `The Culture Profile assessment module offers a unique approach to understanding and aligning with your company's culture, using the proven Competing Values Framework adopted by over 10,000 companies globally. It isn't just about identifying a candidate's preferred workplace culture, but about assessing their compatibility with your organization's specific culture type. This can significantly enhance employee satisfaction, productivity, and retention.


      In this module, candidates navigate a series of thought-provoking scenarios and questions exploring six key aspects of work life. The responses help determine the candidate's inclination towards one of the four culture types: Collaborate (a culture emphasizing teamwork, participation, and consensus), Create (a culture encouraging innovation, flexibility, and uniqueness), Compete (a culture that values achievement, results, and winning), and Control (a culture that highlights efficiency, stability, and doing things right).
      
      Understanding how a candidate fits into these cultural quadrants can be transformative. It not only helps place the candidate in a position where they are more likely to thrive but also bolsters the overall harmony and productivity within your teams.
      `,
      Covered_Skills_Text: `- Adaptability to various work cultures
      - Understanding of organizational dynamics
      - Ability to prioritize preferences
      - Awareness of the interplay between personal style and organizational success`,
      This_test_is_relevant_for_Text: `- C-Level
      - Business Leaders
      - HR Leaders
      - HR Managers`,
    },
    acceptableBehaviors: {
      Setup_your_Acceptable_Behaviors: "Setup your Acceptable Behaviors",
      Identify_areas_of_misalignment:
        "Identify areas of misalignment in acceptable behaviors to eliminate toxic behaviors and align on expectations.",
      In_each_scenario:
        "In each scenario, select the level at which each behavior is acceptable or unacceptable as a baseline for comparison.",
      Review_the_acceptable_behaviors:
        "Review the acceptable behaviors that you would like to evaluate. Add or remove scenarios as needed. We recommend that you have no more than 15 scenarios in total.",
      Workplace_Scenarios: "Workplace Scenarios",
      Add_a_workplace_scenario: "Add a workplace scenario",
      Add_a_scenario_that:
        "Add a scenario that would be evaluated by your organization and the respondants as either acceptable, frowned upon, actively discouraged, reprimanded, or zero-tolerance.",
      New_Scenario_English: "New Scenario (English)",
      New_Scenario_Thai: "New Scenario (Thai)",
      Enter_scenario_here: "Enter scenario here",
      Setup_your_Values: "Setup your Acceptable Behaviors",
      Setup_Completed: "Setup Completed",
      Thank_you_for_setting_up:
        "Thank you for setting up your Acceptable Behaviors. You can now publish it as part of your assessment.",
      Add_Scenario: "Add Scenario",
      scenario: "scenario",
      Need_help_View_rating_definitions: "Need help? View rating definitions",
      Rating_Guide_Title: "What each rating means",
      Rating_Guide_Intro: "Rate each scenario by how you would respond if it happened at work. The scale runs from 0, perfectly fine, up to 4, the most serious.",
      Rating_Guide_Reopen_Hint: "You can open this guide again while rating.",
      Rating_Guide_Start: "Got it, let's start",
      Rating_Guide_Outcome_0: "No response needed",
      Rating_Guide_Outcome_1: "Noticed, but let go",
      Rating_Guide_Outcome_2: "Someone speaks up",
      Rating_Guide_Outcome_3: "Formal consequences",
      Rating_Guide_Outcome_4: "Termination",
      Rating_Definitions: "Rating Definitions",
      Description: "Description",
      Details: "Details",
      Covered_Skills: "Covered Skills",
      This_test_is_relevant_for: "This test is relevant for",
      Brief_Description:
        "Behaviors can become disruptive when they don't align with the expected norms. The Acceptable Behaviors module is designed to define and understand behaviors that are encouraged, discouraged, or not tolerated, helping to identify potential mismatches.",
      Full_Details: `Understanding and maintaining acceptable behaviors is essential for a healthy and productive workplace. The Acceptable Behaviors assessment module is designed to shed light on these standards, helping both candidates and employers determine a suitable match.


      In this module, candidates are presented with a series of hypothetical scenarios that reflect real-life workplace situations. The responses to these scenarios help identify the candidate's behavioral inclinations, which are then compared to the company's established standards of acceptable, discouraged, and non-tolerated behaviors.
      
      This process enables us to detect potential mismatches early on and can significantly contribute to building a respectful, inclusive, and harmonious workplace. It also aids in mitigating the risk of toxic behaviors that can hinder productivity, affect team morale, and lead to higher employee turnover.
      
      In addition, it also sets clear expectations about what behaviors are expected within the company, allowing candidates to better understand the culture they may be joining. This clarity can significantly improve both the hiring process and the candidate's integration into their new role.`,
      Covered_Skills_Text: `- Alignment of personal behaviors with company norms
      - Comprehension of behavior's impact on the workplace
      - Adherence to behavior standards
      - Respect for organizational boundaries`,
      This_test_is_relevant_for_Text: `- C-Level
      - Business Leaders
      - HR Leaders
      - HR Managers
      - Team Managers`,
    },
    humanSkills: {
      Setup_Questions: "Set Up Human Skills Questions",
      Questions_Guidance:
        "These questions are designed to evaluate critical thinking, situational awareness, empathy, and written communication. Questions should be framed to give candidates an opportunity to express these skills.",
      Question_N: "Question {n}",
      Add_Question: "Add Question",
      Remove_Question: "Remove",
      Reset_to_Defaults: "Reset to Defaults",
      Language_Tab: "{lang}",
      Description: "Description",
      Details: "Details",
      Covered_Skills: "Covered Skills",
      This_test_is_relevant_for: "This test is relevant for",
      Brief_Description:
        "Human skills, or soft skills, play a vital role in fostering successful relationships and facilitating sound decision-making. This module focuses on evaluating key human skills such as written communication, empathy, situational awareness, and critical thinking.",
      Full_Details: `The Human Skills assessment module has been meticulously designed to probe into and evaluate the more subtle, yet critical, skills that make a candidate successful in any role. As the world of work evolves, the ability to connect, understand, and effectively respond to various situations is becoming increasingly important.


      In this module, candidates are faced with two scenarios that measure their proficiency in written communication. This is not merely about grammar and vocabulary, but also about clarity, conciseness, and the ability to convey complex ideas effectively.
      
      Empathy is evaluated by exploring the candidate's capacity to understand and share the feelings of others, which is crucial in fostering strong relationships within a team and with clients. Situational awareness is tested through the candidate's ability to perceive, understand, and respond to dynamic circumstances or events in the workplace.
      
      Lastly, we assess critical thinking - a skill that underpins effective problem-solving and decision-making. This is gauged by the candidate's ability to objectively analyze information, reason logically, and draw reliable conclusions.`,
      Covered_Skills_Text: `- Proficiency in written communication
- Capacity for empathy and understanding others
- Acute situational awareness and adaptability
- Sound critical thinking and decision-making abilities`,
      This_test_is_relevant_for_Text: `- C-Level
      - Business Leaders
      - HR Leaders
      - HR Managers
      - Team Managers`,
    },
    workStyleIdentifier: {
      Description: "Description",
      Details: "Details",
      Covered_Skills: "Covered Skills",
      This_test_is_relevant_for: "This test is relevant for",
      Brief_Description:
        "Every individual has a unique approach to work, characterized by the 3P framework: Product, Process, or People. The Work Style Identifier module helps uncover a candidate's dominant work style, providing valuable insights into how they complete and prioritize tasks.",
      Full_Details: `The Work Style Identifier assessment module is a powerful tool that delves into a candidate's approach to work. By applying the 3P framework, we can better understand what drives a candidate and how they naturally operate within a work environment.


      In the Product category, individuals are driven by tangible results and deliverables, focusing on the final outcome. In the Process category, people are more inclined towards systematic, step-by-step methods, and consistency in their work. Lastly, the People category includes individuals who prioritize relationships and teamwork, valuing the human element of work above all.
      
      The assessment unfolds through a series of workplace scenarios, asking the candidate to select their dominant preference in each situation. This method offers a real-life approach to understanding a candidate's work style, providing insights into how they might perform tasks, interact with others, and align with the company's workflow.
      
      Identifying a candidate's dominant work style not only helps predict their fit within the team but also empowers managers to allocate tasks more effectively, ultimately leading to improved team performance and job satisfaction.
      `,
      Covered_Skills_Text: `- Understanding one's work style preferences
- Aligning personal work style with scenarios
- Recognizing the impact of work styles on team dynamics
- Flexibility and adaptability in diverse work environments`,
      This_test_is_relevant_for_Text: `- C-Level
      - Business Leaders
      - HR Leaders
      - HR Managers
      - Team Managers`,
    },
    logicTest: {
      Description: "Description",
      Details: "Details",
      Brief_Description:
        "The Logic Test is a critical tool for evaluating a candidate's reasoning abilities. This module challenges candidates with puzzles and scenarios that require keen logical analysis, testing their ability to decipher complex patterns and solve problems effectively.",
      Full_Details: `The Logic Test encompasses various types of logical puzzles, including pattern recognition, logical deduction, and spatial reasoning challenges. Each question is designed to probe the candidate's ability to process information, draw conclusions, and apply logical thinking to different scenarios.

      Candidates will encounter a range of problems, from identifying patterns in data sequences to deducing outcomes based on given premises. The test also includes visual logic questions, adding a layer of spatial and visual-spatial reasoning, essential for roles demanding high-level analytical skills.
      
      This module not only assesses a candidate's raw logical aptitude but also provides insights into their approach to complex problem-solving, a key skill in today's dynamic work environment.`,
      Covered_Skills: "Covered Skills",
      Covered_Skills_Text: `- Advanced problem-solving and critical thinking
      - Pattern recognition and logical sequence analysis
      - Spatial and visual-spatial reasoning
      - Deductive reasoning and hypothesis testing
      - Analytical decision-making under time constraints`,
      This_test_is_relevant_for_Text: ``,
    },
    customSurvey: {
      Set_up_Custom_Survey: "Set up Custom Survey",
      Setup_your_Custom_Survey: "Setup your Custom Survey",
      Question_Block: "Question Block",
      Open_ended: "Open-ended",
      Multiple_Choice: "Multiple Choice",
      Multiple_Select: "Multiple Select",
      Add_your_own_set_of_questions:
        "Add your own set of questions that help you gather essential information & feedback",
      Title_of_Section: "Title of Section",
      Description_optional: "Description (optional)",
      Short_Description: "Short Description",
      Setup_Completed: "Setup Completed",
      Thank_you_for_setting_up:
        "Thank you for setting up a Custom Survey section as part of your assessment.",
      questionTypes: {
        "open-ended": "Open-ended",
        "multiple-choice": "Multiple Choice",
        "multiple-select": "Multiple Select",
      },
      What_makes_you_happiest_at_work: "What makes you happiest at work?",
      Type_your_answer_here: "Type your answer here...",
      Add_Option: "Add Option",
      Option_A: "Option A",
      Option_B: "Option B",
      Add_and_configure_questions: "Add and configure questions",
      Select_from_different_question_and_content_blocks_to_create_an_easy_to_understand_survey:
        "Select from different question and content blocks to create an easy to understand survey",
      Review_your_questions_for_your_custom_survey:
        "Review your questions for your custom survey",
      addMultipleChoiceErrorMsg: "You can add up to 10 options.",
      addMultipleSelectErrorMsg: "You can add up to 20 options.",
      removeMultipleChoiceErrorMsg: "Add at least 2 options.",
      removeMultipleSelectErrorMsg: "Add at least 2 options.",
      save_failed: "We couldn't save your questions. Check your internet connection, then try again.",
      Remove_question_title: "Remove question",
      Remove_question_message: "Are you sure you want to remove this question?",
      draft_restored: "We restored changes you hadn't saved yet.",
      locked_title: "Only wording can be changed",
      locked_message: "Candidates have already started this assessment. You can fix typos and wording, but you can't add, remove or reorder questions or options, because that would mix up the answers you already have.",
      wording_only_notice: "Wording only. Candidates have started, so questions and options can't be added, removed or reordered. Keep each question's meaning the same.",
      wording_only_blocked: "Candidates have started, so only wording can change. Undo any added, removed or reordered questions or options, then try again.",
      started_panel_title: "Custom Survey questions",
      started_panel_body: "Candidates have started, so you can fix typos and wording only. After you save your changes there, go to Review & Publish and click Save to update the assessment.",
      started_panel_button: "Edit wording",
      next_blocked: {
        title: "Add a section title to continue.",
        description: "Add a short description to continue.",
        no_questions: "Add at least one question to continue.",
        question_text: "Question {n} is empty. Write the question to continue.",
        options: "Question {n} needs at least 2 options.",
        empty_option: "Question {n} has an empty option. Fill it in or remove it.",
      },
      Preview: "Preview",
      Description: "Description",
      Details: "Details",
      Brief_Description:
        "Custom Survey is a flexible tool that allows you to create tailored questionnaires specific to your organization's needs. This module enables you to gather precise feedback and insights from employees or candidates, helping you make informed decisions about cultural fit and organizational alignment.",
      Full_Details: `The Custom Survey module offers a unique opportunity to delve deeper into aspects of your company culture that standard assessments might not cover. You can design questions that address your organization's specific values, goals, and challenges, ensuring that you collect the most relevant and actionable data.

In this module, you have the freedom to craft a variety of question types, including open-ended, multiple choice and multiple select questions. This versatility allows you to explore both quantitative and qualitative aspects of a candidate's or employee's perspective, providing a more comprehensive understanding of their potential fit within your organization.

By utilizing custom surveys, you can:
1. Address specific cultural nuances unique to your company
2. Gather insights on particular skills or attributes crucial to your organization
3. Assess alignment with your company's mission and long-term objectives
4. Identify potential areas for organizational improvement

Understanding the responses to your custom survey can be transformative. It not only helps in making more informed hiring decisions but also provides valuable insights for enhancing your overall organizational culture and employee experience.`,
      Covered_Skills: "Covered Skills",
      Covered_Skills_Text: `- Ability to provide targeted feedback
      - Self-awareness and reflection
      - Alignment with specific organizational values
      - Understanding of company-specific practices or methodologies`,
      This_test_is_relevant_for: "This test is relevant for",
      This_test_is_relevant_for_Text: `- All levels of employees
      - Job candidates
      - Department heads
      - HR professionals
      - Leadership teams`,
    },
    big5: {
      Description: "Description",
      Details: "Details",
      Brief_Description:
        "Every individual possesses distinct personality traits that shape workplace behavior. The Big Five personality model measures five core dimensions: Openness, Conscientiousness, Extraversion, Agreeableness, and Neuroticism. This assessment reveals a candidate's natural behavioral tendencies, providing valuable insights into their work preferences and team compatibility.",
      Full_Details: `Every individual possesses distinct personality traits that shape workplace behavior. The Big Five personality model measures five core dimensions: Openness, Conscientiousness, Extraversion, Agreeableness, and Neuroticism. This assessment reveals a candidate's natural behavioral tendencies, providing valuable insights into their work preferences and team compatibility.`,
      Covered_Skills: "Covered Skills",
      Covered_Skills_Text: `- Understanding core personality dimensions and workplace implications
- Identifying natural behavioral patterns and preferences
- Recognizing personality-based strengths and development areas
- Assessing emotional stability and stress management approach`,
      This_test_is_relevant_for: "This test is relevant for",
      This_test_is_relevant_for_Text: `- C-Level
- Business Leaders
- HR Leaders
- HR Managers
- Team Managers`,
    },
    aiUseEvaluator: {
      Description: "Our Philosophy",
      Details: "How It Works",
      Brief_Description:
        "AI effectiveness isn't about knowing which buttons to click. It's about the human skills behind the interaction. Critical thinking, clear communication, contextual knowledge, sound judgment, and values alignment must all work together. If any of these capabilities fall short, AI effectiveness suffers. This assessment measures these interconnected skills to determine true AI readiness.",
      Full_Details: `Candidates complete a realistic task using an AI assistant. Their conversation reveals how they think, communicate, and make decisions when working with AI.

We measure 5 Core Capabilities, the underlying abilities that determine AI effectiveness:
• Critical Thinking – Do they question AI outputs or accept them blindly?
• Communication Clarity – Can they give clear instructions that get useful results?
• Contextual Knowledge – Do they apply their expertise to guide and improve AI outputs?
• Decision Making – Do they make thoughtful choices when presented with options?
• Values Alignment – Do their decisions reflect your company's values?

We also observe 5 Behaviors, meaning what they actually do during the assessment:
• Prompt Quality – How clearly they communicate requests
• Output Review – How thoroughly they check for accuracy
• Refinement Process – How well they iterate to improve results
• Situational Fit – How well they adapt outputs to context
• Decision Quality – How well choices align with values

Results show an overall readiness level, individual scores for each capability and behavior, and specific recommendations for development.`,
      Covered_Skills: "What We Measure",
      Covered_Skills_Text: `- Critical thinking and skepticism toward AI outputs
- Clear, effective communication with AI tools
- Application of domain expertise and context
- Sound judgment and decision-making
- Alignment with organizational values`,
      This_test_is_relevant_for: "Use Cases",
      This_test_is_relevant_for_Text: `- Evaluating candidates before provisioning AI tools
- Assessing current team readiness for AI adoption
- Identifying who needs AI training and support
- Building confidence in AI tool investments
- Any role where AI assistance is being introduced`,
      // Setup modal translations
      Setup_AI_Task: "Configure AI Task",
      Generate_Task_Description:
        "A task will be generated based on the role. You can edit it to fit your needs.",
      Task_Context: "Task Context",
      Role: "Role",
      Organization_Type: "Organization",
      Core_Values: "Core Values",
      Not_specified: "Not specified",
      Generated_Task: "Generated Task",
      Task_For_Candidate: "Task for Candidate",
      Task_Title: "Title",
      Task_Instructions: "Instructions",
      Scenario: "Scenario",
      Your_Task: "Your Task",
      Your_Task_Placeholder: "Describe the specific action the candidate should take...",
      Deliverable: "Deliverable",
      Deliverable_Format: "Format",
      Deliverable_Format_Placeholder: "e.g., Email draft, Memo, Bullet points",
      Deliverable_Recipient: "Recipient",
      Deliverable_Recipient_Placeholder: "e.g., VP Operations, Client",
      Deliverable_Length: "Length",
      Deliverable_Length_Placeholder: "e.g., Under 200 words, 3-5 bullets",
      Must_Include: "Must Include",
      Add_Must_Include: "Add required element...",
      Key_Facts: "Key Facts (shown to candidate)",
      Add_Key_Fact: "Add key fact...",
      Completion_Criteria: "Completion Criteria",
      Completion_Criteria_Placeholder: "When should the candidate consider their task complete?",
      Advanced_Settings: "Advanced Settings",
      Guidance_Prompts: "Guidance Prompts (shown to candidate)",
      Add_Guidance: "Add guidance prompt...",
      Areas_to_Explore: "Areas to Explore",
      Generate_Task: "Generate Task",
      Generating: "Generating...",
      Generating_Task_For_Role: "Generating task for this role...",
      Creating_Tailored_Task: "Creating a tailored, open-ended task based on the role and context",
      Loading_Step_Analyzing: "Analyzing role requirements",
      Loading_Step_Crafting: "Crafting task scenario",
      Loading_Step_Context: "Adding organizational context",
      Loading_Step_Finalizing: "Finalizing details",
      ready_prompt: "I'm ready to help you with this task. How would you like to begin?",
      Consider: "Consider",
      Complete_Task: "Complete Task",
      Message_AI_Assistant: "Message AI Assistant...",
      AI_disclaimer: "AI can make mistakes. Verify important information.",
      message_placeholder: "Type your response...",
      Finish_Title: "Complete Assessment?",
      Finish_Description: "Your conversation will be submitted for evaluation. Make sure you've covered all the skills you'd like to demonstrate.",
      Keep_Working: "Keep Working",
      Next_Section: "Next Section",
      Finish_Assessment: "Finish Assessment",
      Generate_Task_First: "Please generate a task first",
      Ready_For_Review: "AI Proficiency assessment ready for review",
      Configured_Successfully: "AI Readiness Assessment task configured successfully",
    },
    roleSkillsEvaluator: {
      Setup_Title: "Set Up Role Skills Assessment",
      Review_Title: "Review Role Skills Assessment",
      State_Preparing_Title: "Preparing role skills",
      State_Preparing_Description: "We are tailoring the skill set to this role and will mark it ready automatically.",
      State_Ready_Title: "{count} role skills ready",
      State_Ready_Description: "No confirmation is required. You can review or edit the skills at any time.",
      State_Fallback_Title: "Standard role skills ready",
      State_Fallback_Description: "Personalized generation was unavailable, so we used a reliable standard set for this role.",
      State_Error_Title: "Role skills need attention",
      State_Error_Description: "The skills could not be saved. Review them and try saving again.",
      Fallback_Notice_Title: "Using standard role skills",
      Fallback_Notice_Description: "These skills are ready to use. You can keep them, edit them, or try personalization again.",
      Review_Skills: "Review skills",
      Try_Personalization: "Try personalization again",
      Save_Changes: "Save changes",
      Saving: "Saving...",
      Save_Failed: "We couldn't save the role skills. Please try again.",
      Personalization_Failed: "Personalization is temporarily unavailable. Your existing skills are still ready to use.",
      Setup_Description: "Your assessment is already configured. Review or adjust the skills here, then save only if you make changes.",
      Loading_Step_Analyzing: "Analyzing role requirements",
      Loading_Step_Identifying: "Identifying key skills",
      Loading_Step_Finalizing: "Finalizing skill definitions",
      Skills_To_Assess: "Skills to Assess",
      Regenerate: "Regenerate",
      Skill_Name: "Skill name",
      Skill_Description: "Brief description of this skill...",
      Add_Skill: "Add Skill",
      Generating_Skills: "Generating skills for this role...",
      Detail_Description: "Our Philosophy",
      Detail_Brief:
        "Traditional interviews often fail to capture real-world competence. This assessment gives candidates a realistic, collaborative work task with an AI assistant so you can see how they make decisions, handle tradeoffs, and apply the skills that matter most for the role.",
      Detail_How_It_Works: "How It Works",
      Detail_How_It_Works_Text: `When you toggle this section on, AI automatically generates a set of skills relevant to the role based on your assessment context (role, organization type, core values, and purpose).\n\nYou can edit, add, remove, or reorder these skills before publishing.\n\nDuring the assessment, the AI presents one realistic work situation. Candidates can ask questions, make decisions, and develop their response as the situation changes.\n\nResults include an overall score, per-skill scores with proficiency levels (Expert, Proficient, Developing, Beginner, Novice), sub-dimension breakdowns, performance summaries, and the full task transcript.`,
      Detail_What_We_Measure: "What We Measure",
      Detail_What_We_Measure_Text: `- Depth of knowledge in each role-specific skill
- Practical application in a realistic work scenario
- Problem-solving approach within the skill domain
- Ability to articulate technical concepts clearly
- Adaptability and learning mindset`,
      Detail_Use_Cases: "Use Cases",
      Detail_Use_Cases_Text: `- Screening candidates for technical or specialized roles
- Assessing skill depth beyond what resumes show
- Comparing candidates across consistent skill criteria
- Identifying skill gaps for training and development
- Any role where specific professional skills are critical`,
      Wait_For_Generation: "Please wait for the skills to finish generating",
      Configured_Successfully: "Role Skills Assessment is set up",
      Default_Dim_Knowledge: "Knowledge and fundamentals",
      Default_Dim_Knowledge_Desc: "Understands the concepts, tools, and methods of this skill",
      Default_Dim_Application: "Practical application",
      Default_Dim_Application_Desc: "Has done the work and can walk through real examples",
      Default_Dim_Judgment: "Judgment and tradeoffs",
      Default_Dim_Judgment_Desc: "Makes sound decisions when situations are ambiguous",
      Evaluated_On: "Evaluated on",
      Skills_Count: "{count} skills",
      Reorder_Hint: "Drag to reorder",
      Remove_Skill: "Remove skill",
    },
  },
  question: {
    common: {
      move_on_step_n: "Moving on to Step {step}",
      Start: "Start",
      thank_you: "Thank you",
      thank_you_msg:
        "We appreciate you taking the time to complete this assessment. You may now close this window.",
      go_to_main_page: "Go to Main Page",
      close_window: "Close Window",
    },
    valueAndTraits: {
      Values_and_Traits: "Values Alignment",
      Your_values_guide_your:
        "Your values guide your natural tendencies and preferences, and we want to act consistently with our values. And traits explain how our values express themselves.",
      In_this_sectio_you_have: "In this section, you have",
      minutes: "minutes",
      to_identify_and_select_your:
        "to identify and select your underlying values and traits.",
      Select_the: "Select the",
      values_that_best_describe: "values most important to you",
      traits_that_best_describe: "traits that best describe you",
      Click_on_a_word_to_add:
        "Click on a word to add or remove it from your selection.",
      SELECT: "SELECT",
      MORE_ITEMS: "MORE ITEMS",
      Rated_very_important_by: "Rated very important by ",
      but_unselected_by: " but unselected by ",
      Values: "Values",
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this step. The timer will start once you click the <b>"Start"</b> button. Please ensure you have enough time to complete this step without interruptions. 
      Thank you, and good luck!`,
      intro:
        "Our personal values guide our natural tendencies and preferences, and we want to act consistently with our values. Think about what motivates your decisions and actions.",
      intro_highlight: "Identify and select your underlying personal values.",
      v4_intro:
        "Your values guide the choices you make at work. There are no right or wrong answers.",
      v4_intro_highlight:
        "Choose the six values that matter most to you, put them in order, then answer a few short scenarios.",
      v4_get_started_message: `You have <b>{minute} minutes</b> for this step. Choose the six values that matter most to you, put them in order, then answer a few short scenarios. The timer starts when you click <b>"Start"</b>.
      There are no right or wrong answers. Good luck!`,
      parts_label: "Parts of this step",
      part_choose: "Choose 6 values",
      part_order: "Put them in order",
      part_scenarios: "Answer scenarios",
      order_title: "Put your {count} values in order",
      order_help:
        "Put the value that matters most to you at the top. Drag a value, or use the arrows.",
      order_list_label: "Your values, most important first",
      order_move_up: "Move {name} up",
      order_move_down: "Move {name} down",
      order_moved: "{name} is now number {position}",
      order_change_choices: "Change my choices",
      Loading_your_personalized_scenarios:
        "Loading your personalized scenarios",
      Scenario_n_of_n: "Scenario {current} of {total}",
      Consider_this_situation: "Consider this situation",
      How_would_you_respond: "How would you respond?",
      Option_A: "Option A",
      Option_B: "Option B",
    },
    cultureProfile: {
      Culture_Profile: "Culture Profile",
      The_Happily_Culture_Profile:
        "The Culture Profile is adapted from the Competing Values Framework and used by over 10,000 companies worldwide.",
      Which_culture_type_should:
        "Which culture type should dominate? Do you want more focus on collaboration, control, competition, or creativity?",
      Takes: "Takes",
      minutes: "minutes",
      to_go_evaluate_your_ideal:
        "to go evaluate your ideal organization based on 6 different areas.",
      Assessing_each_aspect_divide:
        "Assessing each aspect, divide 100 points among four choices. Give a higher number of points to the choice that is most similar to the organization you want and less or no points to the alternative that is least similar to what you're looking for.",
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this step. The timer will start once you click the <b>"Start"</b> button. Please ensure you have enough time to complete this step without interruptions. 
        Thank you and good luck!`,
      intro: `The Culture Profile is adapted from the Competing Values Framework and used by over 10,000 companies worldwide. Which culture type should dominate? Do you want more focus on collaboration, control, competition, or creativity? Evaluate your ideal organization across six different areas.`,
      Which_best_desribes_your_ideal_organization:
        "Which best describes your ideal organization?",
      Which_best_desribes_your_ideal_leadership:
        "Which best describes your ideal leadership?",
      Which_best_desribes_the_ideal_role_managers_play:
        "Which best describes the ideal role managers play?",
      Which_best_desribes_what_ideally_holds_the_organization_together:
        "Which best describes what ideally holds the organization together?",
      Which_best_desribes_the_basis_of_your_decisions:
        "Which best describes the basis of your decisions?",
      Which_best_desribes_what_success_looks_like:
        "Which best describes what success looks like?",
      Which_best_desribes_the_basis_of_how_decisions_should_be_made:
        "Which best describes the basis of how decisions should be made?",
      Family_Atmosphere: "Family Atmosphere",
      Entrepreneurial_Spirit: "Entrepreneurial Spirit",
      Results_Driven: "Results-Driven",
      Structured_Environment: "Structured Environment",
      Human_Development: "Human Development",
      Opportunity_Exploration: "Opportunity Exploration",
      Competitive_Achievement: "Competitive Achievement",
      Operational_Stability: "Operational Stability",
      Trust_and_Loyalty: "Trust & Loyalty",
      Innovative_Commitment: "Innovative Commitment",
      Achievement_Focus: "Achievement Focus",
      Structured_Stability: "Structured Stability",
      Teamwork_Emphasis: "Teamwork Emphasis",
      Individual_Innovation: "Individual Innovation",
      Competitive_Drive: "Competitive Drive",
      Stable_Employment: "Stable Employment",
      Nurturing_Leadership: "Nurturing Leadership",
      Innovative_Pioneers: "Innovative Pioneers",
      Aggressive_Focus: "Aggressive Focus",
      Efficient_Coordination: "Efficient Coordination",
      People_Centric_Success: "People-Centric Success",
      Innovative_Leadership: "Innovative Leadership",
      Marketplace_Dominance: "Marketplace Dominance",
      Operational_Efficiency: "Operational Efficiency",
    },
    acceptableBehaviors: {
      Acceptable_Behaviors: "Acceptable Behaviors",
      Evaluating_Acceptable_Behaviors: "Evaluating Acceptable Behaviors",
      In_the_workplace_it_is_not_uncommon:
        "In the workplace, it is not uncommon to come across undesirable behaviors. We may tolerate some more than others.",
      Please_provide_a_rating_for_each:
        "Please provide a rating for each scenario based on your preference and tolerance levels.",
      Acceptable: "Acceptable",
      Acceptable_Desc:
        "This behavior is fine and doesn't cause any issues.",
      This_behavior_is_acceptable: "This behavior is acceptable to me.",
      Frowned_Upon: "Frowned Upon",
      Frowned_Upon_Desc:
        "It bothers you, but it isn't serious enough to act on.",
      This_behavior_is_not_acceptable:
        "This behavior is not acceptable and I am visibly upset when it happens.",
      Actively_Discouraged: "Actively Discouraged",
      Actively_Discouraged_Desc:
        "You would speak up or take steps to stop it.",
      This_behavior_is_unacceptable_Discouraged:
        "This behavior is unacceptable. I will go out of my way to discourage it.",
      Reprimanded: "Reprimanded",
      Reprimanded_Desc:
        "It calls for a formal warning or disciplinary action.",
      This_behavior_is_unacceptable_Reprimanded:
        "This behavior is unacceptable. There should be repercussions.",
      Zero_Tolerance_Policy: "Zero Tolerance Policy",
      Zero_Tolerance: "Zero Tolerance",
      Zero_Tolerance_Desc:
        "It should lead to immediate termination.",
      Setup_Step_1_Title: "Evaluating Acceptable Behaviors Tutorial",
      Setup_Step_1_Desc:
        "Select and manage a set of values that you would like to have available to evaluate and candidates select from.",
      Setup_Step_2_Title: "Rate each scenario",
      Setup_Step_2_Desc:
        "Please provide a rating for each scenario based on your preference and tolerance levels.",
      This_behavior_is_irreprehensible:
        "This behavior is irreprehensible, and no second chance should be given.",
      Scenario: "Scenario",
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this step. The timer will start once you click the <b>"Start"</b> button. Please ensure you have enough time to complete this step without interruptions. 
      Thank you and good luck!`,
      intro: `In the workplace, it is not uncommon to come across undesirable behaviors. We may tolerate some more than others. This part takes up to 5 minutes. Please rate each scenario based on your preferences and tolerance levels.`,
    },
    workStyleIdentifier: {
      Work_Style_Identifier: "Work Style Identifier",
      identify_your_work_style:
        "Identify your work style based on the 3P framework: Product, Process, or People. Better understand how you complete and prioritize activities at work.",
      complete_each_workplace_scenario:
        "Complete each workplace scenario by selecting your primary action, priority, or preference.",
      Based_on_your_natural_tendencies:
        "Based on your natural tendencies, what is your closest response or action to this workplace scenario?",
      SCENARIO: "SCENARIO",
      Scenario: "Scenario",
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this step. The timer will start once you click the <b>"Start"</b> button. Please ensure you have enough time to complete this step without interruptions. 
      Thank you and good luck!`,
      intro: `Identify your work style based on the 3P framework: Product, Process, or People. Better understand how you complete and prioritize activities at work. Complete each workplace scenario by selecting your primary action, priority, or preference.`,
    },
    humanSkills: {
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this step. The timer will start once you click the <b>"Start"</b> button.Please ensure you have enough time to complete this step without interruptions. 
        Thank you for your participation and good luck on the first step!`,
      intro: `Showcase your communication ability, empathy, situational awareness, and critical thinking by answering the following open-ended questions to the best of your ability. Be analytical by sharing your thought process, and be specific by providing examples.`,
      Showcase_your_communication_ability:
        "Showcase your communication ability, empathy, situational awareness, and critical thinking by answering the following open-ended questions to ",
      The_best_of_your: "the best of your ability.",
      Be_analytical_by_sharing:
        "Be analytical by sharing your thought process, and be specific by providing examples.",
      You_will_have_ten_min:
        "You'll have 10-min in total to respond to two questions.",
      Write_your_response: "Write your response here...",
      Your_answer: "Your answer",
      Write_your_answer_here: "Write your answer here",
    },
    logicTest: {
      Logic_Test: "Logic Test",
      intro:
        "This section evaluates your skills in pattern recognition, logical deduction, and problem-solving. Pay close attention to detail and think analytically. The test is timed, emphasizing both accuracy and efficiency, with 4 sections.",
      Section: "Section",
      Question: "Question",
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this step. The timer will start once you click the <b>"Start"</b> button. Please ensure you have enough time to complete this step without interruptions. 
        Thank you and good luck!`,
      question_n: "Question {n}",
      question_button_label: "{name} ({point} Points)",
      answer_n:
        "<span style='font-size: 12px; font-weight: 700; color: {color}'>Answer</span>: {n})",
      correct_answer_n:
        "<span style='font-size: 12px; font-weight: 700; color: {color}'>Correct Answer</span>: {n})",
      sum_score_each_section_n: "{sum_point} out of {max_point} ({percent}%)",
    },
    customSurveys: {
      Custom_Surveys: "Custom Survey",
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this step. The timer will start once you click the <b>"Start"</b> button. Please ensure you have enough time to complete this step without interruptions. 
      Thank you, and good luck!`,
      Set_up_Custom_Survey: "Set up Custom Survey",
      Setup_your_Custom_Survey: "Setup your Custom Survey",
      Question_Block: "Question Block",
      Add_your_own_set_of_questions:
        "Add your own set of questions that help you gather essential information & feedback",
      Title_of_Section: "Title of Section",
      Description_optional: "Description (optional)",
      Short_Description: "Short Description",
    },
    aiUseEvaluator: {
      AI_Use_Evaluator: "AI Readiness Assessment",
      intro:
        "This section assesses your readiness to work effectively with AI tools. You will interact with an AI assistant to accomplish a given task. Your critical thinking, clear communication, and ability to verify AI responses will demonstrate your AI readiness.",
      get_started_message: `Please note that you have <b>{minute} minutes</b> to complete this task. The timer will start once you click the <b>"Start"</b> button. 
        
        <b>Tips for success:</b>
        • Be clear and specific in your prompts
        • Break down complex problems into smaller steps
        • Verify the AI's responses for accuracy
        • Ask follow-up questions to refine results
        
        Good luck!`,
      Task: "Task",
      Your_Task: "Your Task",
      Deliverable: "Deliverable",
      Key_Facts: "Key Facts",
      Type_your_message: "Type your message...",
      Send: "Send",
      Im_Done: "I'm Done",
      Finish_Task: "Finish Task",
      AI_Assistant: "AI Assistant",
      You: "You",
      Attach_files: "Attach files or images",
      File_too_large: "File is too large. Maximum size is 10MB.",
      File_type_not_supported: "File type is not supported.",
      Remove_attachment: "Remove attachment",
      Thinking: "Thinking...",
      Time_Remaining: "Time Remaining",
      Complete_Task_Early: "Complete Task Early",
      Complete_Task_Early_Message: "Are you sure you want to complete this task? You still have time remaining.",
      Yes_Complete: "Yes, Complete",
      Continue_Working: "Continue Working",
      Task_Completed: "Task Completed",
      Task_Completed_Message: "Your conversation has been recorded and will be analyzed to assess your AI readiness.",
    },
  },
  assessmentTest: {
    Hello: "Hello",
    minutes_remaining_defore: "",
    minutes_remaining_after: "minutes remaining",
    Thank_you_for_taking:
      "Thank you for taking the time to complete this assessment with us at",
    Thank_you_for_taking_end: ".",
    A_few_things_you_should: "A few things you should know before you start:",
    Time_estimate: "Most people finish in about {typical} minutes. Each part has its own timer, so it won't take longer than {max} minutes.",
    Time_estimate_max_only: "This takes up to {max} minutes. Each part has its own timer.",
    It_is_in_your_best_interest:
      "It is in your best interest to answer truthfully.",
    There_is_no_right: "Answer honestly and to the best of your ability.",
    If_you_re_unsure: "If you're unsure, trust your gut instinct.",
    Thank_you_for_taking_to_complete:
      "Thank you for taking the time to complete the",
    Thank_you_for_taking_to_complete_the_assessment:
      "Thank you for taking the time to complete the assessment",
    section_of_the_assessment: "section of the assessment.",
    You_ve_completed_this_section: "You've completed this section",
    You_ve_completed_all_section: "You've completed all section",
    You_have_completed_all_sections:
      "You have completed all sections of the assessment. You can now close this window.",
    Once_you_re_ready:
      "Once you're ready, please continue to the next section.",
    Go_to_the_Next_Section: "Go to the Next Section",
    POINTS_REMAINING: "POINTS REMAINING",
    Optional: "Optional",
    Anyz_feedback_or_thoughts: "Any feedback or thoughts to share about ",
    values_and_traits_q: "values alignment?",
    culture_profile_q: "culture profile?",
    acceptable_behaviors_q: "acceptable behaviors?",
    work_style_identifier_q: "work style identifier?",
    human_skills_q: "human skills?",
    big_five_personality_q: "Big Five personality?",
    Describe_a_time_when_you:
      "Describe a time when you had to solve a complex problem at work. What was your thought process, and how did you arrive at a solution?",
    Imagine_you_are_working_on:
      "Imagine you are working on a team project with a tight deadline, and you discover a significant flaw in the project's design. What steps do you take to address the issue, and how do you ensure the project stays on track?",
  },

  // Big Five Assessment Test
  assessment: {
    big_five: {
      title: "Big Five Personality Assessment",
      description:
        "Answer how much you agree with each statement about yourself.",
      question_of: "Question {current} of {total}",
      keyboard_hint: "Use number keys 1-5 for quick answers:",
      options: {
        strongly_disagree: "Strongly Disagree",
        disagree: "Disagree",
        neutral: "Neutral",
        agree: "Agree",
        strongly_agree: "Strongly Agree",
      },
      instructions: {
        title: "Instructions",
        content:
          "Rate each statement based on how accurately it describes you. There are no right or wrong answers - just be honest about yourself.",
        time_estimate:
          "This assessment takes approximately 10-15 minutes to complete.",
        tip: "If you're unsure about a statement, go with your first instinct.",
      },
    },
  },
  assessmentResults: {
    es2: {
      title: "Executive Summary",
      ai_label: "AI summary",
      ai_label_about: "About this AI summary",
      ai_tip_source: "AI wrote this from {name}'s results{jd}.",
      ai_tip_source_jd: " and the job description",
      ai_tip_calculated: "The match level, rank and scores are calculated, not written by AI.",
      ai_tip_use: "Use it to plan the interview, not to make the decision.",
      flag: "Flag an issue",
      copy: "Copy",
      copied: "Summary copied",
      collapse: "Collapse Executive Summary",
      expand: "Show summary",
      level_strong: "Strong match",
      level_mixed: "Mixed match",
      level_weak: "Weak match",
      rank: "Ranks {position} of {total} candidates",
      rank_short: "{position} of {total}",
      meta_role: "For {role}",
      meta_no_role: "No role set",
      meta_based_on: "Based on {count} completed sections",
      meta_based_on_jd: "Based on {count} completed sections and the job description",
      stands_out: "What stands out",
      closer_look: "Worth a closer look",
      stands_out_empty: "No high scores in this assessment.",
      closer_look_empty: "No moderate or low scores in this assessment.",
      column_empty_neutral: "Nothing else to note here.",
      dealbreaker: "Dealbreaker: {section} {score}",
      dealbreaker_behaviors: "Rated some behaviors as fine that your team doesn't accept.",
      see_answers: "See answers",
      pace_title: "Read these results with care",
      pace_body: "{name} finished in {spent} minutes. Most people take about {typical} minutes, so some answers may be rushed.",
      role_title: "Against the job description",
      role_sub: "{count} requirements from {file}",
      role_sub_one: "{count} requirement from {file}",
      role_sub_no_file: "{count} requirements from the job description",
      role_sub_no_file_one: "{count} requirement from the job description",
      role_shown: "{n} shown",
      role_ask: "{n} to ask about",
      role_not_met: "{n} not met",
      role_not_assessed: "{n} not assessed",
      status_shown: "Shown",
      status_partly: "Partly shown",
      status_worth_asking: "Worth asking",
      status_not_met: "Not met",
      status_not_assessed: "Not assessed",
      col_asks: "The role asks for",
      col_shows: "What the results show",
      col_status: "Status",
      add_jd_title: "Compare {name} with the role",
      add_jd_body: "Add a job description to see which requirements the results support.",
      add_jd: "Add job description",
      questions_title: "{n} interview questions",
      questions_sub: "Picked to test the points above",
      add_to_checklist: "Add to question checklist",
      added_to_checklist: "{n} questions added to your checklist",
      already_in_checklist: "These questions are already in your checklist",
      tests: "Tests: {what}",
      source_job_description: "Job description",
      details: "Details",
      show: "Show",
      hide: "Hide",
      generating: "Reading {count} sections{jd}",
      error: "We couldn't write this summary. The scores above are still correct.",
      retry: "Try again",
      not_enough_title: "Not enough results for a summary yet",
      not_enough_body: "A summary needs at least three finished sections, including Values Alignment, Culture Profile or Human Skills. {name} has finished {done} so far.",
      section_done: "{section}, done",
      section_not_started: "{section}, not started",
      flag_title: "What's wrong with this summary?",
      flag_wrong: "Something is wrong or made up",
      flag_unfair: "It feels unfair or biased",
      flag_unclear: "It's hard to understand",
      flag_other: "Something else",
      flag_note: "Tell us more (optional)",
      flag_send: "Send",
      flag_sent: "Thanks for flagging this.",
      flag_failed: "Couldn't send that. Please try again.",
      checklist_failed: "Couldn't add the questions. Please try again.",
    },
    gathering_information: "Gathering information...",
    evaluator_section_mismatch_title: "These results belong to a different assessment section",
    evaluator_section_mismatch_description:
      "This candidate completed {recordedSection}, but the assessment is now configured for {currentSection}. Existing responses cannot be converted into the new result type. Reset and retake this candidate to collect the expected results.",
    analyzing_culture_fit:
      "Analyzing culture fit and generating comprehensive insights",
    // Executive Summary Section
    assessment_analysis_unavailable: "Assessment Analysis Unavailable",
    insufficient_assessment_data:
      "The Executive Summary requires at least 3 completed assessment sections, including Values Alignment, Culture Profile, or Human Skills, to generate meaningful AI-powered insights. Additional sections help connect results and provide a comprehensive candidate overview.",
    executive_summary: "Executive Summary",
    ai_powered_assessment_analysis: "AI-Powered Assessment Analysis",
    ai_insights: "AI INSIGHTS",
    risk_level: "Compatibility",
    alignment_levels: {
      high_alignment: "High Alignment",
      moderate_alignment: "Moderate Alignment",
      low_alignment: "Low Alignment",
      poor_alignment: "Poor Alignment",
    },
    value_importance: {
      core_value: "Core Value - Extremely Important",
      permission_to_play: "Permission to Play - Very Important",
      moderately_important: "Moderately Important",
      somewhat_important: "Somewhat Important",
      non_essential: "Non-essential",
    },
    valuesV4: {
      candidate: "The candidate",
      band_high: "High",
      band_moderate: "Moderate",
      band_low: "Low",
      not_scored: "Not scored",
      shared: "Shared",
      partly: "Partly shared",
      not_shared: "Not shared",
      summary_shared: "{name} closely shares {shared} of your {total} values.",
      doesnt_fit: "Doesn't fit",
      factors_title: "What shaped this score",
      score_label: "Alignment score",
      factor_raised: "Raised the score:",
      factor_lowered: "Lowered the score:",
      factor_shared_all: "Shares all {total} of your values",
      factor_shared: "Shares {count} of your {total} values",
      factor_partly: "Partly shares {count} more",
      factor_not_shared: "Didn't choose anything near {values}",
      factor_not_a_fit: "Chose {card}, one of the values you said doesn't fit here",
      factor_tension: "Chose {card}, which can pull against {value}",
      legend_not_fit: "Doesn't fit here",
      legend_tension: "Pulls against a value",
      anchor_pulled: "{cards} pulls against it",
      summary_partly_one: "1 more is partly shared.",
      summary_partly_many: "{count} more are partly shared.",
      summary_not_one: "1 isn't shared.",
      summary_not_many: "{count} aren't shared.",
      summary_verified: "Picks held up in {verified} of {total} scenarios.",
      summary_ceiling: "Six picks can't cover all {total} of your values, so the score is out of the best six picks can reach.",
      summary_not_scored: "None of your values could be scored from the value cards, so there's no score. Explore them in the interview.",
      meet_title: "Where your values and {name}'s meet",
      pairs_help: "Each of your values next to the pick that comes closest to it.",
      pairs_help_ranked: "Each of your values next to the pick that comes closest to it. Numbers are {name}'s own order of importance.",
      map_title: "{name}'s picks on the values map",
      map_help: "Cards that candidates often choose together sit side by side. Numbered dots mark your values on the card that expresses them. Point at a card, group or value for details.",
      map_aria: "The value cards in a ring, shaded by how close each is to the candidate's picks, with your values marked around the outside.",
      view: "View",
      pairs: "Pairs",
      map: "Map",
      only_yours: "Only on your list",
      only_yours_sub: "Your values with no pick nearby",
      only_yours_empty: "Every one of your values has a pick near it.",
      common_ground: "Common ground",
      common_ground_key: "≈ shared · ~ partly shared",
      common_ground_empty: "None of their picks is near your values.",
      only_theirs: "Only on theirs",
      only_theirs_sub: "Their picks outside your list",
      only_theirs_empty: "All of their picks relate to your values.",
      no_pick_near: "No pick near it",
      closest_card: "Closest card is {card}, which they didn't pick",
      checked_in_scenarios: "No value card expresses this, so explore it in the interview",
      unmatched: "Couldn't be matched to the value cards, so it isn't in the score",
      counts_half: "No card is closer · counts half",
      needs_discussion: "Didn't hold up in its scenario",
      listed_not_fit: "Your company listed {values} as not a fit",
      pulls_against: "Can pull against {values}",
      not_near_yours: "Not near any of your values",
      credit_full: "Full",
      credit_half: "Half",
      anchor_on: "on {card}",
      anchor_via: "on {card} · via {pick}",
      anchor_also: "also near {picks}",
      legend_pick: "Their pick",
      legend_close: "Close to a pick",
      legend_related: "Related to a pick",
      legend_none: "Not near their picks",
      legend_picks_title: "Their picks",
      legend_pick_shared: "Shares one of your values",
      legend_pick_partly: "Partly shares one",
      legend_pick_theirs: "Only theirs",
      legend_pick_conflict: "Lowered the score",
      legend_around_title: "Other cards",
      tip_pick: "Their pick",
      tip_pick_rank: "Their pick, number {rank}",
      tip_shares: "Shares {values}",
      tip_partly: "Partly shares {values}",
      tip_also_near: "Also near {values}",
      tip_not_fit: "You said this doesn't fit here",
      factor_not_a_fit_reason: "Chose {card}, one of the values you said doesn't fit here ({reason})",
      not_fit_reason: "Why: {reason}",
      not_fit_uncounted: "No reason given, so it didn't lower the score",
      watch_not_a_fit_reason: "They picked {card}, and your company listed {values} as not a fit: {reason}.",
      watch_not_a_fit_uncounted: "They picked {card}, and your company listed {values} as not a fit. No reason was given, so it didn't lower the score.",
      reflect_not_a_fit_reason: "You chose {card}. In this role: {reason}. How would that work for you?",
      tip_not_fit_reason: "You said this doesn't fit here: {reason}",
      tip_close: "Close to {picks}",
      tip_related: "Related to {picks}",
      tip_none: "Not near any of their picks",
      tip_your_value: "Your value here: {values}",
      tip_group_picks: "Their picks here: {picks}",
      tip_group_none: "None of their picks are in this group",
      group_doing_it_right: "Doing it right",
      group_growing: "Growing",
      group_striving: "Striving",
      group_steady: "Steady",
      group_community: "Community",
      group_people: "People",
      guidance_title: "Interviewer guidance",
      watch_out: "Worth discussing",
      watch_not_shared: "Nothing they picked is near {value}.",
      watch_not_shared_card: "Nothing they picked is near {value}. The closest card is {card}.",
      watch_needs_discussion: "{card}, their pick for {value}, didn't hold up in its scenario.",
      watch_tension: "{card} can pull against {value}.",
      watch_not_a_fit: "They picked {card}, and your company listed {values} as not a fit.",
      watch_unmatched: "{value} couldn't be matched to the value cards, so it isn't in the score.",
      interview_questions: "Interview questions",
      reflection_title: "Reflection questions",
      reflection_help: "Ask the candidate to reflect on their own choices. Each question comes from their result.",
      reflect_top_pick_ranked: "You ranked {card} first. Tell me about a recent decision where it shaped what you did.",
      reflect_top_pick: "You chose {card}. Tell me about a recent decision where it shaped what you did.",
      reflect_not_a_fit: "{card} is one of the values you chose. What does it look like in your work, and when has it mattered most?",
      reflect_not_shared: "We care about {value}. When have you worked this way, and what made it easy or hard?",
      reflect_not_shared_desc: "We care about {value}: \"{description}\" When have you worked this way, and what made it easy or hard?",
      reflect_scenario: "In one scenario you chose the option that leans away from {card}. What would lead you to choose differently?",
      reflect_partly: "{value} matters here. How close is that to what {card} means to you?",
      reflect_partly_desc: "For us, {value} means \"{description}\" How close is that to what {card} means to you?",
      reflect_tension: "{card} and {value} can pull in different directions. How do you balance the two?",
      reflect_team_view: "Which of your values would your last team say shows most in your work? What would they point to?",
      // What the candidate sees on their own results: the same card, worded for them.
      respondent: {
        summary_shared: "You closely share {shared} of the company's {total} values.",
        factor_shared_all: "You share all {total} of the company's values",
        factor_shared: "You share {count} of the company's {total} values",
        factor_partly: "You partly share {count} more",
        factor_not_shared: "You didn't choose anything near {values}",
        summary_ceiling: "Six picks can't cover all {total} of the company's values, so the score is out of the best six picks can reach.",
        summary_not_scored: "None of the company's values could be scored from the value cards, so there's no score.",
        meet_title: "Where your values and the company's meet",
        pairs_help: "Each of the company's values next to your pick that comes closest to it.",
        pairs_help_ranked: "Each of the company's values next to your pick that comes closest to it. Numbers are your own order of importance.",
        map_title: "Your picks on the values map",
        map_help: "Cards that candidates often choose together sit side by side. Numbered dots mark the company's values on the card that expresses them. Point at a card, group or value for details.",
        map_aria: "The value cards in a ring, shaded by how close each is to your picks, with the company's values marked around the outside.",
        only_yours: "Only on the company's list",
        only_yours_sub: "Company values with no pick nearby",
        only_yours_empty: "Every company value has one of your picks near it.",
        common_ground_empty: "None of your picks is near the company's values.",
        only_theirs: "Only on yours",
        only_theirs_sub: "Your picks outside the company's list",
        only_theirs_empty: "All of your picks relate to the company's values.",
        closest_card: "Closest card is {card}, which you didn't pick",
        checked_in_scenarios: "No value card expresses this",
        not_near_yours: "Not near any of the company's values",
        legend_pick: "Your pick",
        legend_none: "Not near your picks",
        legend_picks_title: "Your picks",
        legend_pick_shared: "Shares one of the company's values",
        legend_pick_theirs: "Only yours",
        tip_pick: "Your pick",
        tip_pick_rank: "Your pick, number {rank}",
        tip_none: "Not near any of your picks",
        tip_your_value: "Company value here: {values}",
        tip_group_picks: "Your picks here: {picks}",
        tip_group_none: "None of your picks are in this group",
      },
    },
    verification_status: {
      incomplete_due_to_time: "Incomplete due to time",
      verified_in_scenarios: "Verified in scenarios",
      needs_discussion: "Needs discussion",
      incomplete: "Incomplete",
      verified: "Verified",
      review: "Review",
    },
    based_on_completed_sections:
      "Based on {completed} of {total} completed sections.",
    incomplete_excluded_from_score:
      "Incomplete and excluded from the Culture Profile score.",
    culture_profile_no_completed_sections:
      "No completed Culture Profile sections yet.",
    time_not_recorded: "Time not recorded",
    Pattern_Recognition: "Pattern Recognition",
    Logical_Reasoning: "Logical Reasoning",
    Data_Interpretation: "Data Interpretation",
    Problem_Resolving: "Problem Resolving",
    trend_analysis: "Trend Analysis",
    decision_making: "Decision Making",
    business_intelligence: "Business Intelligence",
    strategic_planning: "Strategic Planning",
    pattern_recognition_detail:
      "Ability to decipher and apply complex patterns, essential for recognizing trends, errors or anomalies in various data sets.",
    logical_reasoning_detail:
      "Ability to analyze scenarios and deduce logical outcomes, which is vital for diagnosing issues and making informed decisions in complex situations.",
    data_interpretation_detail:
      "Ability to interpret and draw conclusions from graphical data a skill crucial in many roles that require data analysis and strategic decision- making.",
    problem_pesolving_detail:
      "Ability to solve problems by applying logical reasoning Problem-solving skills are critical for efficiently tackling challenges and optimizing resources in the workplace.",
    A_logic_test_profile_for:
      "An overlay of candidate logic scores across four sections that test skills essential to solving problems and making effective decisions.",
    Overall: "Overall",
    Create: "Create",
    Compete: "Compete",
    Control: "Control",
    Collaborate: "Collaborate",
    people_oriented: "people-oriented",
    dynamic_entrepreneurial: "dynamic & entrepreneurial",
    results_oriented: "results-oriented",
    process_oriented: "process-oriented",
    Values: "Values",
    and_: " & ",
    Traits: "Traits",
    Culture_: "Culture",
    Profile_: "Profile",
    Acceptable_: "Acceptable",
    Behaviors_: "Behaviors",
    COPY_LINK: "COPY LINK",
    SEND_RESULTS_TO: "SEND RESULTS TO",
    RE_SEND_RESULTS_TO: "RE-SEND RESULTS TO",
    Completed_on: "Completed on",
    Score_Summary: "Score Summary",
    Score_Summary_empty_title: "See how your candidates compare",
    Score_Summary_empty_body:
      "When someone finishes the assessment, their overall score appears here so you can compare candidates at a glance.",
    Score_Summary_empty_cta: "Invite a candidate",
    Values_alignment: "Values alignment",
    Dominant_Characteristics: "Dominant Characteristics",
    Organizational_Glue: "Organizational Glue",
    Organizational_Leadership: "Organizational Leadership",
    Strategic_Emphases: "Strategic Emphases",
    Management_of_Employees: "Management of Employees",
    Criteria_of_Success: "Criteria of Success",
    Step_desc: `Allocate 100 points across four types based on the likeness to your organization, giving more points to the types most similiar.`,
    Written_Communication: "Written Communication",
    Empathy: "Empathy",
    Situational_Awareness: "Situational Awareness",
    Critical_Thinking: "Critical Thinking",
    importance: "importance",
    Scenario: "Scenario",
    selection_of_the_candidate_values:
      "This is the selection of the candidate's values, color-coded by level of importance based on the organization's values.",
    Our_values_guide_our:
      "Our values guide our natural tendencies and how we work, act, and make decisions.",
    This_is_the_selection:
      "This is the selection of the candidate's traits, color-coded by level of importance based on the organization's ideal traits.",
    Our_traits_guide_give:
      "Our traits guide and give us the ability to behave, act, and deliver on our values.",
    The_overall_overlap_between:
      "The overall overlap between the candidate's ideal work culture and your organization's work culture.",
    Hover_over_each_dimension: "Hover over each dimension to see",
    how_each_value_is: "how each value is expressed in this section",
    A_comparison_between_what:
      "A comparison between what the candidate and organization feel are acceptable behaviors or not. For any mismatched pair, we recommend having a conversation to clarify expectations.",
    The_candidate_primary_work_style:
      "This assessment reveals how the candidate naturally approaches work and collaboration. Understanding their work style helps predict job satisfaction, team dynamics, and optimal work environment setup. These insights should be used alongside other evaluation methods and should not be the sole basis for hiring decisions.",

    Work_Style__: "Work Style",
    Composition__: "Composition",
    Product: "Product",
    Doers_and_executors_They:
      "<strong>Doers and executors.</strong> They're driven by getting things done and delivering results. However, they often overlook details and people's sensitivities in their quest to accomplish work.",
    Process: "Process",
    Learners_and_thinkers_They:
      "<strong>Learners and thinkers.</strong> They are strongest in being analytical and thorough, knowing that success lies in the details. However, they often spend too much time perfecting work rather than getting things done in time or taking care of people.",
    People: "People",
    Relationship_builders_They:
      "<strong>Relationship builders.</strong> They understand people and know how to get the best out of them. However, they often spend too much time making others feel great rather than follow-up on details or getting work done.",

    // Enhanced Work Style Descriptions
    Product_Enhanced_Description:
      "<strong>Product-focused:</strong> Thrives on achieving tangible outcomes and delivering results. Excels in goal-oriented environments where they can see the direct impact of their work.",
    Product_Strengths:
      "• Results-driven and outcome-focused<br/>• Excellent at meeting deadlines and targets<br/>• Strong execution and delivery skills<br/>• Motivated by achievement and success metrics",
    Product_Considerations:
      "• May benefit from structured planning and process documentation<br/>• Could benefit from collaborative decision-making approaches<br/>• May need support in detailed analysis phases",
    Product_Ideal_Environment:
      "Best suited for roles with clear deliverables, measurable outcomes, and opportunities for independent execution.",

    Process_Enhanced_Description:
      "<strong>Process-focused:</strong> Values systematic approaches, quality, and thorough analysis. Excels in environments that reward precision, planning, and continuous improvement.",
    Process_Strengths:
      "• Exceptional attention to detail and quality<br/>• Strong analytical and problem-solving skills<br/>• Excellent at creating and following structured workflows<br/>• Natural tendency toward continuous improvement",
    Process_Considerations:
      "• May benefit from clear deadlines and milestone checkpoints<br/>• Could benefit from guidance on prioritizing speed vs. perfection<br/>• May need support in rapid decision-making situations",
    Process_Ideal_Environment:
      "Best suited for roles requiring analysis, quality control, system design, or process optimization.",

    People_Enhanced_Description:
      "<strong>People-focused:</strong> Prioritizes relationships, collaboration, and team harmony. Excels in environments that value communication, empathy, and collective success.",
    People_Strengths:
      "• Excellent communication and interpersonal skills<br/>• Natural ability to build relationships and trust<br/>• Strong emotional intelligence and empathy<br/>• Effective at conflict resolution and team building",
    People_Considerations:
      "• May benefit from support in data-driven decision making<br/>• Could benefit from clear performance metrics and deadlines<br/>• May need guidance on balancing relationship and task priorities",
    People_Ideal_Environment:
      "Best suited for roles in team leadership, client relations, HR, or collaborative project management.",

    // Hiring Manager Guidance
    Hiring_Manager_Insights: "What This Means for Hiring Managers",
    Product_Hiring_Guidance:
      "This candidate will excel in roles with clear targets and measurable outcomes. Consider them for positions in sales, project management, operations, or business development. They work well with structured timelines and benefit from process-oriented team members who can handle detailed planning.",
    Process_Hiring_Guidance:
      "This candidate will excel in roles requiring analysis, quality assurance, or system optimization. Consider them for positions in data analysis, quality control, compliance, research, or technical roles. They perform best with adequate time for thorough analysis and clear quality standards.",
    People_Hiring_Guidance:
      "This candidate will excel in roles requiring collaboration, communication, or relationship building. Consider them for positions in customer success, HR, team leadership, account management, or client relations. They thrive in collaborative environments with regular interpersonal interaction.",

    // Candidate Value
    Candidate_Development_Tips: "Development Opportunities",
    Product_Development:
      "To complement your execution strengths, consider developing skills in strategic planning, stakeholder management, and process documentation. Focus on building systematic approaches to planning and incorporating diverse perspectives in decision-making.",
    Process_Development:
      "To complement your analytical strengths, consider developing skills in rapid decision-making, agile methodologies, and stakeholder communication. Focus on balancing thoroughness with speed-to-market and improving presentation of complex findings.",
    People_Development:
      "To complement your relationship strengths, consider developing skills in data analysis, project management, and performance measurement. Focus on using metrics to guide decisions and managing task priorities alongside relationship building.",
    Select_a_dimension_to: "Select a dimension to learn more",
    Tap_on_a_row_in_the:
      "Tap on a row in the left panel to see the alignment between the company and respondent's preferences",
    Group_Results: "Group Results",
    Analytics: "Analytics",
    Legend: "Chart Legend",
    The_overlap_between_the__workplace:
      "The overlap between the candidate's ideal type of workplace and your organization's type of workplace.",
    A_human_skills_profile_for:
      "A human skills profile for each candidate based on written communication, empathy, situational awareness, and critical thinking",
    There_are_no_values_assigned:
      "There are no values assigned to this level of importance.",
    Progress: "Progress",
    Assessment_Results_for: "Assessment Results for",
    Human_: "Human",
    Skills_: "Skills",
    The_candidate_human_skills_are:
      "The candidate's human skills are evaluated based on how they responded to two open-ended questions. An evaluation of written communication, empathy, situational awareness, and critical thinking is provided, along with how core values are expressed (core values ratings do not factor into the overall score but are displayed for alignment purposes).",
    Completion_Time: "Completion Time",
    Values_of: "$1's Values",
    values_info: `Here's how well the candidate's personal values match your company's values. Green shows strong alignment, yellow shows some differences, and red indicates potential conflicts to discuss.`,
    Analysis: "What This Means",
    Strong_Alignment: "Strong match",
    Weaker_Alignment: "Some differences",
    Possible_Conflict: "Potential conflict",
    analysis_result: `This candidate's values align well with your company's most important values, especially in areas like adaptability, entrepreneurial spirit, excellence, and openness. This suggests they'll likely integrate well with your team and contribute positively to your culture. However, there's one area to discuss: the candidate highly values work-life balance, while your company doesn't prioritize this as much. We recommend having an open conversation about expectations and work culture to ensure both sides are aligned.`,
    Company_Values: `Here are your company's values organized by how important they are for day-to-day decisions and culture.`,
    legend_also_chosen_by: "Also chosen by $1",
    legend_not_chosen_by: "Not chosen by $1",
    Core_Values: "Our Core (Must-Have) Values",
    Core_Values_desc:
      "These values make your company unique and guide your most important decisions. Every team member should embrace these.",
    Permission_to_play_values: "Our Permission-to-Play (Expected) Values",
    Permission_to_play_values_desc:
      "These are basic professional values that everyone in your company should demonstrate. They're important but not unique to your organization.",
    Non_essential_values: "Our Non-essential Values (We Don't Prioritize)",
    Non_essential_values_desc:
      "These values aren't priorities at our company and don't guide our decisions or daily work. If these are important to you, you may find them unfulfilled here.",
    Non_essential_no_conflicts:
      "None of the candidate's chosen values conflict with your non-essential category.",
    // v3 Values Alignment
    v3_values_fit: "Values Fit",
    v3_values_fit_tooltip:
      "How strongly the selected values align with the company's priorities. Shared values create the baseline, core and permission-to-play values lift the score, and non-essential values reduce it.",
    v3_consistency: "Values Consistency",
    v3_consistency_tooltip:
      "How consistently the scenario responses reflect the values that were selected. This is a separate measure and does not affect the overall score.",
    v3_scenarios_aligned: "scenarios aligned with stated values",
    v3_alignment_breakdown: "Alignment Breakdown",
    v3_alignment_breakdown_desc:
      "How the selected values map to the company's value categories. Shared values contribute to baseline fit, strategic values increase it, and non-essential values lower it.",
    v3_matches: "matches",
    v3_match: "match",
    v3_conflicts: "conflicts",
    v3_conflict: "conflict",
    v3_core_explanation:
      "Core values define what makes this company unique. These create the strongest lift in the fit score.",
    v3_ptp_explanation:
      "Permission-to-play values are important baseline expectations. They raise the fit score, but less than core values.",
    v3_non_essential_explanation:
      "These are not priorities for this company. Selecting them may indicate different expectations about what matters day to day.",
    v3_non_essential_warning:
      "This candidate selected values the company has marked as non-essential. Consider discussing expectations around these areas in the interview.",
    v3_neutral: "Shared Values",
    v3_neutral_explanation:
      "These values are still shared with the company, but they are not top priorities. They contribute to baseline fit without adding as much lift as core or permission-to-play values.",
    v3_weight_label: "Score impact",
    v3_strongest_positive: "Highest weight",
    v3_moderate_positive: "Moderate weight",
    v3_negative_signal: "Reduces score",
    v3_zero_impact: "Baseline contribution",
    v3_score_note:
      "Shared values create the baseline score. Core and permission-to-play values increase it, while non-essential values lower it.",
    v3_what_this_means: "What This Means",
    v3_what_this_means_desc:
      "The Values Fit score starts from whether this person shares the company's values at all, then rises when they select more of the values the company prioritizes most. Core values create the strongest lift, permission-to-play values add a moderate lift, and non-essential selections reduce the score because they point to likely friction.",

    Acceptable_Behaviors_Info: `A comparison between what the candidate and organization feel are acceptable behaviors or not. For any mismatched pair, we recommend having a conversation to clarify expectations.`,

    Needs_Attention: "Needs Attention",
    Worth_Discussing: "Worth Discussing",
    Aligned: "Aligned",

    // Big Five Personality Assessment
    big_five_personality: "Big Five Personality",
    overall_big_five: "Overall Big Five",
    big_five_radar_title: "Personality Profile Overview",
    big_five_radar_subtitle:
      "A comprehensive view of the candidate's personality across five major dimensions",
    time_spent: "Time Spent",
    interpretation: "What This Means",
    facets: "Detailed Breakdown",

    // Big Five Dimensions
    big_five: {
      openness: "Openness",
      conscientiousness: "Conscientiousness",
      extraversion: "Extraversion",
      agreeableness: "Agreeableness",
      neuroticism: "Neuroticism",
      your_profile: "Your Profile",

      // Dimension Descriptions
      openness_description:
        "Reflects creativity, curiosity, and openness to new experiences and ideas",
      conscientiousness_description:
        "Indicates organization, responsibility, and goal-oriented behavior",
      extraversion_description:
        "Measures social energy, assertiveness, and comfort in social situations",
      agreeableness_description:
        "Shows cooperation, trust, and concern for others' well-being",
      neuroticism_description:
        "Reflects emotional stability and resilience under stress",

      // Facets
      facets: {
        // Openness facets
        ideas: "Abstract Thinking",
        fantasy: "Imagination",
        aesthetics: "Artistic Interest",
        actions: "Adventurousness",
        feelings: "Emotional Awareness",
        values: "Liberalism",

        // Conscientiousness facets
        competence: "Self-Efficacy",
        order: "Orderliness",
        dutifulness: "Dutifulness",
        achievement_striving: "Achievement Striving",
        self_discipline: "Self-Discipline",
        deliberation: "Cautiousness",

        // Extraversion facets
        warmth: "Friendliness",
        gregariousness: "Gregariousness",
        assertiveness: "Assertiveness",
        activity: "Activity Level",
        excitement_seeking: "Excitement Seeking",
        positive_emotions: "Cheerfulness",

        // Agreeableness facets
        trust: "Trust",
        straightforwardness: "Morality",
        altruism: "Altruism",
        compliance: "Cooperation",
        modesty: "Modesty",
        tender_mindedness: "Sympathy",

        // Neuroticism facets
        anxiety: "Anxiety",
        angry_hostility: "Anger",
        depression: "Depression",
        self_consciousness: "Self-Consciousness",
        impulsiveness: "Immoderation",
        vulnerability: "Vulnerability",
      },

      // Interpretations for different levels
      interpretations: {
        // Openness interpretations
        openness_high:
          "Shows strong creativity, intellectual curiosity, and openness to new experiences. Likely to embrace innovation and think outside the box.",
        openness_moderate:
          "Demonstrates balanced approach to new ideas and experiences. Open to change while maintaining practical considerations.",
        openness_low:
          "Prefers familiar approaches and established methods. Values stability and proven solutions over experimentation.",

        // Conscientiousness interpretations
        conscientiousness_high:
          "Highly organized, reliable, and goal-focused. Excellent at planning, following through, and maintaining high standards.",
        conscientiousness_moderate:
          "Shows good organizational skills and reliability. Balances structure with flexibility in approach to tasks.",
        conscientiousness_low:
          "More flexible and spontaneous in approach. May benefit from external structure and deadlines to maintain focus.",

        // Extraversion interpretations
        extraversion_high:
          "Energetic, outgoing, and comfortable in social situations. Thrives in collaborative environments and leadership roles.",
        extraversion_moderate:
          "Comfortable in both social and solitary situations. Can adapt communication style based on context and audience.",
        extraversion_low:
          "Prefers quieter, more focused work environments. Excels in independent work and one-on-one interactions.",

        // Agreeableness interpretations
        agreeableness_high:
          "Highly cooperative, empathetic, and team-oriented. Excellent at building relationships and resolving conflicts.",
        agreeableness_moderate:
          "Balances cooperation with healthy skepticism. Can work well with others while maintaining independent judgment.",
        agreeableness_low:
          "More competitive and direct in approach. Comfortable with challenging ideas and making tough decisions.",

        // Neuroticism interpretations
        neuroticism_high:
          "May experience stress more intensely but often demonstrates high emotional awareness. Benefits from supportive environments.",
        neuroticism_moderate:
          "Shows typical emotional responses to stress. Generally resilient with normal reactions to challenging situations.",
        neuroticism_low:
          "Highly emotionally stable and resilient. Maintains composure under pressure and recovers quickly from setbacks.",
      },

      // Percentile comparisons
      percentiles: {
        top5: "Top 5%",
        top10: "Top 10%",
        top25: "Top 25%",
        above_average: "Above average",
        average: "Average range",
        below_average: "Below average",
        bottom10: "Bottom 10%",
        comparison_note: "Compared to 307,000+ global professionals",
      },

      // UI Labels for components
      subtitle:
        "Understanding your core personality dimensions and how you naturally approach work, relationships, and challenges",
      your_workplace_archetype: "Your Workplace Archetype",
      team_collaboration_style: "Team Collaboration Style:",
      percentile_suffix: "th percentile",

      // Dimension levels
      levels: {
        very_high: "VERY HIGH",
        moderate: "MODERATE",
        very_low: "VERY LOW",
        high: "High",
        average: "Average",
        low: "Low",
      },

      // Percentile descriptions for each dimension (shortened for display purposes)
      descriptions: {
        openness: {
          very_high: "You are highly creative and enjoy novelty.",
          high: "You are more open to new experiences than most people.",
          average: "You have a balanced approach to new things and creativity.",
          low: "You prefer familiar and stable methods.",
          very_low: "You prefer tradition and routine.",
        },
        conscientiousness: {
          very_high: "You are highly organized and disciplined.",
          high: "You are more organized than most people.",
          average: "You have a balanced approach to organization.",
          low: "You prefer flexibility in how you work.",
          very_low: "You prefer high flexibility and dislike strict rules.",
        },
        extraversion: {
          very_high: "You are highly sociable and energetic.",
          high: "You are more sociable than most people.",
          average: "You have a balanced approach to social interaction.",
          low: "You are somewhat reserved and prefer quiet settings.",
          very_low: "You prefer solitude and avoid social interaction.",
        },
        agreeableness: {
          very_high: "You are highly cooperative and considerate of others.",
          high: "You are more cooperative than most people.",
          average: "You balance cooperation with competitiveness.",
          low: "You tend to be competitive and cautious.",
          very_low: "You enjoy competition and prefer direct interactions.",
        },
        neuroticism: {
          very_high: "You are emotionally volatile and prone to stress.",
          high: "You experience stronger emotions than most people.",
          average: "You have a normal range of emotional responses.",
          low: "You tend to be calm and composed.",
          very_low: "You are very emotionally stable and rarely stressed.",
        },
      },

      // Archetype specific translations
      archetypes: {
        strategic_innovator: {
          name: "Strategic Innovator",
          description:
            "Combines visionary thinking with practical execution. Excels at identifying opportunities and developing innovative solutions to complex challenges.",
          strengths: [
            "Forward-thinking and strategic planning",
            "Creative problem-solving abilities",
            "Strong execution and follow-through",
            "Adaptable to changing environments",
          ],
          roles: [
            "Strategy Lead",
            "Innovation Manager",
            "Product Director",
            "Consultant",
          ],
          collaboration:
            "Works best when given autonomy to explore new ideas while maintaining regular check-ins with stakeholders.",
          complementary: ["steady_executor", "diplomatic_coordinator"],
        },
        collaborative_leader: {
          name: "Collaborative Leader",
          description:
            "Natural team builder who excels at bringing people together and driving collective success through strong interpersonal skills.",
          strengths: [
            "Exceptional team leadership",
            "Strong communication skills",
            "Builds trust and rapport easily",
            "Motivates and inspires others",
          ],
          roles: ["Team Lead", "Project Manager", "HR Director", "Coach"],
          collaboration:
            "Thrives in team environments and excels at facilitating collaboration between different personalities and working styles.",
          complementary: ["analytical_thinker", "detail_specialist"],
        },
        analytical_thinker: {
          name: "Analytical Thinker",
          description:
            "Deep thinker who excels at complex analysis and systematic problem-solving. Values precision and evidence-based decision making.",
          strengths: [
            "Exceptional analytical abilities",
            "Methodical approach to problems",
            "High attention to detail",
            "Evidence-based decision making",
          ],
          roles: [
            "Data Analyst",
            "Research Lead",
            "Quality Assurance",
            "Consultant",
          ],
          collaboration:
            "Works best with clear objectives and appreciates thorough preparation. Values quality over speed.",
          complementary: ["creative_catalyst", "collaborative_leader"],
        },
        steady_executor: {
          name: "Steady Executor",
          description:
            "Reliable and consistent performer who excels at delivering high-quality results. Maintains composure under pressure.",
          strengths: [
            "Consistent high-quality delivery",
            "Excellent under pressure",
            "Strong organizational skills",
            "Dependable and reliable",
          ],
          roles: [
            "Operations Manager",
            "Account Manager",
            "Administrator",
            "Coordinator",
          ],
          collaboration:
            "Provides stability to teams and can be counted on to deliver consistently. Works well with clear expectations.",
          complementary: ["strategic_innovator", "creative_catalyst"],
        },
        creative_catalyst: {
          name: "Creative Catalyst",
          description:
            "Energetic innovator who brings fresh perspectives and creative solutions. Excels at inspiring others and driving change.",
          strengths: [
            "High creativity and innovation",
            "Energetic and motivating presence",
            "Adaptable and flexible approach",
            "Strong interpersonal skills",
          ],
          roles: [
            "Creative Director",
            "Marketing Lead",
            "Facilitator",
            "Change Agent",
          ],
          collaboration:
            "Energizes teams and brings creative solutions to challenges. Works best in dynamic, collaborative environments.",
          complementary: ["analytical_thinker", "steady_executor"],
        },
        diplomatic_coordinator: {
          name: "Diplomatic Coordinator",
          description:
            "Skilled at building consensus and managing relationships. Excels at coordinating complex projects involving multiple stakeholders.",
          strengths: [
            "Excellent relationship management",
            "Strong coordination abilities",
            "Diplomatic conflict resolution",
            "Reliable project delivery",
          ],
          roles: [
            "Program Manager",
            "Client Relations",
            "Coordinator",
            "Mediator",
          ],
          collaboration:
            "Excels at managing diverse teams and stakeholder relationships. Natural bridge-builder between different groups.",
          complementary: ["strategic_innovator", "analytical_thinker"],
        },
        adaptive_problem_solver: {
          name: "Adaptive Problem Solver",
          description:
            "Flexible and resilient professional who thrives in changing environments. Excels at finding creative solutions under pressure.",
          strengths: [
            "Highly adaptable to change",
            "Creative problem-solving",
            "Resilient under pressure",
            "Open to new approaches",
          ],
          roles: [
            "Consultant",
            "Troubleshooter",
            "Agile Lead",
            "Crisis Manager",
          ],
          collaboration:
            "Brings stability and creative solutions during challenging times. Works well across different team structures.",
          complementary: ["steady_executor", "collaborative_leader"],
        },
        detail_specialist: {
          name: "Detail Specialist",
          description:
            "Meticulous professional who excels at precision work and quality control. Values accuracy and systematic approaches.",
          strengths: [
            "Exceptional attention to detail",
            "High-quality work standards",
            "Systematic and methodical",
            "Strong focus and concentration",
          ],
          roles: [
            "Quality Analyst",
            "Compliance Officer",
            "Technical Writer",
            "Auditor",
          ],
          collaboration:
            "Provides critical quality control and detailed analysis. Works best with clear processes and standards.",
          complementary: ["collaborative_leader", "creative_catalyst"],
        },

        // New Archetypes - Tier 2: Leadership & Vision
        visionary_leader: {
          name: "Visionary Leader",
          description:
            "Combines innovative thinking with social confidence to inspire teams toward exceptional achievements. Excels at painting compelling pictures of the future.",
          collaboration:
            "Leads through inspiration and big-picture thinking, energizing teams to pursue challenging goals and new approaches.",
        },
        operational_manager: {
          name: "Operational Manager",
          description:
            "Process-focused leader who excels at organizing teams and optimizing workflows. Strong at implementing proven systems and maintaining standards.",
          collaboration:
            "Leads through clear structure and processes, ensuring team alignment and efficient execution of defined objectives.",
        },
        resilient_commander: {
          name: "Resilient Commander",
          description:
            "Decisive leader who makes tough decisions under pressure. Combines high standards with emotional flexibility to drive results through challenges.",
          collaboration:
            "Leads through clear direction and high expectations, comfortable making unpopular but necessary decisions for team success.",
        },

        // New Archetypes - Tier 3: Team & Collaboration
        team_builder: {
          name: "Team Builder",
          description:
            "Natural connector who excels at bringing people together and fostering positive team dynamics. Creates inclusive environments where everyone contributes.",
          collaboration:
            "Bridges gaps between team members, facilitates open communication, and ensures everyone feels heard and valued.",
        },
        empathetic_innovator: {
          name: "Empathetic Innovator",
          description:
            "Human-centered problem solver who creates innovative solutions with deep consideration for user needs and impact on others.",
          collaboration:
            "Brings creativity while ensuring solutions serve everyone's best interests, excels at inclusive innovation.",
        },
        supportive_stabilizer: {
          name: "Supportive Stabilizer",
          description:
            "Reliable team supporter who provides consistency and emotional stability. Excels at maintaining team morale and supporting proven methods.",
          collaboration:
            "Provides steady support to teammates, offers encouragement during challenges, and helps maintain team cohesion.",
        },

        // New Archetypes - Tier 4: Independent & Specialized
        independent_specialist: {
          name: "Independent Specialist",
          description:
            "Self-directed expert who thrives working autonomously on complex problems. Combines deep expertise with innovative approaches to specialized challenges.",
          collaboration:
            "Works best with minimal oversight, contributes through expert knowledge and ability to solve problems independently.",
        },
        technical_expert: {
          name: "Technical Expert",
          description:
            "Precision-focused individual contributor who excels at detailed technical work. Masters complex systems and maintains high quality standards.",
          collaboration:
            "Contributes through technical excellence and systematic approaches, prefers clear requirements and minimal ambiguity.",
        },
        creative_maverick: {
          name: "Creative Maverick",
          description:
            "Unconventional thinker who generates breakthrough ideas through unique perspectives. Thrives on creative freedom and novel approaches.",
          collaboration:
            "Best utilized for brainstorming and creative problem-solving, brings fresh perspectives that challenge conventional thinking.",
        },

        // New Archetypes - Tier 5: Performance & Competition
        competitive_driver: {
          name: "Competitive Driver",
          description:
            "Results-focused performer who thrives in competitive environments. Combines high energy with direct communication to achieve ambitious goals.",
          collaboration:
            "Drives team performance through competitive spirit and direct feedback, excels in high-stakes, goal-oriented environments.",
        },
        ambitious_achiever: {
          name: "Ambitious Achiever",
          description:
            "High-energy goal pursuer who channels intensity into exceptional performance. Thrives on challenging targets and fast-paced execution.",
          collaboration:
            "Motivates teams through enthusiasm and drive, performs best in fast-paced environments with clear success metrics.",
        },
        flexible_performer: {
          name: "Flexible Performer",
          description:
            "Adaptable relationship-focused worker who excels in changing environments. Balances social connection with emotional flexibility.",
          collaboration:
            "Adapts collaboration style to team needs, builds relationships while maintaining performance under changing conditions.",
        },
      },
      // Big Five results page (v3): trait profile, facets and archetype card.
      results_v3: {
        chip_hint: "Show this trait in the profile",
        summary_balanced: "Close to the middle on all five traits.",
        list_and: "and",
        profile_title: "Trait profile",
        profile_help: "Each trait compared with a large reference group. Neither end of a trait is better. Select a trait to see its six facets.",
        percentile_caption: "Percentile",
        middle_line: "About the same as most people",
        lower_than_most: "Lower than most",
        typical_range: "Typical range",
        higher_than_most: "Higher than most",
        likely_range: "likely {low} to {high}",
        legend_higher: "Higher than most",
        legend_lower: "Lower than most",
        legend_leaning: "Leaning higher or lower",
        legend_typical: "Typical",
        legend_range: "Likely range, from measurement error",
        select_trait: "Select a trait to see its six facets",
        archetype_tag: "Archetype",
        inside_trait: "Inside this trait",
        facet_above: "{facet} sits well above this trait overall.",
        facet_below: "{facet} sits well below this trait overall.",
        facet_none: "No facet stands far from this trait overall.",
        facet_help: "Facets are percentiles, like the trait. At most two are highlighted, and only when they sit 35 or more points from the trait, because facet scores are less precise. Emotional awareness and Liberalism are never highlighted.",
        facet_trait_mark: "This trait's percentile",
        not_highlighted: "not highlighted",
        bands: {
          high: "High",
          above_average: "Above average",
          average: "Average",
          below_average: "Below average",
          low: "Low",
        },
        traits: {
          openness: { name: "Openness", low: "Prefers the familiar", high: "Seeks new ideas", more: "More open to new ideas than {n} in 100 people", less: "Prefers the familiar more than {n} in 100 people" },
          conscientiousness: { name: "Conscientiousness", low: "Flexible, spontaneous", high: "Organised, disciplined", more: "More organised than {n} in 100 people", less: "More flexible than {n} in 100 people" },
          extraversion: { name: "Extraversion", low: "Reserved, reflective", high: "Outgoing, energetic", more: "More outgoing than {n} in 100 people", less: "More reserved than {n} in 100 people" },
          agreeableness: { name: "Agreeableness", low: "Direct, challenging", high: "Warm, cooperative", more: "More cooperative than {n} in 100 people", less: "More direct than {n} in 100 people" },
          neuroticism: { name: "Stress response", sub: "Neuroticism", low: "Calm under pressure", high: "Feels pressure more", more: "Feels pressure more than {n} in 100 people", less: "Calmer under pressure than {n} in 100 people" },
        },
        poles: {
          openness_high: "Curious",
          openness_low: "Practical",
          conscientiousness_high: "Organised",
          conscientiousness_low: "Flexible",
          extraversion_high: "Outgoing",
          extraversion_low: "Reserved",
          agreeableness_high: "Cooperative",
          agreeableness_low: "Direct",
          neuroticism_high: "Feels pressure",
          neuroticism_low: "Calm",
        },
        // Headline sentence: five tiers per trait (15th or below, 16th-35th,
        // 36th-64th, 65th-84th, 85th or above). "middle" fills "About as {list}
        // as most people."
        tiers: {
          openness: { very_low: "very practical", low: "practical", middle: "curious", high: "curious", very_high: "very curious" },
          conscientiousness: { very_low: "very flexible", low: "flexible", middle: "organised", high: "organised", very_high: "very organised" },
          extraversion: { very_low: "very reserved", low: "reserved", middle: "outgoing", high: "outgoing", very_high: "very outgoing" },
          agreeableness: { very_low: "very direct", low: "direct", middle: "cooperative", high: "cooperative", very_high: "very cooperative" },
          neuroticism: { very_low: "very calm under pressure", low: "calm under pressure", middle: "steady under pressure", high: "quick to feel pressure", very_high: "very quick to feel pressure" },
        },
        sentence_middle: "About as {list} as most people.",
        why_fits_leaning: "Only {trait} stands out. The name pairs it with the next strongest trait, which is still in the typical range, so read that half as a light lean.",
        third_title: "Third trait",
        // A blend: four traits stand out about equally, so two archetypes share the card.
        blend_label: "A blend of two archetypes",
        blend_names: "{first} and {second}",
        blend_title: "A blend of {first} and {second}",
        blend_body: "These traits stand out about equally, so both archetypes apply.",
        blend_covers: "{name}: {traits}",
        third_body: "Stands out too. It doesn't change the name, but adds the lines marked below.",
        third_tag: "Third trait: {trait}",
        // The third trait that stands out adds one strength, one watch-out and
        // one interview question to any archetype.
        third: {
          openness_high: { strength: "Brings fresh ideas and questions the usual way of doing things", watch: "May lose interest in routine work once it is set up", question: "Tell me about an idea you brought to a team that changed how something was done.", listen_for: "an idea that was actually used, not just suggested." },
          openness_low: { strength: "Keeps ideas grounded in what works", watch: "May be slow to try untested approaches", question: "Tell me about a new way of working you weren't sure about at first. How did it go?", listen_for: "how they adapted, and what they learned." },
          conscientiousness_high: { strength: "Follows through and keeps work in order", watch: "Can be hard on themselves and others when standards slip", question: "How do you keep track of several commitments at once?", listen_for: "a system they actually use." },
          conscientiousness_low: { strength: "Adapts quickly when plans change", watch: "Details and deadlines can slip", question: "Tell me about a deadline that slipped. What happened?", listen_for: "ownership, and a change in habit." },
          extraversion_high: { strength: "Brings energy to a group and speaks up easily", watch: "May fill silences others would use to think", question: "Tell me about a time you made room for quieter people in a discussion.", listen_for: "noticing others and making space for them." },
          extraversion_low: { strength: "Works well alone and thinks before speaking", watch: "May not share ideas unless asked", question: "How do you make sure your ideas are heard in a busy meeting?", listen_for: "a way of contributing that works for them." },
          agreeableness_high: { strength: "Easy to work with and quick to help", watch: "May say yes to too much", question: "Tell me about a time you turned down a request from a colleague.", listen_for: "a clear no, said kindly." },
          agreeableness_low: { strength: "Says what they think and challenges weak ideas", watch: "Can come across as blunt", question: "Tell me about feedback you gave that was hard to hear.", listen_for: "honesty, with care for how it landed." },
          neuroticism_low: { strength: "Stays steady when things go wrong", watch: "May underplay how stressful something is for others", question: "Tell me about a time a colleague was more stressed than you about the same problem.", listen_for: "noticing and responding to how others feel." },
          neuroticism_high: { strength: "Notices risks and takes problems seriously", watch: "Long stretches of pressure can wear them down", question: "What helps you do your best work during a stressful period?", listen_for: "practical habits, and knowing when to ask for support." },
        },
        // One facet note at most: a facet on the other side of the middle
        // from its trait. <facet>_high is used when the trait is low overall,
        // <facet>_low when it is high.
        facet_note_title: "Inside {trait}",
        facet_note_value: "{facet}, {n} percentile",
        facet_note_link: "See all six facets",
        // Results report (v3)
        report_leaning: "The second trait is still in the typical range, so read that half as a light lean.",
        report_also_close_for: "{name}, for {traits}",
        facet_notes: {
          ideas_high: "Mostly practical, but enjoys working through abstract ideas and complex problems.",
          ideas_low: "Curious in many ways, but prefers concrete problems to abstract theory.",
          fantasy_high: "Mostly practical, but has a lively imagination.",
          fantasy_low: "Curious in many ways, but keeps their thinking grounded in reality.",
          aesthetics_high: "Mostly practical, but cares about design, art and how things look.",
          aesthetics_low: "Curious in many ways, but less drawn to art and design than most.",
          actions_high: "Mostly practical, but enjoys variety and trying new activities.",
          actions_low: "Curious about ideas, but prefers familiar routines day to day.",
          competence_high: "Flexible about structure, but confident they can get things done.",
          competence_low: "Organised and dependable, but less sure of their own ability than most.",
          order_high: "Flexible overall, but likes their work and workspace in order.",
          order_low: "Disciplined overall, but relaxed about tidiness and order.",
          dutifulness_high: "Flexible overall, but takes promises and rules seriously.",
          dutifulness_low: "Organised overall, but relaxed about rules they don't see the point of.",
          achievement_striving_high: "Flexible overall, but ambitious and driven to achieve.",
          achievement_striving_low: "Organised overall, but not especially driven by ambition.",
          self_discipline_high: "Flexible overall, but gets on with tasks without putting them off.",
          self_discipline_low: "Organised overall, but can put off tasks they don't enjoy.",
          deliberation_high: "Flexible overall, but thinks carefully before making decisions.",
          deliberation_low: "Organised overall, but makes decisions quickly.",
          warmth_high: "Reserved overall, but friendly and warm one to one.",
          warmth_low: "Outgoing overall, but takes time to warm up to people.",
          gregariousness_high: "Reserved overall, but enjoys being part of a big group.",
          gregariousness_low: "Outgoing overall, but prefers small groups to big crowds.",
          assertiveness_high: "Reserved in social settings, but speaks up and takes charge when it matters.",
          assertiveness_low: "Outgoing overall, but happy to let others take the lead.",
          activity_high: "Reserved overall, but likes a fast pace and a busy day.",
          activity_low: "Outgoing overall, but prefers a relaxed pace.",
          excitement_seeking_high: "Reserved overall, but enjoys excitement and new experiences.",
          excitement_seeking_low: "Outgoing overall, but avoids noisy, high-thrill settings.",
          positive_emotions_high: "Reserved overall, but cheerful and upbeat.",
          positive_emotions_low: "Outgoing overall, but less openly cheerful than most.",
          trust_high: "Direct overall, but trusts that others mean well.",
          trust_low: "Cooperative overall, but slow to trust others' motives.",
          straightforwardness_high: "Direct overall, but plays straight and avoids manipulating others.",
          straightforwardness_low: "Cooperative overall, but comfortable using tact or strategy to get their way.",
          altruism_high: "Direct overall, but enjoys helping others.",
          altruism_low: "Cooperative overall, but focuses on their own work more than helping others.",
          compliance_high: "Direct overall, but avoids confrontation and prefers to compromise.",
          compliance_low: "Cooperative overall, but will stand their ground in a conflict.",
          modesty_high: "Direct overall, but modest about their own achievements.",
          modesty_low: "Cooperative overall, but confident about their abilities and happy to say so.",
          tender_mindedness_high: "Direct overall, but moved by other people's difficulties.",
          tender_mindedness_low: "Cooperative overall, but takes a tough-minded view of others' problems.",
          anxiety_high: "Calm overall, but can worry about what might go wrong.",
          anxiety_low: "Feels pressure more than most, but is not a worrier.",
          angry_hostility_high: "Calm overall, but can be quick to frustration.",
          angry_hostility_low: "Feels pressure more than most, but rarely gets angry.",
          self_consciousness_high: "Calm overall, but can feel self-conscious in front of others.",
          self_consciousness_low: "Feels pressure more than most, but is comfortable in front of others.",
          impulsiveness_high: "Calm overall, but can find temptations hard to resist.",
          impulsiveness_low: "Feels pressure more than most, but resists urges and temptations easily.",
          vulnerability_high: "Calm overall, but can feel overwhelmed in a crisis.",
          vulnerability_low: "Feels pressure more than most, but copes well in a crisis.",
        },
        archetype_label: "Workplace archetype",
        hero_note: "A short name for the trait profile below, not a fixed type. Use it to start a conversation, not to make the decision.",
        about_archetype: "About this archetype",
        about_blend: "About these archetypes",
        details_link: "Strengths, watch-outs and interview questions",
        details_link_respondent: "Strengths and how this archetype works best",
        why_fits: "Why this fits",
        why_fits_two: "Named for the two traits that stand out most.",
        also_close_title: "Also close",
        also_close_covers: "Covers {trait}, which stands out almost as much.",
        also_close_balanced: "Only one trait stands out, and only just, so this profile is close to balanced.",
        clear_match: "The traits behind this archetype stand out clearly, so small score changes are unlikely to move it.",
        leaning_match: "The traits behind this archetype only lean one way, so treat it as a light summary.",
        balanced_leans: "Closest to standing out, still in the typical range",
        strengths: "Strengths at work",
        watch_for: "Watch for",
        works_best_when: "Works best when",
        collaboration: "Team collaboration style",
        interview: "Questions to ask in the interview",
        interview_hint: "Based on this archetype's watch-outs. Only your hiring team sees these.",
        more_question: "Show 1 more question",
        more_questions: "Show {n} more questions",
        fewer_questions: "Show fewer questions",
        listen_for: "Listen for: {text}",
      },

      // Workplace archetypes v4: 40 archetypes, one for each exact pair of the
      // two traits that stand out most. Logic in src/utils/bigFiveArchetypes.ts.
      archetypes_v3: {
        improviser: {
          name: "Improviser",
          tagline: "Tries new ideas and adapts on the fly.",
          description: "Curious, inventive and comfortable working things out as they go. Most useful where new problems come up often and speed matters more than a perfect process.",
          collaboration: "Brings fresh ideas and a willingness to try them. Pair with someone organised who enjoys tracking details and follow-up.",
          strengths: {
            1: "Adjusts quickly when priorities shift",
            2: "Tries new approaches instead of waiting for a perfect plan",
            3: "Finds workable fixes under time pressure",
          },
          watch_for: {
            1: "Routine tasks and paperwork can slip",
            2: "May commit before thinking through the details",
            3: "Can leave work unfinished when something new comes up",
          },
          works_best_when: {
            1: "Priorities move and quick calls are needed",
            2: "Someone else owns the detailed process",
            3: "Deadlines are clear, even if the path is not",
          },
          interview: {
            q1: "Tell me about a piece of routine work you were responsible for over several months. How did you make sure it got done?",
            q1_listen_for: "a system they actually used, not just good intentions.",
            q2: "Describe a time a quick decision you made turned out to be wrong. What happened next?",
            q2_listen_for: "how fast they noticed, and what they changed.",
            q3: "How do you keep track of commitments when several things change in the same week?",
            q3_listen_for: "a concrete method, such as a list, a tool or regular check-ins.",
          },
        },
        candid_challenger: {
          name: "Candid Challenger",
          tagline: "Questions ideas hard and brings better ones.",
          description: "Curious, independent and comfortable disagreeing out loud. Most useful where ideas and decisions need honest scrutiny and a fresh alternative.",
          collaboration: "Keeps a team honest by questioning weak ideas and naming risks. Pair with someone warm who can help turn a challenge into agreement.",
          strengths: {
            1: "Raises problems early instead of letting them grow",
            2: "Tests plans and assumptions with real rigour",
            3: "Offers a different idea, not just a criticism",
          },
          watch_for: {
            1: "Can come across as blunt or dismissive",
            2: "May argue a point longer than it deserves",
            3: "Can underestimate how feedback lands on others",
          },
          works_best_when: {
            1: "Challenge is welcome and expected",
            2: "Decisions are judged on evidence",
            3: "The team is confident enough to push back",
          },
          interview: {
            q1: "Tell me about a time you disagreed with a decision that went ahead anyway. What did you do next?",
            q1_listen_for: "commitment to the decision once it was made.",
            q2: "Describe feedback you gave that did not land well. What would you do differently?",
            q2_listen_for: "awareness of the other person's view, not just being right.",
            q3: "When have you changed your mind because someone challenged you?",
            q3_listen_for: "a real example, and openness to being wrong.",
          },
        },
        steady_supporter: {
          name: "Steady Supporter",
          tagline: "The dependable person others lean on.",
          description: "Patient, helpful and calm when things get tense. Most useful where trust, care and a stable team matter.",
          collaboration: "A reliable presence who makes others feel supported. Encourage them to share their view early, and check their workload often.",
          strengths: {
            1: "Builds trust with colleagues and customers",
            2: "Helps others without being asked",
            3: "Keeps the mood steady when things get tense",
          },
          watch_for: {
            1: "Avoids conflict even when it needs to happen",
            2: "Says yes to too much and quietly overloads",
            3: "May hold back their own view to keep the peace",
          },
          works_best_when: {
            1: "Teamwork and service are valued",
            2: "Expectations and priorities are clear",
            3: "Their contribution is noticed and thanked",
          },
          interview: {
            q1: "Tell me about a time you had to tell a colleague something they did not want to hear.",
            q1_listen_for: "that they said it clearly, not only kindly.",
            q2: "Describe a period when you took on too much. How did you notice, and what did you do?",
            q2_listen_for: "saying no or asking for help before it went wrong.",
            q3: "When did you disagree with your team but go along with them anyway? Looking back, was that right?",
            q3_listen_for: "judgement about when to speak up.",
          },
        },
        pace_setter: {
          name: "Pace Setter",
          tagline: "Sets a fast pace and holds a high bar.",
          description: "Energetic, results-focused and comfortable taking charge. Most useful where goals are clear and momentum matters.",
          collaboration: "Brings drive and focus, and lifts the pace of those around them. Pair with someone who notices how the team is coping and says so.",
          strengths: {
            1: "Drives work forward and keeps others moving",
            2: "Sets clear, high standards",
            3: "Makes decisions quickly and owns them",
          },
          watch_for: {
            1: "Can push past people to hit a target",
            2: "May treat disagreement as delay",
            3: "Can expect others to match their pace without asking",
          },
          works_best_when: {
            1: "Goals and success measures are clear",
            2: "They have real ownership of results",
            3: "The team responds well to direct feedback",
          },
          interview: {
            q1: "Tell me about a goal you hit where the team found the pace hard. What did you learn?",
            q1_listen_for: "noticing the cost to people, not just the result.",
            q2: "Describe a time someone slowed you down with a concern that turned out to be right.",
            q2_listen_for: "listening, even under time pressure.",
            q3: "How do you set expectations with people who work at a different pace from you?",
            q3_listen_for: "adjusting their approach, not simply pushing harder.",
          },
        },
        vigilant_planner: {
          name: "Vigilant Planner",
          tagline: "Sticks with what works and spots what could go wrong.",
          description: "Practical, cautious and alert to risks, with a preference for proven ways of working. Most useful where mistakes are costly and reliability matters more than novelty.",
          collaboration: "Protects the team from avoidable mistakes by raising risks others miss. Give clear priorities and early notice of change, and check in during busy periods.",
          strengths: {
            1: "Thinks ahead and prepares for problems",
            2: "Prefers proven methods that keep risk low",
            3: "Takes responsibility seriously",
          },
          watch_for: {
            1: "Stress can build during long periods of pressure",
            2: "Sudden or untested changes can be unsettling",
            3: "Can focus on risks more than opportunities",
          },
          works_best_when: {
            1: "Methods are proven and risks are taken seriously",
            2: "Plans are shared early, with time to prepare",
            3: "Workload is steady rather than constant firefighting",
          },
          interview: {
            q1: "Tell me about a risk you raised that others had missed. How did you get it taken seriously?",
            q1_listen_for: "raising it in a way people could act on.",
            q2: "Describe a stressful period at work. What helped you keep going?",
            q2_listen_for: "practical ways of managing pressure, and knowing when to ask for help.",
            q3: "When did you have to ship something before you felt it was ready?",
            q3_listen_for: "judging when good enough is the right call.",
          },
        },
        independent_thinker: {
          name: "Independent Thinker",
          tagline: "Thinks deeply and works best with room to focus.",
          description: "Reflective and self-directed, with their own view on how things should be done. Most useful for complex problems that need sustained focus.",
          collaboration: "Adds depth and independent judgement, especially on complex work. Agree simple check-ins so others know where their work stands.",
          strengths: {
            1: "Works through hard problems without close supervision",
            2: "Brings original, well-thought-out views",
            3: "Stays focused for long stretches",
          },
          watch_for: {
            1: "May keep progress and problems to themselves",
            2: "Can drift from team plans and rhythms",
            3: "May be slow to ask others for input",
          },
          works_best_when: {
            1: "There is time for deep, uninterrupted work",
            2: "Goals are clear but the approach is theirs",
            3: "Meetings are few and worth attending",
          },
          interview: {
            q1: "Tell me about a problem you solved mostly on your own. How did you keep others informed?",
            q1_listen_for: "sharing progress without being asked.",
            q2: "Describe a time you would have done better by asking for help sooner.",
            q2_listen_for: "honesty, and a change in habit afterwards.",
            q3: "How do you handle a team decision you think is wrong?",
            q3_listen_for: "raising it openly, then working with the outcome.",
          },
        },
        practical_operator: {
          name: "Practical Operator",
          tagline: "Makes proven methods run well.",
          description: "Grounded, sensible and focused on what works. Most useful for running and improving established processes.",
          collaboration: "Turns plans into routines that actually work. Pair with someone who brings fresh ideas, and make a practical case for any change.",
          strengths: {
            1: "Keeps day-to-day operations running smoothly",
            2: "Focuses on practical, workable solutions",
            3: "Brings consistency and clear standards",
          },
          watch_for: {
            1: "Can resist changes that are not yet proven",
            2: "May dismiss new ideas too quickly",
            3: "Can stick with the familiar way when a new one would be better",
          },
          works_best_when: {
            1: "Processes are clear and results are measurable",
            2: "Changes come with a clear reason",
            3: "Improvement is steady, not constant reinvention",
          },
          interview: {
            q1: "Tell me about a new way of working you were sceptical of. What changed your mind, or didn't?",
            q1_listen_for: "judging change on evidence rather than habit.",
            q2: "Describe a process you improved. How did you decide what to change?",
            q2_listen_for: "a clear problem, a practical fix and a result.",
            q3: "When did you have to work on something with no proven method to follow?",
            q3_listen_for: "how they coped without a playbook.",
          },
        },
        connector: {
          name: "Connector",
          tagline: "Builds relationships and brings people in.",
          description: "Sociable, warm and energised by people. Most useful where relationships inside or outside the team drive results.",
          collaboration: "Energises a team and keeps people connected and informed. Pair with someone who protects focus time and keeps an eye on detail.",
          strengths: {
            1: "Builds rapport quickly with new people",
            2: "Brings people together and makes them feel included",
            3: "Keeps communication flowing across groups",
          },
          watch_for: {
            1: "Can spread their time too thin across people",
            2: "May avoid the unpopular part of a decision",
            3: "Focused solo work can slip",
          },
          works_best_when: {
            1: "The role involves a lot of contact with people",
            2: "Relationships are part of how success is measured",
            3: "There is some structure for focused work",
          },
          interview: {
            q1: "Tell me about a working relationship that was hard to build. What did you do?",
            q1_listen_for: "patience and effort, not just charm.",
            q2: "Describe a time you had to give an unpopular message to people you get on well with.",
            q2_listen_for: "clarity, even at some cost to the relationship.",
            q3: "How do you protect time for work that needs you alone and focused?",
            q3_listen_for: "a real habit, not just an intention.",
          },
        },
        composed_problem_solver: {
          name: "Composed Problem Solver",
          tagline: "Stays level-headed and finds a way through.",
          description: "Calm under pressure and curious about new ways to solve a problem. Most useful in roles with uncertainty, escalations or problems nobody has solved before.",
          collaboration: "A steadying presence who helps the team think clearly when pressure rises. Make urgency explicit, since they may not feel it the way others do.",
          strengths: {
            1: "Thinks clearly in a crisis",
            2: "Steadies others when stress is high",
            3: "Looks for new angles when the usual fix fails",
          },
          watch_for: {
            1: "Can underplay how urgent something is",
            2: "May not show the concern others need to see",
            3: "Their calm can be read as not caring",
          },
          works_best_when: {
            1: "Problems are complex or unpredictable",
            2: "They are trusted to handle difficult situations",
            3: "Urgency is agreed openly",
          },
          interview: {
            q1: "Tell me about the most stressful situation you have handled at work. Walk me through it.",
            q1_listen_for: "a clear process, not just staying calm.",
            q2: "Describe a time someone thought you were not taking a problem seriously enough.",
            q2_listen_for: "awareness of how their calm comes across.",
            q3: "How do you decide what is urgent when everything feels urgent?",
            q3_listen_for: "a practical way to prioritise.",
          },
        },
        curious_catalyst: {
          name: "Curious Catalyst",
          tagline: "Sparks ideas and gets others excited about them.",
          description: "Imaginative, energetic and quick to share new ideas. Most useful at the start of projects and in times of change.",
          collaboration: "Brings new possibilities to a team. Pair with a strong finisher, and agree which ideas to see through to the end.",
          strengths: {
            1: "Generates fresh ideas and new angles",
            2: "Gets others enthusiastic about change",
            3: "Makes connections across different areas",
          },
          watch_for: {
            1: "Starts more than they finish",
            2: "Can lose interest once the new part is over",
            3: "May move on before an idea is tested",
          },
          works_best_when: {
            1: "There are new projects, early ideas or change",
            2: "There is variety and room to explore",
            3: "A partner or process carries ideas through",
          },
          interview: {
            q1: "Tell me about an idea of yours that made it all the way to launch. What was your part in finishing it?",
            q1_listen_for: "staying involved through the less exciting middle.",
            q2: "Describe an idea you were excited about that did not work. How did you know when to stop?",
            q2_listen_for: "testing ideas, not just generating them.",
            q3: "How do you choose which ideas to put your time into?",
            q3_listen_for: "a clear way of prioritising.",
          },
        },
        steady_finisher: {
          name: "Steady Finisher",
          tagline: "Delivers what they promise, without drama.",
          description: "Reliable, disciplined and calm under deadlines. Most useful where dependable delivery matters most.",
          collaboration: "The person a team trusts to get it done. Give early notice of changes, and involve them in re-planning.",
          strengths: {
            1: "Delivers on time and to standard",
            2: "Stays calm and methodical under pressure",
            3: "Plans work and sticks to the plan",
          },
          watch_for: {
            1: "Can be rigid when plans change",
            2: "May resist last-minute shifts, even good ones",
            3: "Can hold others to their own high standards",
          },
          works_best_when: {
            1: "Deadlines and responsibilities are clear",
            2: "Reliability is valued and noticed",
            3: "Changes come with reasons and notice",
          },
          interview: {
            q1: "Tell me about a time a plan changed at the last minute. How did you respond?",
            q1_listen_for: "adapting without losing quality.",
            q2: "Describe a time a teammate's standards were lower than yours. What did you do?",
            q2_listen_for: "fairness and constructive feedback.",
            q3: "When did you have to drop a task to meet a bigger priority?",
            q3_listen_for: "flexibility about the plan itself.",
          },
        },
        bridge_builder: {
          name: "Bridge Builder",
          tagline: "Keeps people and plans moving together.",
          description: "Builds agreement and keeps shared work in order. Most useful on projects where several people or teams need to stay in step, and where follow-through matters as much as ideas.",
          collaboration: "Keeps shared plans in order and helps people agree on them. Likely to share credit and smooth over friction. Pair with someone who is comfortable raising hard trade-offs early.",
          strengths: {
            1: "Follows through on what they commit to",
            2: "Eases friction between people and teams",
            3: "Keeps shared plans, notes and details in order",
          },
          watch_for: {
            1: "May put off a hard conversation to keep the peace",
            2: "Can take on too much while helping others",
            3: "May find it hard to push back on senior people",
          },
          works_best_when: {
            1: "Ownership and shared goals are clear",
            2: "Work depends on shared plans and reliable follow-through",
            3: "Disagreements are raised openly, not left to settle",
          },
          interview: {
            q1: "Tell me about a time you had to say no to someone you wanted to keep on side. What happened?",
            q1_listen_for: "a clear no, said early, and how they kept the relationship.",
            q2: "Describe a project where two groups wanted different things. How was it decided?",
            q2_listen_for: "whether they helped make a decision, or only kept both sides talking.",
            q3: "When did you last take on more than you could deliver? What did you change after?",
            q3_listen_for: "a specific change in how they say yes, not just working longer hours.",
          },
        },
        expressive_creative: {
          name: "Expressive Creative",
          tagline: "Brings imagination and feeling to their work.",
          description: "Expressive, imaginative and emotionally tuned in. Most useful in creative or people-facing work where feeling matters.",
          collaboration: "Adds creativity and empathy, and helps a team connect with the people it serves. Give feedback early and specifically, and check in when pressure is high.",
          strengths: {
            1: "Brings originality and emotional depth",
            2: "Picks up on how others are feeling",
            3: "Cares deeply about the quality of their work",
          },
          watch_for: {
            1: "Setbacks and criticism can hit harder than for most",
            2: "Mood can affect focus during stressful periods",
            3: "May take feedback on their work personally",
          },
          works_best_when: {
            1: "Creative input is valued",
            2: "Feedback is specific and given with care",
            3: "There is support during high-pressure periods",
          },
          interview: {
            q1: "Tell me about critical feedback on your work that was hard to hear. What did you do with it?",
            q1_listen_for: "using it, even when it stung.",
            q2: "Describe a stressful project. How did you look after your focus and energy?",
            q2_listen_for: "practical habits, and knowing when to ask for support.",
            q3: "When did your sense of how people felt change the direction of your work?",
            q3_listen_for: "empathy turned into a better result.",
          },
        },
        people_centred_innovator: {
          name: "People-centred Innovator",
          tagline: "Shapes new ideas around real people.",
          description: "Creative and caring, with a focus on how ideas affect people. Most useful in product, design or service improvement.",
          collaboration: "Brings fresh, human-centred ideas and invites others in. Help them make clear trade-offs when not everyone can win.",
          strengths: {
            1: "Designs ideas around real needs",
            2: "Brings people into the process",
            3: "Balances new thinking with care for others",
          },
          watch_for: {
            1: "Can struggle to make unpopular calls",
            2: "May try to please everyone and water down the idea",
            3: "Can find hard trade-offs uncomfortable",
          },
          works_best_when: {
            1: "The work improves things for customers or colleagues",
            2: "Collaboration is part of how ideas are made",
            3: "Someone helps make the final trade-offs",
          },
          interview: {
            q1: "Tell me about an idea you dropped or changed because it would not work for some people. How did you decide?",
            q1_listen_for: "a clear trade-off, not endless compromise.",
            q2: "Describe a decision you made that disappointed someone you were trying to help.",
            q2_listen_for: "owning the call.",
            q3: "How do you find out what people actually need, rather than what they say they want?",
            q3_listen_for: "a real method, such as watching people or testing ideas.",
          },
        },
        pragmatic_innovator: {
          name: "Pragmatic Innovator",
          tagline: "Turns new ideas into plans that ship.",
          description: "Curious and disciplined, able to imagine what could be and then deliver it. Most useful for new initiatives that need real execution.",
          collaboration: "Links big ideas to practical plans and helps teams deliver something new. Agree scope early and share ownership of the vision.",
          strengths: {
            1: "Combines fresh thinking with a solid plan",
            2: "Sees how an idea becomes a delivered result",
            3: "Holds a high standard from concept to launch",
          },
          watch_for: {
            1: "Can over-engineer or over-plan",
            2: "May push hard for their own vision",
            3: "Can take on too much at once",
          },
          works_best_when: {
            1: "They own a project from start to finish",
            2: "New thinking is welcome and results are expected",
            3: "Scope is agreed and protected",
          },
          interview: {
            q1: "Tell me about a project where you had to cut scope to ship. What did you cut, and why?",
            q1_listen_for: "choosing the essentials, not just working longer.",
            q2: "Describe a time your vision clashed with a teammate's. How was it resolved?",
            q2_listen_for: "openness to other approaches.",
            q3: "How do you decide an idea is worth turning into a full plan?",
            q3_listen_for: "testing before committing.",
          },
        },
        exacting_specialist: {
          name: "Exacting Specialist",
          tagline: "Gets the details right with deep, quiet focus.",
          description: "Careful, thorough and happiest with focused, independent work. Most useful for precision work with clear standards and room to concentrate.",
          collaboration: "The person whose work others can rely on without checking. Agree regular check-ins, since they may not raise problems unprompted.",
          strengths: {
            1: "Produces accurate, high-quality work",
            2: "Spots errors others miss",
            3: "Builds deep expertise over time",
          },
          watch_for: {
            1: "May not share progress or problems until asked",
            2: "Slow to hand work over until it feels perfect",
            3: "May prefer working alone to collaborating",
          },
          works_best_when: {
            1: "Standards and expectations are clear",
            2: "Quality is valued over speed",
            3: "Feedback can be direct and specific",
          },
          interview: {
            q1: "Tell me about a mistake you found in someone else's work. How did you raise it?",
            q1_listen_for: "speaking up in time, and in a way the person could accept.",
            q2: "When did you have to trade quality for speed? How did you decide?",
            q2_listen_for: "sensible judgement, not perfection at any cost.",
            q3: "Describe a time you had to rely on work done to a lower standard than yours.",
            q3_listen_for: "how they handled it without redoing everything themselves.",
          },
        },
        watchful_observer: {
          name: "Watchful Observer",
          tagline: "Notices what others miss and thinks before acting.",
          description: "Quiet, observant and careful, and more affected by pressure than most. Most useful where noticing problems early matters more than being in the spotlight.",
          collaboration: "Brings careful observation and a thoughtful view. Ask for their input directly and give them time to prepare it.",
          strengths: {
            1: "Notices small changes and early warning signs",
            2: "Thinks carefully before acting",
            3: "Listens more than they speak",
          },
          watch_for: {
            1: "Busy, high-pressure settings can wear them down",
            2: "May hold back concerns in a large group",
            3: "Can take longer to settle into a new team",
          },
          works_best_when: {
            1: "The pace is steady and expectations are clear",
            2: "There are quieter ways to share ideas, such as writing",
            3: "A manager checks in one to one",
          },
          interview: {
            q1: "Tell me about a problem you noticed before anyone else. What did you do about it?",
            q1_listen_for: "acting on what they noticed, not only seeing it.",
            q2: "Describe a period of high pressure at work. What helped you manage it?",
            q2_listen_for: "practical ways of coping, and asking for support when needed.",
            q3: "How do you share a concern when you are in a meeting with people you don't know well?",
            q3_listen_for: "a way of being heard, even if it is not in the room.",
          },
        },
        free_spirit: {
          name: "Free Spirit",
          tagline: "Works in the moment and feels things strongly.",
          description: "Spontaneous, open and quick to react to what is happening around them. Most useful in varied work where energy and flexibility count.",
          collaboration: "Brings a candid read of how things are going and adapts quickly. Agree a few clear priorities, and check in during busy periods.",
          strengths: {
            1: "Responds quickly to what is in front of them",
            2: "Is honest about how things are going",
            3: "Is comfortable changing direction",
          },
          watch_for: {
            1: "Can find routine and long deadlines hard to sustain",
            2: "Stress can knock plans off course",
            3: "Follow-through may vary with mood and workload",
          },
          works_best_when: {
            1: "The work is varied and hands-on",
            2: "Someone helps set priorities and deadlines",
            3: "Support is easy to reach when pressure rises",
          },
          interview: {
            q1: "Tell me about a long piece of work you kept going with even when it got dull. What kept you on track?",
            q1_listen_for: "a method or support they used, not just willpower.",
            q2: "Describe a time pressure pushed a plan off course. What did you do next?",
            q2_listen_for: "how quickly they recovered, and what they changed.",
            q3: "How do you decide what to do first on a hectic day?",
            q3_listen_for: "a simple, repeatable way to prioritise.",
          },
        },
        outspoken_advocate: {
          name: "Outspoken Advocate",
          tagline: "Speaks up strongly for what matters to them.",
          description: "Direct, passionate and quick to challenge things they see as wrong. Most useful where problems need to be named and someone needs to push for change.",
          collaboration: "Makes sure hard issues get raised. Give them a clear channel for concerns, and agree how disagreement is handled in the team.",
          strengths: {
            1: "Names problems others avoid",
            2: "Pushes hard for causes they believe in",
            3: "Keeps standards and fairness in view",
          },
          watch_for: {
            1: "Can react strongly in heated moments",
            2: "Frustration may show in how they give feedback",
            3: "May take disagreement personally",
          },
          works_best_when: {
            1: "Speaking up is welcome",
            2: "There are clear, fair ways to raise concerns",
            3: "Decisions and their reasons are shared openly",
          },
          interview: {
            q1: "Tell me about a time you pushed for a change others resisted. How did it end?",
            q1_listen_for: "persuading people, not just pushing harder.",
            q2: "Describe a moment at work when you were frustrated. How did you handle it in the moment?",
            q2_listen_for: "staying constructive while still making the point.",
            q3: "When did someone change your mind about something you felt strongly about?",
            q3_listen_for: "openness, even on issues they care about.",
          },
        },
        confident_motivator: {
          name: "Confident Motivator",
          tagline: "Brings energy and keeps others positive.",
          description: "Outgoing, upbeat and steady under pressure. Most useful where people need encouragement and someone to keep spirits up.",
          collaboration: "Keeps a team energised and confident. Pair with someone who asks the awkward questions and tracks details.",
          strengths: {
            1: "Lifts the mood and energy of a group",
            2: "Stays composed when things go wrong",
            3: "Comfortable speaking up and taking the lead",
          },
          watch_for: {
            1: "May underplay real problems to stay positive",
            2: "Can move on before others feel heard",
            3: "Detail and follow-up can take second place",
          },
          works_best_when: {
            1: "The role involves people, pitching or leading a group",
            2: "Change is frequent and morale matters",
            3: "Someone else keeps an eye on detail",
          },
          interview: {
            q1: "Tell me about a time your team was losing heart. What did you do?",
            q1_listen_for: "real support, not just positivity.",
            q2: "Describe a problem you were too optimistic about. What did you learn?",
            q2_listen_for: "honesty about risks, and a change in how they judge them.",
            q3: "How do you make sure quieter people are heard in a group you are leading?",
            q3_listen_for: "a concrete habit that makes room for others.",
          },
        },
        grounded_realist: {
          name: "Grounded Realist",
          tagline: "Calm, practical and hard to rattle.",
          description: "Steady, down to earth and focused on what works. Most useful in roles that need a level head and practical judgement.",
          collaboration: "A steady, practical voice who keeps plans realistic. Invite them to test new ideas rather than just approve or reject them.",
          strengths: {
            1: "Stays calm and practical in difficult moments",
            2: "Keeps plans realistic",
            3: "Gives sensible, grounded advice",
          },
          watch_for: {
            1: "Can be cautious about untested ideas",
            2: "May seem unmoved when others are excited or worried",
            3: "Can stick with the familiar way for too long",
          },
          works_best_when: {
            1: "The work is practical and results are visible",
            2: "Change comes with a clear, practical reason",
            3: "Calm judgement is valued",
          },
          interview: {
            q1: "Tell me about a new idea you were doubtful about that turned out to work.",
            q1_listen_for: "being open to evidence, not just caution.",
            q2: "Describe the most difficult situation you have had to keep calm in.",
            q2_listen_for: "a practical process, not just staying calm.",
            q3: "How do you respond when colleagues are much more worried or excited than you are?",
            q3_listen_for: "reading how others feel and responding to it.",
          },
        },
        cool_headed_decider: {
          name: "Cool-headed Decider",
          tagline: "Makes tough calls calmly and directly.",
          description: "Direct, steady and comfortable making unpopular decisions. Most useful where hard trade-offs must be made under pressure.",
          collaboration: "Brings calm, clear decision-making when stakes are high. Pair with someone who pays close attention to how people are feeling.",
          strengths: {
            1: "Makes difficult decisions without getting rattled",
            2: "Says clearly what they think",
            3: "Stays objective when emotions run high",
          },
          watch_for: {
            1: "Can come across as detached or unsympathetic",
            2: "May underestimate how decisions land on people",
            3: "Can dismiss concerns that seem emotional",
          },
          works_best_when: {
            1: "Decisions and ownership are clear",
            2: "Tough calls are part of the role",
            3: "Someone helps communicate decisions with care",
          },
          interview: {
            q1: "Tell me about a tough decision that upset people. How did you handle their reactions?",
            q1_listen_for: "care in delivery, not only a sound decision.",
            q2: "Describe a time a concern you dismissed turned out to matter.",
            q2_listen_for: "learning to weigh concerns they don't share.",
            q3: "How do you explain a hard decision to the people it affects?",
            q3_listen_for: "clear reasons and real listening.",
          },
        },
        maverick: {
          name: "Maverick",
          tagline: "Does things their own way and questions the rules.",
          description: "Independent, unconventional and relaxed about structure. Most useful where fresh approaches matter more than doing things by the book.",
          collaboration: "Brings independence and a willingness to challenge how things are done. Agree the few rules that matter, and be clear about deadlines.",
          strengths: {
            1: "Finds new ways around old problems",
            2: "Questions rules that no longer make sense",
            3: "Is comfortable standing apart from the group",
          },
          watch_for: {
            1: "May ignore processes others rely on",
            2: "Can resist feedback and direction",
            3: "Commitments and deadlines can slip",
          },
          works_best_when: {
            1: "There is room to try new approaches",
            2: "Rules are few and clearly explained",
            3: "Results matter more than method",
          },
          interview: {
            q1: "Tell me about a rule or process you worked around. What happened as a result?",
            q1_listen_for: "judgement about when breaking the norm helped, and when it hurt.",
            q2: "Describe feedback from a manager you disagreed with. What did you do with it?",
            q2_listen_for: "taking feedback on board even when they disagree.",
            q3: "How do you make sure others can rely on you to meet commitments?",
            q3_listen_for: "a concrete habit, not good intentions.",
          },
        },
        easygoing_individualist: {
          name: "Easygoing Individualist",
          tagline: "Relaxed, low-key and works in their own way.",
          description: "Unhurried, independent and not driven by structure or the spotlight. Most useful in flexible roles that value independence over routine.",
          collaboration: "A low-drama, flexible colleague who adapts easily. Agree clear goals and simple check-ins so progress is visible.",
          strengths: {
            1: "Stays relaxed when others get wound up",
            2: "Works independently without needing attention",
            3: "Adapts easily when plans change",
          },
          watch_for: {
            1: "May lack urgency on deadlines",
            2: "Can drift without clear goals",
            3: "May not volunteer updates",
          },
          works_best_when: {
            1: "Goals are clear and check-ins are regular",
            2: "Work can be done independently",
            3: "The pace is steady rather than frantic",
          },
          interview: {
            q1: "Tell me about a deadline you nearly missed. What happened?",
            q1_listen_for: "awareness of how it slipped and what they changed.",
            q2: "How do you keep yourself on track when nobody is checking?",
            q2_listen_for: "a real method, such as lists, reminders or routines.",
            q3: "Describe a goal you set for yourself at work and how you reached it.",
            q3_listen_for: "self-set direction, not only following others.",
          },
        },
        bold_persuader: {
          name: "Bold Persuader",
          tagline: "Speaks up, pushes hard and wins people over.",
          description: "Assertive, outgoing and competitive. Most useful where influence, negotiation or winning new business matter.",
          collaboration: "Brings drive and confidence to winning people over. Pair with someone who listens closely and keeps relationships strong over time.",
          strengths: {
            1: "Confident speaking up and making the case",
            2: "Comfortable with negotiation and competition",
            3: "Keeps pushing when others give up",
          },
          watch_for: {
            1: "Can dominate conversations",
            2: "May push past others' concerns",
            3: "Competitiveness can strain teamwork",
          },
          works_best_when: {
            1: "Targets and wins are clear",
            2: "The role involves influence, sales or negotiation",
            3: "The team can match their energy or push back",
          },
          interview: {
            q1: "Tell me about a deal or decision you won. What did the other side get?",
            q1_listen_for: "fair outcomes, not winning at any cost.",
            q2: "Describe a time you realised you were dominating a discussion. What did you do?",
            q2_listen_for: "noticing it and making room for others.",
            q3: "When did you lose an argument you cared about? How did you respond?",
            q3_listen_for: "accepting the outcome and moving on constructively.",
          },
        },
        self_reliant_sceptic: {
          name: "Self-reliant Sceptic",
          tagline: "Independent, questioning and hard to convince.",
          description: "Reserved, direct and happy to work alone. Most useful where independent judgement and a critical eye are needed.",
          collaboration: "Brings independent judgement and a healthy scepticism. Agree how and when they will share progress, and ask for their critique directly.",
          strengths: {
            1: "Works well without supervision",
            2: "Questions claims and checks evidence",
            3: "Is not swayed by popular opinion",
          },
          watch_for: {
            1: "Can seem distant or hard to get to know",
            2: "May dismiss ideas before hearing them out",
            3: "May not ask for help or share progress",
          },
          works_best_when: {
            1: "The work needs critical, independent judgement",
            2: "Contact with others is focused and purposeful",
            3: "Trust is built through results",
          },
          interview: {
            q1: "Tell me about a time you were sceptical of a plan. How did you share your doubts?",
            q1_listen_for: "raising doubts in a way others could use.",
            q2: "Describe a working relationship that improved over time. What did you do to help?",
            q2_listen_for: "effort to connect, not just waiting for others.",
            q3: "When did you last change your mind after hearing someone out?",
            q3_listen_for: "willingness to be persuaded by good evidence.",
          },
        },
        quiet_helper: {
          name: "Quiet Helper",
          tagline: "Kind, considerate and helps without fuss.",
          description: "Caring, modest and happiest supporting others behind the scenes. Most useful where care, patience and trust matter.",
          collaboration: "A caring presence who supports others quietly and reliably. Make sure their contribution is seen, and ask for their view directly.",
          strengths: {
            1: "Helps others without needing credit",
            2: "Listens patiently and without judgement",
            3: "Builds trust one to one",
          },
          watch_for: {
            1: "May not speak up for their own needs or ideas",
            2: "Can take on others' worries",
            3: "May avoid conflict even when it is needed",
          },
          works_best_when: {
            1: "The team is supportive and respectful",
            2: "There are one-to-one ways to contribute",
            3: "Their help is noticed and valued",
          },
          interview: {
            q1: "Tell me about a time you helped a colleague through a hard patch. How did you look after yourself too?",
            q1_listen_for: "caring for others without burning out.",
            q2: "Describe a time you disagreed with a colleague. Did you tell them? How?",
            q2_listen_for: "being able to raise it, kindly and clearly.",
            q3: "What is something you did at work that you are proud of, just for yourself?",
            q3_listen_for: "comfort owning their own achievements.",
          },
        },
        down_to_earth_practitioner: {
          name: "Down-to-earth Practitioner",
          tagline: "Quiet, practical and gets on with the job.",
          description: "Reserved, sensible and focused on doing the work well in familiar ways. Most useful in hands-on roles with clear, practical tasks.",
          collaboration: "A steady, practical colleague who does what is needed. Ask for their hands-on experience, which they may not offer unprompted.",
          strengths: {
            1: "Gets on with the work without fuss",
            2: "Brings practical common sense",
            3: "Is steady and consistent day to day",
          },
          watch_for: {
            1: "Can be wary of new ideas and change",
            2: "May not raise ideas or problems unless asked",
            3: "May find open-ended or abstract work hard",
          },
          works_best_when: {
            1: "Tasks are practical and clearly defined",
            2: "Change is explained with a practical reason",
            3: "Their experience is asked for",
          },
          interview: {
            q1: "Tell me about a change at work you found hard to accept. How did you adapt?",
            q1_listen_for: "adapting over time, even when unsure.",
            q2: "Describe a practical improvement you suggested. How did you raise it?",
            q2_listen_for: "speaking up with ideas from experience.",
            q3: "How do you handle a task that has no clear instructions?",
            q3_listen_for: "finding a way forward, including asking questions.",
          },
        },
        no_nonsense_realist: {
          name: "No-nonsense Realist",
          tagline: "Practical, direct and gets to the point.",
          description: "Straightforward, tough-minded and focused on what works. Most useful where plain speaking and practical decisions are needed.",
          collaboration: "Brings straight talk and practical focus. Pair with someone who brings fresh ideas and attends to how people feel.",
          strengths: {
            1: "Says plainly what they think",
            2: "Cuts through complexity to what matters",
            3: "Makes practical calls quickly",
          },
          watch_for: {
            1: "Can seem blunt or dismissive",
            2: "May reject new ideas too quickly",
            3: "Can overlook how people feel about a decision",
          },
          works_best_when: {
            1: "Goals are practical and clear",
            2: "Plain speaking is valued",
            3: "Decisions are based on results",
          },
          interview: {
            q1: "Tell me about a new idea you dismissed that later worked. What did you learn?",
            q1_listen_for: "openness to being wrong about new ideas.",
            q2: "Describe feedback you gave that came across more harshly than you meant.",
            q2_listen_for: "awareness of impact, and a change in approach.",
            q3: "How do you win people over to a practical solution they don't like?",
            q3_listen_for: "persuading with reasons, not just insisting.",
          },
        },
        loyal_team_player: {
          name: "Loyal Team Player",
          tagline: "Dependable, cooperative and loyal to the team.",
          description: "Warm, practical and committed to the people around them. Most useful where teamwork, consistency and trust matter.",
          collaboration: "The steady team member others can count on. Involve them early in changes so they can help bring others along.",
          strengths: {
            1: "Is loyal and dependable to their team",
            2: "Supports agreed ways of working",
            3: "Builds harmony and trust",
          },
          watch_for: {
            1: "Can be wary of change that disrupts the team",
            2: "May go along with the group instead of speaking up",
            3: "May find it hard to challenge established ways",
          },
          works_best_when: {
            1: "The team is stable and relationships matter",
            2: "Roles and processes are clear",
            3: "Change is introduced with care",
          },
          interview: {
            q1: "Tell me about a change your team went through. What part did you play?",
            q1_listen_for: "helping the change work, not only coping with it.",
            q2: "Describe a time you disagreed with the way your team did something.",
            q2_listen_for: "raising it, even when it risked harmony.",
            q3: "How do you welcome a new person into an established team?",
            q3_listen_for: "openness to new people and ideas.",
          },
        },
        hands_on_energiser: {
          name: "Hands-on Energiser",
          tagline: "Gets people moving on practical, real-world work.",
          description: "Sociable, energetic and focused on what works in practice. Most useful in active, people-facing roles with clear, concrete goals.",
          collaboration: "Brings energy and a practical focus to a team. Pair with someone who enjoys exploring new ideas, and explain changes with a practical reason.",
          strengths: {
            1: "Gets people moving and keeps energy up",
            2: "Turns plans into action quickly",
            3: "Relates easily to customers and colleagues on practical matters",
          },
          watch_for: {
            1: "May dismiss ideas that seem abstract or untested",
            2: "Can prefer doing to reflecting",
            3: "May stick with a familiar approach when a new one would work better",
          },
          works_best_when: {
            1: "The work is active, concrete and involves people",
            2: "Results are visible and come quickly",
            3: "Change comes with a clear, practical reason",
          },
          interview: {
            q1: "Tell me about a new way of working you were unsure about at first. How did it turn out?",
            q1_listen_for: "judging change on its results, not on habit.",
            q2: "Describe a time you acted quickly and later wished you had thought it through.",
            q2_listen_for: "a pause or check they now build in.",
            q3: "How do you keep a team's energy up during a long, routine stretch?",
            q3_listen_for: "practical things they did, not just enthusiasm.",
          },
        },
        standard_bearer: {
          name: "Standard Bearer",
          tagline: "Holds a high bar and says so plainly.",
          description: "Organised, exacting and direct about what good work looks like. Most useful where quality, accountability and clear standards matter.",
          collaboration: "Keeps a team accountable and raises problems before they spread. Pair with someone warm who can help feedback land well.",
          strengths: {
            1: "Sets clear standards and holds to them",
            2: "Raises problems plainly and early",
            3: "Follows through and expects others to do the same",
          },
          watch_for: {
            1: "Can be critical of work that falls short",
            2: "Feedback can come across as harsh",
            3: "May find it hard to let others do things their own way",
          },
          works_best_when: {
            1: "Standards and ownership are clear",
            2: "Honest feedback is welcome",
            3: "Quality is valued over keeping everyone comfortable",
          },
          interview: {
            q1: "Tell me about feedback you gave on work that fell short. How did the person respond?",
            q1_listen_for: "a clear message, and care for how it landed.",
            q2: "Describe a time you let someone do a task their way, even though you would have done it differently.",
            q2_listen_for: "trust, and judging when the difference really matters.",
            q3: "When did a standard you held turn out to be more than the situation needed?",
            q3_listen_for: "knowing when good enough is the right call.",
          },
        },
        spontaneous_energiser: {
          name: "Spontaneous Energiser",
          tagline: "Brings energy and goes with the moment.",
          description: "Sociable, lively and happy to change course as things happen. Most useful in fast-moving, people-facing work where energy counts more than routine.",
          collaboration: "Lifts a team's energy and adapts quickly to what is happening. Pair with someone organised who enjoys tracking details and follow-up.",
          strengths: {
            1: "Brings energy and enthusiasm to a group",
            2: "Thinks on their feet in live situations",
            3: "Adapts quickly when plans change",
          },
          watch_for: {
            1: "Follow-up and paperwork can slip",
            2: "May promise more than they can deliver",
            3: "Can get pulled away by the next conversation",
          },
          works_best_when: {
            1: "The work involves people and variety",
            2: "Quick responses matter more than long plans",
            3: "Someone else owns the detailed follow-up",
          },
          interview: {
            q1: "Tell me about a commitment you made that slipped. What happened, and what did you change?",
            q1_listen_for: "ownership, and a new habit rather than a promise to try harder.",
            q2: "How do you keep track of follow-ups after a busy day of meetings or calls?",
            q2_listen_for: "a system they actually use.",
            q3: "Describe a long project that needed steady effort. How did you keep going?",
            q3_listen_for: "staying with it after the exciting start.",
          },
        },
        relaxed_adapter: {
          name: "Relaxed Adapter",
          tagline: "Takes change in stride and stays unruffled.",
          description: "Calm, easygoing and relaxed about changing plans. Most useful in unpredictable work where a steady, flexible approach helps.",
          collaboration: "A low-drama colleague who stays steady when plans shift. Agree clear deadlines and check-ins, since they may not feel urgency the way others do.",
          strengths: {
            1: "Stays calm when plans change",
            2: "Handles surprises without fuss",
            3: "Helps keep the mood relaxed in busy times",
          },
          watch_for: {
            1: "May lack urgency on deadlines",
            2: "Details and follow-up can slip",
            3: "Their calm can be read as not caring",
          },
          works_best_when: {
            1: "Plans change often and a steady head helps",
            2: "Deadlines and priorities are clear",
            3: "Someone else owns the detailed process",
          },
          interview: {
            q1: "Tell me about a deadline that slipped. What happened, and what did you change?",
            q1_listen_for: "ownership, not just staying calm about it.",
            q2: "Describe a time a colleague felt you were not taking something seriously enough.",
            q2_listen_for: "awareness of how their calm comes across.",
            q3: "How do you keep track of commitments when nobody is checking?",
            q3_listen_for: "a real method, such as lists, reminders or routines.",
          },
        },
        laid_back_pragmatist: {
          name: "Laid-back Pragmatist",
          tagline: "Keeps things simple and works it out as they go.",
          description: "Practical, relaxed and happy to handle things as they come, using ways that already work. Most useful in hands-on roles with concrete tasks and some flexibility.",
          collaboration: "A down-to-earth colleague who keeps things simple. Agree clear goals and deadlines, and explain changes with a practical reason.",
          strengths: {
            1: "Keeps solutions simple and practical",
            2: "Handles the task in front of them without fuss",
            3: "Adjusts easily to day-to-day changes",
          },
          watch_for: {
            1: "May lack urgency on longer deadlines",
            2: "Can be wary of new ideas and change",
            3: "Routine details and paperwork can slip",
          },
          works_best_when: {
            1: "Tasks are practical and clearly defined",
            2: "Deadlines are clear and check-ins are regular",
            3: "Change comes with a clear, practical reason",
          },
          interview: {
            q1: "Tell me about a task with a long deadline. How did you make sure it got done on time?",
            q1_listen_for: "a plan or routine they actually used.",
            q2: "Describe a new tool or way of working you had to learn. How did you get on?",
            q2_listen_for: "openness, even when the old way felt fine.",
            q3: "When did a small detail you skipped cause a problem later?",
            q3_listen_for: "ownership, and a change in habit.",
          },
        },
        easygoing_helper: {
          name: "Easygoing Helper",
          tagline: "Helps out wherever needed and goes with the flow.",
          description: "Warm, accommodating and flexible, quick to help when priorities shift. Most useful in supportive, varied roles where people come first.",
          collaboration: "Makes others feel supported and adapts easily to what the team needs. Help them protect their own priorities and follow through on them.",
          strengths: {
            1: "Pitches in wherever help is needed",
            2: "Adapts easily to others' needs and changing plans",
            3: "Keeps working relationships easy and friendly",
          },
          watch_for: {
            1: "May say yes to too much and let their own work slip",
            2: "Details and deadlines can slip",
            3: "May avoid conflict even when it needs to happen",
          },
          works_best_when: {
            1: "The work is varied and people-focused",
            2: "Priorities are clear, so helping does not crowd them out",
            3: "Someone helps with the detailed follow-up",
          },
          interview: {
            q1: "Tell me about a time helping others got in the way of your own work. What did you do?",
            q1_listen_for: "protecting their own priorities, not only helping.",
            q2: "How do you keep track of what you have promised to different people?",
            q2_listen_for: "a real system, not memory alone.",
            q3: "Describe a time you had to disagree with someone you get on well with.",
            q3_listen_for: "saying it clearly, not only kindly.",
          },
        },
        caring_listener: {
          name: "Caring Listener",
          tagline: "Tunes in to people and takes things to heart.",
          description: "Caring, considerate and quick to notice how others are doing, and takes problems and responsibilities seriously. Most useful where empathy, trust and care for people matter.",
          collaboration: "Notices how people are doing and offers real support. Give clear priorities and regular check-ins, especially in demanding periods.",
          strengths: {
            1: "Picks up quickly on how others are feeling",
            2: "Listens with patience and care",
            3: "Takes problems and responsibilities seriously",
          },
          watch_for: {
            1: "Long stretches of pressure can wear them down",
            2: "May take on others' problems as their own",
            3: "May hold back a concern to avoid friction",
          },
          works_best_when: {
            1: "The team is supportive and respectful",
            2: "Priorities are clear and workload is steady",
            3: "Care for people is part of the role",
          },
          interview: {
            q1: "Tell me about a time you supported a colleague through a hard patch. How did you manage your own workload?",
            q1_listen_for: "caring for others without overloading themselves.",
            q2: "Describe a demanding period at work. What helped you keep going?",
            q2_listen_for: "practical habits, and asking for support when needed.",
            q3: "When did you raise a concern that you knew might cause friction?",
            q3_listen_for: "speaking up, even when it felt uncomfortable.",
          },
        },
        quiet_anchor: {
          name: "Quiet Anchor",
          tagline: "Quiet, composed and steady under pressure.",
          description: "Reserved, even-tempered and hard to rattle. Most useful where calm, focused work matters more than being in the spotlight.",
          collaboration: "A calm, steady presence who keeps working when others get stirred up. Ask for their view directly, since they may not offer it.",
          strengths: {
            1: "Stays composed when things go wrong",
            2: "Works steadily and independently",
            3: "Gives a calm, considered view",
          },
          watch_for: {
            1: "May not share concerns or progress unless asked",
            2: "Their calm can be read as not caring",
            3: "May be overlooked in busy, noisy teams",
          },
          works_best_when: {
            1: "There is room for focused, independent work",
            2: "Updates and check-ins have a clear rhythm",
            3: "Their view is asked for directly",
          },
          interview: {
            q1: "Tell me about a tense situation at work where you stayed calm. What did you actually do?",
            q1_listen_for: "clear actions, not just staying calm.",
            q2: "How do you let people know about a problem before it grows?",
            q2_listen_for: "raising issues early, without being asked.",
            q3: "Describe a time someone misread your calm as not caring.",
            q3_listen_for: "awareness of how they come across, and what they changed.",
          },
        },
        passionate_communicator: {
          name: "Passionate Communicator",
          tagline: "Expressive, engaging and invested in the work.",
          description: "Outgoing, expressive and deeply invested in their work and the people around them. Most useful in people-facing roles where energy and enthusiasm count.",
          collaboration: "Brings energy and warmth to a team, and says openly how things are going. Give feedback early and specifically, and check in during demanding periods.",
          strengths: {
            1: "Engages people with energy and enthusiasm",
            2: "Is open about how the work is going",
            3: "Cares a lot about doing well",
          },
          watch_for: {
            1: "Pressure can show in how they react in the moment",
            2: "Setbacks and criticism can hit harder than for most",
            3: "May take on more than they can sustain",
          },
          works_best_when: {
            1: "The role involves people, energy and communication",
            2: "Feedback is specific and given with care",
            3: "Support is easy to reach in busy periods",
          },
          interview: {
            q1: "Tell me about a moment at work when you felt frustrated. How did you handle it?",
            q1_listen_for: "staying constructive while still making the point.",
            q2: "Describe critical feedback that was hard to hear. What did you do with it?",
            q2_listen_for: "using it, even when it stung.",
            q3: "What helps you keep your energy steady through a demanding month?",
            q3_listen_for: "practical habits, and knowing when to ask for support.",
          },
        },
        quality_guardian: {
          name: "Quality Guardian",
          tagline: "Prepares carefully and cares about getting it right.",
          description: "Organised, conscientious and alert to what could go wrong. Most useful where accuracy and careful preparation matter.",
          collaboration: "Protects quality by planning ahead and checking the details. Give clear priorities and early notice of change, and help them judge when work is good enough.",
          strengths: {
            1: "Plans ahead and prepares thoroughly",
            2: "Checks work carefully before it goes out",
            3: "Takes commitments seriously",
          },
          watch_for: {
            1: "May find it hard to let work go until it feels perfect",
            2: "Sudden changes and tight deadlines can add stress",
            3: "Can be hard on themselves when things go wrong",
          },
          works_best_when: {
            1: "Standards are clear and quality matters",
            2: "Plans are shared early, with time to prepare",
            3: "Deadlines leave time to check the work",
          },
          interview: {
            q1: "When did you have to hand in work before you felt it was ready? What happened?",
            q1_listen_for: "judging when good enough is the right call.",
            q2: "Describe a period of high pressure at work. What helped you manage it?",
            q2_listen_for: "practical habits, and asking for support when needed.",
            q3: "Tell me about a mistake you made at work. How did you handle it afterwards?",
            q3_listen_for: "learning from it without dwelling on it.",
          },
        },
        balanced: {
          name: "Balanced profile",
          description: "No trait is outside the 35th to 65th percentile, so no archetype describes this candidate well, and we would rather say so than force a label. People with balanced profiles often adjust their style to the situation. Look at the facets and use the interview to learn which way they lean at work.",
        },
      },
    },

    // Workplace Archetype section
    workplace_archetype: "Your Workplace Personality Archetype",
    workplace_archetype_description:
      "Based on your Big Five personality profile, you align with this workplace archetype that describes your professional strengths and ideal work environment.",
    key_strengths: "Key Strengths",
    ideal_roles: "Ideal Roles",
    collaboration_style: "Collaboration Style",
    works_well_with: "Works Well With",

    // Personality profile section (legacy - can be removed later)
    personality_profile: "Personality Profile",
    personality_profile_description:
      "Your unique personality characteristics across the five major dimensions. Each trait represents different ways of thinking, feeling, and behaving - all equally valuable in different contexts.",

    // Levels
    level: {
      very_low: "Very Low",
      low: "Low",
      moderate: "Moderate",
      high: "High",
    },

    // AI Readiness Assessment Results
    ai_use_evaluator: "AI Readiness Assessment",
    role_skills_evaluator: "Role Skills Assessment",
    ai_proficiency: "AI Readiness",
    ai_proficiency_description:
      "This assessment measures AI readiness by evaluating the human skills that determine AI effectiveness: critical thinking, clear communication, and sound judgment.",
    critical_thinking: "Critical Thinking",
    critical_thinking_description:
      "Ability to break down complex problems, iterate on solutions, and think systematically when working with AI.",
    communication_clarity: "Communication Clarity",
    communication_clarity_description:
      "Skill in crafting clear, specific prompts and providing adequate context for AI to understand the task.",
    hallucination_detection: "Hallucination Detection",
    hallucination_detection_description:
      "Ability to identify and verify potentially incorrect or fabricated information in AI responses.",
    ai_conversation_transcript: "Conversation Transcript",
    ai_conversation_summary: "Conversation Summary",
    conversation_transcript: "Conversation Transcript",
    messages_exchanged: "Messages Exchanged",
    task_completed: "Task Completed",
    analysis_pending_title: "Analysis Pending",
    analysis_pending_description: "The AI conversation has been recorded and is awaiting analysis. Detailed readiness scores for critical thinking, communication clarity, and verification skills will be available once the analysis is complete.",
    candidate: "Candidate",
    ai_assistant: "AI Assistant",
    and_more_messages: "...and {count} more messages",
    ai_use_evaluator_analysis:
      "The candidate's AI readiness was assessed across critical thinking patterns, communication effectiveness, and verification behaviors.",
    strong_ai_user:
      "{name} demonstrates strong AI readiness with effective prompting strategies and healthy skepticism toward AI outputs. Ready to leverage AI tools productively.",
    developing_ai_user:
      "{name} shows developing AI readiness with room for improvement in prompt clarity and verification habits. Would benefit from guidance on effective AI collaboration techniques.",
    novice_ai_user:
      "{name} shows limited AI readiness and may need training on effective prompting, critical evaluation of AI responses, and iterative problem-solving approaches.",
    // Additional AI evaluation aspects
    prompt_engineering: "Prompt Engineering",
    prompt_engineering_description:
      "Ability to craft effective prompts with appropriate context, constraints, and desired output format.",
    iterative_refinement: "Iterative Refinement",
    iterative_refinement_description:
      "Skill in building upon AI responses, asking follow-up questions, and progressively improving outputs.",
    information_synthesis: "Information Synthesis",
    information_synthesis_description:
      "Capability to combine AI-generated insights into coherent, actionable conclusions and deliverables.",
    // AI Readiness Levels
    ai_proficiency_level: "AI Readiness Level",
    final_recommendation: "Final Recommendation",
    ai_proficiency_expert: "Highly Ready",
    ai_proficiency_expert_desc:
      "Demonstrates exceptional AI readiness with sophisticated prompting strategies, strong verification habits, and excellent ability to synthesize AI outputs. Ready to lead AI initiatives and mentor others.",
    ai_proficiency_proficient: "Ready",
    ai_proficiency_proficient_desc:
      "Shows strong AI readiness with effective prompting, good iterative refinement skills, and healthy skepticism. Well-prepared to leverage AI tools productively in their role.",
    ai_proficiency_developing: "Developing",
    ai_proficiency_developing_desc:
      "Exhibits foundational readiness with room for improvement in prompt clarity, verification practices, and output synthesis. Would benefit from AI training and mentorship.",
    ai_proficiency_novice: "Not Yet Ready",
    ai_proficiency_novice_desc:
      "Shows limited AI readiness and would benefit from structured training on prompting basics, critical evaluation, and iterative problem-solving before productive AI use.",

    // AI Readiness Group Analytics
    proficiency_distribution: "Readiness Level Distribution",
    ai_readiness: "AI Readiness",
    ready_for_ai: "Ready",
    needs_development: "Needs Development",
    dimensions_breakdown: "Dimension Breakdown",
    ai_dimension_details: "AI Readiness - Dimension Details",
    ai_skill_details: "AI Readiness - Skill Details",
    group_average: "Group Average",
  },
  coreValuesAnalyzer: {
    My_Core_Values: "My Core Values",
    Audit: "Audit",
    Skills: "Skills",
    Survey_Question: "Survey Questions",
    Microlearning: "Microlearning",
    Clarity: "Clarity",
    Practical: "Practical",
    Best_Practice: "Best Practice",
    Inspiring: "Inspiring",
    Audit_Summary: "Audit Summary",
    Purpose_driven: "Purpose-driven",
    Alternative_Options: "Alternative Options",
    Auditing_you_values: "Auditing your values…",
    Overall: "Overall",
    Simple_Language: "Simple Language",
    Potential_Misunderstanding: "Potential Misunderstanding",
    Consistency: "Consistency",
    Actionable: "Actionable",
    Easy_To_Reinforce: "Easy To Reinforce",
    Measureable: "Measureable",
    Not_Permission_To_Play: "Not Permission To Play",
    Sense_Of_Pride: "Sense Of Pride",
    Positive_Impact: "Positive Impact",
    Analyze_everything_you:
      "Analyze everything you need to know about your core values, and get recommendations on skills to develop, questions to ask, and information to share.",
    Enter_from_1_to: "Enter your core values (8 max)",
    Analyze: "Analyze",
    Analyzing: "Analyzing",
    What_you_get: "What you get",
    Audit_your_core_values: "Audit your core values",
    Analyze_how_well_your:
      "Analyze how well your core values score on clarity, being practical, following best practice, and being inspiring.",
    Ratings_recommendations_and:
      "Ratings, recommendations, and alternate core values are provided to help you develop your core values.",
    Get_a_Skills_Development: "Get a Skills Development Plan",
    Get_a_skill_evelopment:
      "Get a skill development framework that helps your employees can effectively express and deliver on your values.",
    Leaders_an_encourage_and:
      "Leaders can encourage and reward employees who embody these values, and provide opportunities for employees to practice and develop these skills.",
    Generate_Survey_Questions: "Generate Survey Questions",
    Help_your_employees_regularly:
      "Help your employees regularly reflect and share feedback based on your core values. Add these questions to your pulse survey or feedback tool of choice.",
    Learning_Content_to_Support: "Learning Content to Support Your Values",
    // --
    Get_micro_learning_content:
      "Get micro-learning content snippets to share through various channels such as emails, company intranet, social media, or a learning management system.",
    Short_and_easily_digestible:
      "Short and easily digestible, they allow employees to reflect on and improve upon the core values quickly and conveniently.",
    Skills_and_Development_Guidance: "Skills & Development Guidance",
    In_order_for_your:
      "In order for your employees to express and stay true to your core values they must possess or and continuously develop the following skills:",
    By_veloping_and_supporting:
      "By developing and supporting these skills, employees can effectively express and deliver on the core values of",
    Leaders_can_encourage_and:
      "Leaders can encourage and reward employees who embody these values, and provide opportunities for employees to practice and develop these skills.",
    Questions: "Questions",
    Regularly_get_your_employees:
      "Regularly get your employees to reflect and share feedback based on the following questions. Add these questions to your pulse survey or feedback tool of choice:",
    These_micro_learning_content:
      "These micro-learning content snippets can be shared through various channels such as emails, company intranet, social media, or a learning management system. They are intended to be short and easily digestible, allowing employees to reflect on and improve upon the core values in a quick and convenient manner.",
    Generate_more_content: "Generate more content",
    Create_an_account_to:
      "Create an account to unlock skills, survey questions, and microlearning",
    Download_This_Report: "Download This Report",
    Download_to_save: "Save this core values audit and analysis as a PDF file",
    Download: "Download",
    Download_pdf_title:
      "A Core Values Report: An Audit, Skill & Development Guidance, Survey Questions, and Microlearning",
    Download_pdf_success: "Preparing to download the report...",
  },
  headerTable: {
    NAME: "NAME",
    CANDIDATES: "CANDIDATES",
    PROGRESS: "PROGRESS",
    LAST_ACTIVITY: "LAST ACTIVITY",
    DATE_CREATED: "DATE CREATED",
    ACTIONS: "ACTIONS",
    JOINED: "JOINED",
    SCORE: "SCORE",
    STATUS: "STATUS",
    YOUR_RATING: "YOUR RATING",
  },
  dataTable: {
    Invite_your_first: "Invite your first candidate or team member",
    Send_invitations: "Send invitations by email or sharing a link",
  },
  popup: {
    optional: {
      Yes: "Yes",
      Yes_chi: "Yes",
      Confirm: "Confirm",
      Cancel: "Cancel",
      Continue: "Continue",
      Go_to_Next_Section: "Go to Next Section",
      OK: "OK",
      Got_it: "Got it",
      Confirm_Delete: "Confirm Delete",
    },
    question: {
      question_box_1: {
        title: "Send results to ",
        question_1: "We will send an email, on your behalf, to ",
        question_2:
          " with a private link to access their results. Are you sure you would like to proceed?",
      },
      question_box_2: {
        title: "Please Confirm",
        question: "Are you sure you want to delete this submission?",
      },
      question_box_3: {
        title: "Confirmation Required",
        question: "Are you sure you want to delete this candidate?",
      },
      question_box_4: {
        title: "Set up",
        question: "Do you want to edit your current set up process?",
      },
      question_box_5: {
        title: "Action Required",
        question:
          "Are you sure you want to remove this scenario from being evaluated for this assessment?",
      },
      save_team: {
        success_msg: "Team has been changed successfully",
      },
      delete_team_success: {
        success_msg: "Team has been deleted successfully",
      },
      add_member: {
        success_msg: "Member has been added successfully",
      },
      change_role: {
        success_msg: "Member role has been changed successfully",
      },
      remove_member: {
        title: "Warning",
        question: "Are you sure you want to remove this member?",
        success_msg: "Member has been removed successfully",
      },
      leave_team: {
        title: "Warning",
        question: "Are you sure you want to leave from this team?",
        success_msg: "You have left from this team successfully",
      },
      cannot_be_admin: {
        title: "Warning",
        question:
          "Are you sure you want to remove yourself from administrator?",
      },
      delete_team: {
        title: "Delete the {teamName} Team",
        question: `Are you sure you want to delete this team? Once deleted, all team assessments and results will no longer be available to view by any team member.

        <br /><br />Please proceed with caution.`,
      },
      clear_results: {
        title: "Clear Results",
        question: `Are you sure you want to clear all results so that the candidate must retake the assessment from the beginning?`,
      },
    },
    title: {
      ShareAssessmentWithTeam: "Share Assessment with Team",
      UnshareAssessment: "Unshare Assessment",
    },
    label: {
      AssessmentName: "Assessment Name",
      SelectTargetTeam: "Select Team",
    },
    placeholder: {
      SelectTeam: "Select a team",
    },
    info: {
      ShareAssessmentInfo:
        "This assessment will be shared with the selected team and made visible to all team members. All candidate responses will be preserved.",
      UnshareAssessmentInfo:
        "This assessment will be moved back to your Personal account and will no longer be visible to team members.",
    },
    success: {
      AssessmentShared: "Assessment has been shared successfully",
      AssessmentUnshared: "Assessment has been unshared successfully",
    },
    error: {
      FailedToShareAssessment: "Failed to share assessment. Please try again.",
      FailedToUnshareAssessment:
        "Failed to unshare assessment. Please try again.",
    },
    alert: {
      alert_box_1: {
        title: "No time remaining",
        description:
          "The allocated time for this section has run out. Please continue to the next step.",
      },
      alert_box_2: {
        title: "Session Time Out",
        description:
          "Please proceed to the next section of the assessment to complete your submission. Otherwise, you are at risk of losing your responses and may have to re-take the assessment.",
      },
      save_failed: {
        title: "Your answers weren't saved",
        description:
          "Something went wrong while saving your answers. Check your internet connection, then try again.",
        retry: "Try again",
      },
      question_box_5: {
        title: "Warning",
        question:
          "Are you sure you want to remove this scenario from being evaluated for this assessment?",
      },
      cannot_remove_last_admin: {
        title: "Warning",
        message:
          "One admin is required per team. Please assign another member as an Admin before proceeding.",
      },
      cannot_add_duplicated_member: {
        title: "Warning",
        message: "Already have this member.",
      },
    },
    message: {
      message_1: "You have sent assessment results",
      message_2: "An invitation email has been resent to ",
      message_3_1: "The results of ",
      message_3_2: " assessment has been successfully cleared",
      message_4: "Data not found.",
      message_5e: "This image must be a JPG or PNG!",
      message_6e: "This image is bigger than 2MB!",
      message_7e: "Invalid email or OTP. Please check again.",
      message_8: "Copy to clipboard",
      message_9e:
        "No credits remaining. Refer a friend (My Account) to earn more!",
      message_10e: "Maximum emails to send is ",
      message_11: "Emails sent",
      message_12: "Data not found.",
      message_13_1: "An invitation email has been sent to ",
      message_13_2: "",
      message_14w: "Request: 1 section!",
      message_15w: "Please complete your setup before proceeding",
      message_16e: "Oops, something went wrong!",
      message_17: "Referral link copied to your clipboard.",
      message_18: "Saved. User details have been updated.",
      message_18b: "Saved. Company details have been updated.",
      message_19: "The link to this report has been copied to your clipboard.",
      message_20w: "You can only have a maximum of 100 recipients.",
    },
  },
  datetime: {
    months: {
      January: "January",
      February: "February",
      March: "March",
      April: "April",
      May: "May",
      June: "June",
      July: "July",
      August: "August",
      September: "September",
      October: "October",
      November: "November",
      December: "December",
    },
  },
  customDomain: {
    Title: "Custom domain",
    Subdomain_label: "Subdomain",
    Hostname_label: "Hostname",
    Hostname_placeholder: "portal.example.com",
    Description: "Point a subdomain at Happily Assessment. Your team and candidates will see your branding on your domain.",
    gate: {
      requiresUnlimitedTitle: "Custom domains are a Business Plus feature",
      requiresUnlimitedBody:
        "Run assessments on your own domain with your branding. Available on the Business Plus plan.",
      requiresUnlimitedCta: "Upgrade to Business Plus",
      previewBenefit1: "Your branded sign-in portal on your own domain",
      previewBenefit2: "Candidates see your company, not a third party",
      previewBenefit3: "Send assessment emails from your domain",
    },
    wizard: {
      stepLabel1: "Enter domain",
      stepLabel2: "Verify DNS",
      stepLabel3: "Live",
      step1Title: "Use your own domain",
      step1Body:
        "Point a subdomain of your company's website at Happily Assessment. Your team and candidates will see assessments on your domain with your branding.",
      step2Title: "Add these records at your DNS provider",
      step2Intro:
        "Create the records below exactly as shown. Both must be in place before verification completes.",
      dcvExplain:
        "The TXT record is a one-time secret only the domain's DNS owner can publish. It prevents anyone else from claiming your domain. Both records are required. DNS changes usually take 5 to 15 minutes.",
      step3Title: "{host} is live",
      step3SignIn: "Your team can now sign in at {url}",
      step3Links:
        "Assessment links will use this domain automatically where applicable.",
    },
    customEmails: {
      sectionTitle: "Custom email hostname",
      sectionBody:
        "Confirm the hostname used for email setup. It must match your active custom domain.",
      defaultHostnameLabel: "Default hostname",
      Setup: "Set up",
      Loading: "Loading…",
      dnsRecordsIntroTitle: "Email DNS records",
      dnsRecordsIntroBody:
        "Add the records below at your DNS host. Copy each value exactly. After DNS propagates, use Verify on DKIM and Return-Path until both show as verified.",
      Dkim_title: "DKIM",
      ReturnPath_title: "Return-Path",
      guidanceRecommendedLabel: "Recommended",
      guidanceMailDomainTitle: "Mail domain (core sending domain)",
      guidanceSpfTitle: "SPF",
      guidanceDmarcTitle: "DMARC",
      guidanceSpfMergeNote:
        "Do not overwrite an existing SPF record at your root domain. Merge this include with your current SPF value instead.",
      columnHostname: "Hostname",
      columnAddValue: "Add this value",
      Verify: "Verify",
      statusVerified: "Verified",
      statusInactive: "Inactive",
      CopyHostname: "Copy hostname",
      CopyAddValue: "Copy record value",
      DnsRecordsNotReady:
        "DNS record details are not available yet. Refresh the page in a moment or contact support if this persists.",
      removeEmailDnsRecords: "Remove Email DNS records",
      RemoveConfirmTitle: "Remove Email DNS records?",
      RemoveConfirmBody:
        "This removes DKIM and Return-Path DNS setup for {host}. You can add it again later.",
      setupIncompleteAfterRemove:
        "Email DNS setup was removed. Complete setup below. Outbound mail will not use your domain until DNS records are added again.",
      senderSignaturesTitle: "Sender signatures",
      senderSignaturesIntro:
        "Addresses your team can send from once Postmark has confirmed them. They appear here after DKIM and Return-Path are verified.",
      senderSignaturesLoading: "Loading sender signatures…",
      senderSignaturesEmpty:
        "No sender signatures yet. Add the first address below (admins only).",
      senderSignaturesAdminOnlyHint:
        "Only team admins can add sender signatures. Ask an admin if you need outbound mail from your domain.",
      senderSigColumnEmail: "From email",
      senderSigColumnName: "Display name",
      senderSigColumnReplyTo: "Reply-To",
      senderSigColumnReturnPath: "Return-Path domain",
      senderSigColumnRemove: "Remove",
      senderSigRemoveConfirmTitle: "Remove sender signature?",
      senderSigRemoveConfirmBody:
        "Remove {email} from sender signatures? You can add it again later.",
      senderSigHostnameLabel: "Hostname",
      senderSigFromEmailLabel: "From email",
      senderSigFromNameLabel: "From name (optional)",
      senderSigReplyToLabel: "Reply-To (optional)",
      senderSigReturnPathLabel: "Return-Path domain (optional)",
      senderSigReturnPathPlaceholder: "Uses default from Return-Path DNS if empty",
      senderSigConfirmationNoteLabel: "Confirmation note (optional)",
      senderSigSubmit: "Add sender signature",
    },
    customerStatus: {
      pending_dns: "Waiting for DNS records",
      validating_ssl: "Validating SSL",
      active: "Active",
      failed: "Setup failed",
      other: "Processing",
    },
    dns: {
      Instructions_title: "DNS setup instructions",
      Instructions_subtitle:
        "Add the following records at your DNS provider. Use Copy to paste into your DNS panel.",
      Empty_state:
        "DNS records will appear here once provisioning finishes. This can take a minute.",
      Type: "Type",
      Name: "Name",
      Content: "Value",
      Ttl: "TTL",
      Copy: "Copy",
      CopyNameValue: "Copy host or record name",
      CopyContentValue: "Copy record value",
      CopiedStateAria: "Copied to clipboard",
      CopySuccess: "Copied to clipboard",
      Close: "Close",
      VerifyNow: "Check status",
      ChooseProvider: "Provider-specific steps",
    },
    dnsProvider: {
      manual: "Other / manual",
      cloudflare: "Cloudflare",
      route53: "Amazon Route 53",
    },
    CloudflareZoneId_label: "Cloudflare Zone ID",
    CloudflareZoneId_placeholder: "Zone ID from Cloudflare dashboard",
    CloudflareZoneId_hint:
      "Required when using Cloudflare as provider. Find it in the Cloudflare dashboard overview.",
    DnsProvider_label: "DNS provider",
    status: {
      REQUESTED: "Requested",
      PROVISIONING_PROVIDER: "Provisioning",
      AWAITING_DNS_CONFIG: "Awaiting DNS",
      DNS_PROPAGATING: "DNS propagating",
      SSL_PROVISIONING: "SSL provisioning",
      ACTIVE: "Active",
      FAILED: "Failed",
      DELETING: "Removing",
    },
    step: {
      pending: "Pending",
      verifying: "Verifying",
      active: "Active",
      failed: "Failed",
    },
    diagnostics: {
      Generic:
        "We could not finish setup. You can try Check status again or contact support.",
      CnameMismatch:
        "We can't verify your CNAME yet. Double-check the name and target at your DNS provider.",
      CertPending: "SSL is still provisioning. Wait a few minutes and try again.",
      Timeout:
        "Setup is taking longer than expected. Verify your DNS records and try Check status.",
      NotPropagated:
        "DNS may not have propagated everywhere yet. Wait and use Check status again.",
      DcvFailed:
        "SSL validation failed. The TXT record value may be wrong. Regenerate the DCV record and update DNS.",
    },
    errors: {
      Required: "Enter a subdomain.",
      Invalid_format: "Enter a valid hostname (for example portal.example.com).",
      Invalid_email_local_part:
        "Enter only the part before @ (letters, numbers, and . _ % + -).",
      Reserved: "That hostname can't be used. Pick another subdomain.",
      ZoneId_required: "Cloudflare Zone ID is required for this provider.",
      Already_exists: "This domain is already set up for your team.",
      Domain_in_use_elsewhere:
        "This domain is registered to another account. Contact support.",
      DnsNotFoundLong:
        "We can't find your DNS records. Double-check them with your DNS provider.",
      AuthRequired:
        "Please sign in again to continue. Use Google or Microsoft sign-in on this exact site (an email code alone is not enough), or sign out and sign back in here. Sign-ins only work on the website address where you made them.",
      MissingProvisionUrl:
        "API base URL is not configured (VUE_APP_API_URL). Domain setup POSTs to /custom-domains/provision on that host.",
      Email_hostname_must_match_custom_domain:
        "Hostname must match your active custom domain ({expected}).",
    },
    actions: {
      Continue: "Continue",
      Save: "Save",
      CheckStatus: "Check status",
      CancelSetup: "Cancel setup",
      CancelSetupTitle: "Cancel custom domain setup?",
      CancelSetupConfirm:
        "Cancel setup? You can add a domain again later. Pending DNS changes won't affect your main site.",
      DnsProviderHelp: "View provider steps",
      RegenerateDcv: "Regenerate TXT / DCV",
      OpenSite: "Open site",
      OpenPortal: "Open {host}",
      Remove: "Remove domain",
      RemoveConfirm: "Remove this custom domain?",
      RemoveConfirmTitle: "Remove domain",
      RemoveConfirmMvp:
        "Remove this domain? Team members will go back to the default app URL. Existing links that use this hostname will stop working.",
      ConfirmYes: "Yes",
      ConfirmNo: "Cancel",
      ViewInstructions: "View instructions",
      Recheck: "Recheck",
    },
    messages: {
      SetupStarted: "Custom domain setup started.",
      RecheckQueued: "Status check requested.",
      DcvRegenerateQueued:
        "Regeneration requested. Update your DNS when the new TXT value appears.",
      SetupCancelled: "Setup cancelled.",
      DomainRemoved: "Domain removal started.",
      CustomEmailCreated: "Custom email settings saved.",
      SenderSignatureAdded: "Sender signature created. Complete Postmark confirmation if prompted.",
      SenderSignatureRemoved: "Sender signature removed.",
    },
    notifications: {
      Email_will_be_sent: "",
    },
    providers: {
      godaddy: {
        title: "GoDaddy",
        step1: "Sign in to GoDaddy and open DNS for your domain.",
        step2: "Add a CNAME record using the name and value from the table.",
        step3: "Add the TXT record for verification.",
        step4: "Save changes and wait for propagation.",
        step5: "Return here and tap Check status.",
      },
      route53: {
        title: "Route 53",
        step1: "Open Route 53 > Hosted zones and select your zone.",
        step2: "Create a CNAME record with the name and target shown.",
        step3: "Create the TXT record for ACME / DCV verification.",
        step4: "Save the record set.",
        step5: "Wait a few minutes, then tap Check status.",
      },
      namecheap: {
        title: "Namecheap",
        step1: "Open Domain List > Manage > Advanced DNS.",
        step2: "Add the CNAME host and value from the table.",
        step3: "Add the TXT host and value.",
        step4: "Save and allow time to propagate.",
        step5: "Tap Check status here.",
      },
      cloudflare: {
        title: "Cloudflare",
        step1: "Open your site in Cloudflare > DNS.",
        step2: "Add the CNAME (DNS only if instructed by your admin).",
        step3: "Add the TXT verification record.",
        step4: "Save records.",
        step5: "Tap Check status after a few minutes.",
      },
      googleDomains: {
        title: "Google Domains",
        step1: "Open Google Domains > DNS.",
        step2: "Create custom records for CNAME and TXT as shown.",
        step3: "Save.",
        step4: "Wait for DNS to update.",
        step5: "Tap Check status.",
      },
    },
    endUser: {
      domainMembersOnly:
        "This domain is only accessible to members of this organization's team.",
    },
    boot: {
      notConfiguredTitle: "This domain is not configured",
      notConfiguredBody:
        "This hostname is not linked to an active Happily Assessment workspace. Check the address or contact support.",
      inactiveTitle: "This domain is not currently active",
      inactiveBody:
        "This custom domain is suspended or disabled. Contact your organization administrator.",
      errorTitle: "Unable to verify this domain",
      errorBody:
        "We could not load domain settings. Try again later or use the main Happily Assessment URL.",
    },
    accessDeniedHostname:
      "You cannot sign in on this domain with your account. Open Happily Assessment using your organization’s main URL, or ask an admin to add you to this team.",
    accessDeniedCustomDomainId:
      "This account was registered on a different portal address. Open the URL your organization gave you, or contact your administrator.",
  },
  coupon: {
    error_messages: {
      message_1: "Coupon code is required.",
      message_2: "Coupon code was not found.",
      message_3: "The coupon code has already expired.",
      message_4: "Coupon usage limit has been reached.",
      message_5: "Coupon already used.",
    },
  },
  toolbox: {
    Role: "Role",
    Role_focus: "Target Role",
    Level: "Level",
    Role_Level: "Role Level",
    Type_of_organization: "Type of Organization",
    Organization_Type: "Organization Type",
    Core_values: "Core Values",
    Your_Company_Values: "Your Company Values",
    Company_Mission_n_Vision: "Company Mission & Vision",
    Select_a_Role_and_Level: "Select a Role and Level",
    hiring: "Hiring",
    onboarding: "Onboarding",
    people_management: "People Management",
  },
  core_values_analyzer: {
    title: "Core Values Analyzer",
    short_desc: "Audit and get value-aligned recommendations",
  },
  job_role_generator: {
    Job_role_generator: "Team Role Generator",
    short_desc: "Define roles, behaviors, and promotion paths",
    Your_role_generator_that_makes:
      "Your role generator that makes accountability, responsibility, behaviors, and path to promotion clear.",
    Add_your_core_values_to_your_role_description_to_bring_them_to_life:
      "Add your core values to your role description to bring them to life",
  },
  job_post_generator: {
    Job_post_generator: "Job Post Generator",
    short_desc: "Autocraft detailed and effective job posts",
    Your_post_generator_that_makes:
      "Your job post generator that crafts a job post complete with responsibilities, qualifications, and expectations.",
    Add_your_core_values_to_your_role_description_to_bring_them_to_life:
      "Add your core values to your job post to bring them to life",
  },
  interview_guide: {
    Interview_guide: "Interview Guide",
    short_desc: "A script to run effective interviews",
    long_desc:
      "A set of questions and case study to assist your interview process",
    introduction:
      "Add your core values to your interview guide to bring them to life",
  },
  career_path_tracker: {
    Career_path_tracker: "Career Tracker Generator",
    short_desc: "Visualize and guide team member growth",
    Your_post_generator_that_makes:
      "Create a comprehensive career tracker to clarify personal growth opportunities.",
    Add_your_core_values_to_your_role_description_to_bring_them_to_life:
      "Add your core values to your career path tracker to bring them to life",
  },
  okr_generator: {
    Okr_generator: "OKR & Action Plans Generator",
    short_desc: "Set and track clear objectives and results",
    Your_OKR_generator_that_crafts_objectives_and_key_results_that_are_clear_and_measurable:
      "Your OKR generator that crafts objectives and key results that are clear and measurable",
    Select_between_Org_Team_or_Individual_OKRs:
      "Select between Org, Team, or Individual OKRs",
    Add_your_core_values_to_your_role_description_to_bring_them_to_life:
      "Add your core values to your OKRs to bring them to life",
    Title_for_company: "OKRs for {company}",
    Title_for_team: "OKRs for {role} Team",
    Title_for_individual: "OKRs for {role} {level}",
  },
  performance_improvement: {
    title: "Performance Improvement Plan",
    short_desc: "Structured plan for performance enhancement",
    subtitle:
      "Create a structured and clear plan to guide a team member to meeting or exceeding expectations",
    suggestion:
      "Add your core values to your performance improvement plan to bring them to life",
  },
  num_day_plan: {
    title: "30/60/90-day Plan",
    short_desc: "Structured 30/60/90-day integration plan",
    subtitle:
      "Create an onboarding plan for a new hire with clear activities and expectations",
    suggestion:
      "Add your core values to your onboarding plan to bring them to life",
  },
  aiProficiency: {
    results: {
      relative_strength: "Relative strength",
      task_result: "Assessment results",
      scope_note: "AI-generated analysis of this task. Scores reflect the responses observed, not overall ability.",
      suggested_next_step: "Suggested next step",
      analysis_unavailable: "Analysis is not available yet. Any saved conversation is shown below.",
      capabilities_hint: "Scores out of 100. Open a capability to see the evidence.",
      supporting_observations: "Supporting observations",
      gaps_observed: "Gaps observed",
      key_observation: "Key observation",
      supporting_detail: "Supporting detail",
      message_count: "Messages: {count}",
      excerpt_note: "Only a saved excerpt is available for this assessment.",
    },
    title: "AI Proficiency Assessment",
    overall_score: "Overall Score",
    task: "Task",
    total_messages: "Total Messages",
    candidate_messages: "Candidate Messages",
    analysis_summary: "Analysis Summary",
    
    // Readiness
    readiness_ready: "Ready for AI-Assisted Work",
    readiness_needs_development: "Needs Development",
    risk_low: "Low Risk",
    risk_moderate: "Moderate Risk",
    risk_high: "High Risk",
    risk_critical: "Critical Risk",
    confidence: "Confidence",
    confidence_high: "High",
    confidence_moderate: "Moderate",
    confidence_low: "Low",
    primary_risk: "Primary Risk",
    recommended_action: "Recommended Action",
    
    // Limiting Factor / Strongest Area
    limiting_factor: "Area for Development",
    strongest_area: "Top Strength",
    development_focus: "Development Focus",
    
    // Section Titles
    dimensions_title: "Core Capabilities",
    dimensions_subtitle: "How the candidate thinks and works with AI tools",
    skills_title: "Observed Behaviors",
    skills_subtitle: "What the candidate actually did during the assessment",
    
    // Dimension Labels
    dim_critical_thinking: "Critical Thinking",
    dim_critical_thinking_desc: "Questions AI outputs instead of accepting them at face value",
    dim_communication: "Communication Clarity",
    dim_communication_desc: "Gives clear, specific instructions to get better results",
    dim_domain_expertise: "Contextual Knowledge",
    dim_domain_expertise_desc: "Applies their expertise to guide and improve AI outputs",
    dim_judgment: "Decision Making",
    dim_judgment_desc: "Makes thoughtful choices when presented with options",
    dim_values_alignment: "Values Alignment",
    dim_values_alignment_desc: "Decisions reflect your company's values and culture",
    
    // Skill Labels
    skill_prompt_quality: "Prompt Quality",
    skill_prompt_quality_desc: "How clearly they communicate requests to the AI",
    skill_output_review: "Output Review",
    skill_output_review_desc: "How thoroughly they check AI responses for accuracy",
    skill_refinement: "Refinement Process",
    skill_refinement_desc: "How well they iterate to improve AI outputs",
    skill_situational_fit: "Situational Fit",
    skill_situational_fit_desc: "How well they adapt outputs to fit the context",
    skill_decision_quality: "Decision Quality",
    skill_decision_quality_desc: "How well choices reflect values and sound judgment",
    
    // Proficiency Levels
    level_expert: "Expert",
    level_expert_desc: "Exceptional. Catches subtle issues, excellent judgment, reliably values-aligned. Masters the human-AI collaboration.",
    level_ready: "Ready",
    level_ready_desc: "Solid and reliable. Catches most issues, makes sound decisions, generally values-aligned. Can be trusted with AI tools.",
    level_developing: "Developing",
    level_developing_desc: "Foundation exists but gaps remain. Shows potential but will miss issues or make questionable decisions.",
    level_needs_training: "Needs Training",
    level_needs_training_desc: "Significant skill gaps. Will regularly miss errors and make poor decisions. Not safe for independent use.",
    level_not_ready: "Not Ready",
    level_not_ready_desc: "Fundamental issues. AI use creates more risk than value. May actively make things worse.",
    
    // Labels
    key_moment: "Key Moment",
    strengths: "Strengths",
    areas_for_improvement: "Areas for Improvement",
    exchanges: "Exchanges",
    iterations: "Iterations",
    
    // Quality Badges
    iteration_purposeful: "Purposeful Iteration",
    iteration_adequate: "Adequate",
    iteration_excessive: "Over-Refined",
    iteration_insufficient: "Under-Refined",
    
    tailoring_highly_customized: "Highly Customized",
    tailoring_moderately_adapted: "Moderately Adapted",
    tailoring_mostly_generic: "Mostly Generic",
    tailoring_completely_generic: "Completely Generic",
    
    // Challenge & Values
    hidden_challenge: "Hidden Challenge Result",
    challenge_spotted: "Spotted the Issue",
    challenge_partial: "Partially Noticed",
    challenge_missed: "Missed the Issue",
    challenge_na: "Not Encountered",
    
    // Challenge Types
    challenge_type_context_dependency: "Context Dependency",
    challenge_type_factual_error: "Factual Error",
    challenge_type_logical_fallacy: "Logical Fallacy",
    challenge_type_outdated_info: "Outdated Information",
    challenge_type_missing_context: "Missing Context",
    challenge_type_assumption: "Unverified Assumption",
    
    values_alignment_test: "Values Under Pressure",
    values_alignment_test_subtitle: "How the candidate handled a situation that tested your company values",
    tension_tested: "Tension Tested",
    alignment_strong: "Strong Alignment",
    alignment_moderate: "Moderate Alignment",
    alignment_weak: "Weak Alignment",
    alignment_misaligned: "Misaligned",
    
    // Transcript
    conversation_preview: "Conversation Transcript",
    view_transcript: "View Transcript",
    hide_transcript: "Hide Transcript",
    candidate: "Candidate",
    ai_assistant: "AI Assistant",
    more_messages: "and {count} more messages...",
    load_more_messages: "Load {count} More",
    remaining: "remaining",
    
    // Scenario Details Modal
    view_details: "View Details",
    scenario_details: "Scenario Details",
    scenario_context: "Situation",
    scenario_assignment: "Task",
    scenario_deliverable: "Expected Output",
    scenario_key_details: "Key Information Provided",
    time_up_title: "Time is up",
    time_up_message: "Your responses have been recorded.",
    continue: "Continue",
    min_exchange_title: "Keep going",
    min_exchange_message: "Please have at least one exchange with the AI assistant before finishing.",
    read_more: "Read more",
    show_less: "Show less"
  },
  roleSkills: {
    results: {
      relative_strength: "Relative strength",
      development_focus: "Development focus",
      skill_breakdown: "Skills breakdown",
      skills_hint: "Expand a skill to review the scoring detail and evidence from the task.",
      discussion: "Discussion & next steps",
      scope_note: "Scores describe the work shown in this task, not overall ability or a hiring recommendation.",
      transcript_excerpt: "Only a saved excerpt is available for this conversation.",
      unavailable: "The analysis is not available yet.",
      message_count: "{count} messages",
    },
    title: "Role Skills Assessment",
    title_short: "Role Skills",
    overall_score: "Overall Score",
    skill_coverage: "Skill evidence captured",
    coverage_context_directional: "Evidence was captured for {probed} of {total} skills. Treat this score as directional and review the skill evidence below before making a hiring decision.",
    coverage_context_insufficient: "Evidence was captured for only {probed} of {total} skills, so there is not enough information for a reliable overall score. Review the available skill evidence without treating it as a complete evaluation.",
    coverage_context_complete: "Evidence was captured across all {total} skills. Review the skill evidence below to understand what supports the overall score.",
    candidates_assessed: "{assessed} of {total} candidates assessed",
    skill_assessed_count: "{count} of {total} candidates",
    skills: "Skills Assessed",
    transcript: "Task Transcript",
    intro_message: "Welcome. This is a practical {role} task, not a traditional interview. You'll work through a realistic situation with the AI assistant: ask questions, make decisions, and shape your response as you go.",
    task_label: "Your task",
    situation_label: "Situation",
    assignment_label: "Your assignment",
    deliverable_label: "What to deliver",
    key_details_label: "Key details",
    fallback_role: "professional",
    fallback_org: "organization",
    fallback_primary_skill: "role-critical work",
    fallback_task_title: "Turn Around an Underperforming {primarySkill} Initiative",
    fallback_task_scenario: "You are the {role} within a {orgType}. A high-priority initiative related to {primarySkill} is falling short of its goal. Leadership needs a clear recommendation within 48 hours, but time and resources are limited.",
    fallback_task_assignment: "Work with the AI assistant to diagnose the issue and build a practical action plan. Use your judgment across {skills}. Decide what to investigate first and how to handle the central tradeoff.",
    fallback_task_deliverable: "A concise recommendation covering priorities, rationale, immediate actions, risks, and measures of success.",
    fallback_task_detail_1: "You have enough time to investigate, but not to start over from scratch.",
    fallback_task_detail_2: "Your recommendation must distinguish evidence from assumptions.",
    fallback_task_detail_3: "Stakeholders expect both an immediate next step and a way to measure progress.",
    fallback_task_start: "Start by asking for any missing context you need, or share the first thing you would investigate and why.",
    complete_title: "Skills Task Complete",
    complete_description: "Thank you for completing the role skills task. Your work has been recorded.",
    startup_error_banner: "The task assistant couldn't connect, so your task hasn't started yet.",
    error_banner: "We couldn't reach the task assistant, so your response wasn't sent.",
    retry: "Try again",
    wrap_up_hint: "The task has wrapped up. Press Complete Task whenever you're ready.",
    analyzing_title: "Analyzing the task",
    analyzing_description: "We're scoring this work against the role's skill set. This usually takes under a minute.",
    analysis_failed: "We couldn't analyze this task.",
    analysis_retry: "Analyze again",
    not_assessed: "Not assessed",
    not_assessed_note:
      "The task never reached this skill, so it has no score. Nothing here should be read as a strength or a weakness.",
    proficiency: "Proficiency",
    evidence_confidence: "Evidence confidence",
    task_coverage: "Task coverage",
    coverage_value: "{probed} of {total} skills",
    responses_count: "Based on {count} candidate responses",
    deliverable_completed: "Deliverable completed",
    deliverable_incomplete: "Deliverable not completed",
    skills_subtitle:
      "Every candidate for this role is scored against the same skills, so you can compare them directly.",
    hiring_subtitle: "What to lean on, what to probe, and where the evidence runs out.",
    sub_dimensions: "Sub-dimensions",
    no_evidence: "No evidence",
    view_all_evidence: "View all evidence ({count})",
    hide_evidence: "Hide evidence",
    difficulty_reached: "Level reached",
    difficulty_reached_value: "{level} level reached",
    difficulty_foundational: "Foundational",
    difficulty_applied: "Applied",
    difficulty_advanced: "Advanced",
    difficulty_expert: "Expert",
    confidence_high: "High confidence",
    confidence_moderate: "Moderate confidence",
    confidence_low: "Low confidence",
    confidence_value_high: "High",
    confidence_value_moderate: "Moderate",
    confidence_value_low: "Low",
    level_expert: "Expert",
    level_proficient: "Proficient",
    level_developing: "Developing",
    level_beginner: "Beginner",
    level_novice: "Novice",
    strengths: "Strengths",
    gaps: "Gaps",
    strongest_skill: "Strongest skill",
    development_priority: "Development priority",
    analysis_summary: "Assessment synthesis",
    suggested_followups: "Suggested follow-up questions",
    hiring_summary: "Summary for the hiring team",
    skills_probed: "{probed} of {total} skills covered",
    chat_title: "Skills Task",
    interviewer: "Task assistant",
    time_up_title: "Time is up",
    time_up_message: "Your responses have been recorded.",
    continue: "Continue",
    min_exchange_title: "Keep going",
    min_exchange_message: "Please work through at least one step with the task assistant before finishing.",
    read_more: "Read more",
    show_less: "Show less",
    load_more: "Load more",
    complete_interview: "Complete Task",
    message_placeholder: "Ask a question or share your approach...",
    formatting_supported: "Formatting supported",
    formatting_tools: "Text formatting",
    format_bold: "Bold",
    format_list: "Bulleted list",
    format_code: "Code block",
    new_line_hint: "Shift + Enter for a new line",
    copy_code: "Copy code",
    code_copied: "Copied",
    code_label: "Code",
    finish_assessment: "Finish Assessment",
    next_section: "Next Section",
    finish_title: "Complete Task?",
    finish_description: "Your work will be submitted for evaluation. Make sure you've demonstrated the skills you'd like the hiring team to see.",
    early_finish_description: "The task assistant is still working through the scenario. Finishing now may leave important parts of your work without enough evidence to assess fairly.",
    finish_anyway: "Finish Anyway",
    keep_working: "Keep Working",
    hide_transcript: "Hide Transcript",
    view_transcript: "View Transcript",
    candidate: "Candidate",
  },
  resultsReport: {
    chapter: "Chapter {n}",
    candidate_report: "Candidate report",
    overview: "Overview",
    summary: "Conclusion",
    classic_view: "Classic view",
    report_view: "Report view",
    share_report: "Share report",
    link_copied: "Report link copied",
    copy_failed: "We could not copy the link for you. Here it is: {url}",
    share_manage: "Manage link",
    copy_link: "Copy link",
    create_copy_link: "Create and copy link",
    share_active: "Link active since {date}",
    share_active_unknown: "Link is active",
    share_none: "No active link",
    rotate_link: "Replace link",
    rotate_done: "New link copied. The old link no longer works.",
    revoke_link: "Turn off link",
    revoke_done: "Link turned off.",
    share_manage_failed: "Could not update the link. Please try again.",
    regenerate: "Regenerate report",
    complete_report: "Complete the report",
    still_scoring: "This section is still being scored. Check back shortly.",
    chapter_failed: "We couldn't generate this analysis. The data below is complete.",
    link_inactive: "This report link is no longer active. Ask the sender for a new link.",
    note_from: "Note from {name}",
    add_note: "Add a note",
    hide_chapter: "Hide this chapter from shared views",
    show_chapter: "Show this chapter in shared views",
    hidden_badge: "Hidden from shared views",
    detail_title: "Supporting detail",
    evidence_title: "Inside the {title} result",
    evidence_page_intro: "The scores, comparisons and responses used to interpret this section.",
    evidence_page_progress: "Detail {current} of {total}",
    evidence_page_continued: "Detail {current} of {total}",
    candidate_voice: "In the candidate's own words",
    scorecard_title: "Assessment at a glance",
    scorecard_intro: "A section-by-section map of the candidate's results. Open each chapter for the interpretation and supporting evidence.",
    scorecard_note: "Work style is a preference profile rather than a pass-or-fail score.",
    scorecard_scored_group: "Scored measures",
    scorecard_scored_group_hint: "Comparable within each assessment's stated scoring method",
    scorecard_profile_group: "Profiles and qualitative evidence",
    scorecard_profile_group_hint: "Descriptive signals, not pass-or-fail scores",
    scorecard_big_five_profile: "Five-trait profile",
    scorecard_qualitative: "Qualitative responses",
    scorecard_qualitative_caption: "Read the responses in context",
    scorecard_objective_only_caption: "Score covers objective questions only",
    scorecard_partial_coverage_caption: "Directional: {probed} of {total} skills probed",
    scorecard_profile_caption: "Dominant preference, not a pass-or-fail score",
    score_meaning: "What the score means",
    methodology: "How it was assessed",
    values_methodology_brief:
      "The candidate selects values and traits from the same library used by the company. Matches reflect company priorities; selecting a value marked non-essential creates a potential conflict. Separate scenarios test whether stated values hold up in choices.",
    values_methodology_brief_v4:
      "The candidate chooses six values from 24 value cards and puts them in order. Each of your company values was matched to the cards that express it: a value is shared when they chose that card, partly shared when they chose a related one. Scenarios test whether their choices hold up.",
    culture_methodology_brief:
      "The candidate and company each distribute 100 points across Collaborate, Create, Compete and Control in six dimensions. Alignment reflects the distance between their profiles; the opposing priorities reveal relative cultural tilt. It measures preference, not quality.",
    jump_to_chapter: "Jump to a chapter",
    watch_outs: "Worth a closer look",
    ask_in_interview: "Explore in the interview",
    how_to_read_title: "How to read this report",
    overall_score: "Overall score",
    overall_score_context: "Combined signal across scored sections",
    takeaways_title: "What stands out",
    overview_unavailable: "The opening summary is not ready yet, but every chapter below is complete.",
    summary_unavailable: "The closing summary is not ready yet, but every chapter above is complete.",
    interview_focus_title: "What to explore next",
    note_placeholder: "Write a short note for whoever reads this report",
    note_hint: "Save an empty note to remove it.",
    loading_report: "Loading the report",
    preparing_report: "Writing the report",
    preparing_report_hint:
      "This usually takes a minute or two. You can leave this page and come back to it.",
    not_ready_title: "This report is not ready yet",
    not_ready_body: "The report has not been created yet. Please check back soon.",
    load_error_title: "We could not open this report",
    load_error_body: "Please refresh the page. If it keeps happening, ask the sender for a new link.",
    load_error_admin_body: "We could not create the report. This is usually temporary.",
    retry: "Try again",
    writing_chapter: "Writing chapter {current} of {total}",
    previous_chapter: "Previous chapter",
    next_chapter: "Next chapter",
    generation_failed: "We could not finish the report. Please try again.",
    generated_on: "Generated {date}",
    stale_notice: "Results changed after this report was written. Regenerate to update it.",
    shown_in_language: "This report was written in {language}.",
    shown_in_language_admin_hint: "Regenerate to create it in the current language.",
    export_pdf: "Export PDF",
    export_powerpoint: "Export PowerPoint",
    preparing_export: "Preparing your export",
    export_failed: "We could not export this report. Please try again.",
    export_layout_error: "Some content does not fit the slides. Export was stopped to prevent missing text. Please review the report layout.",
    note_author_fallback: "Hiring team",
    powered_by: "Powered by",
    band: {
      excellent: "Excellent",
      good: "Good",
      fair: "Fair",
      poor: "Poor",
    },
    culture_hero: {
      alignment: "culture alignment",
      radar_description: "Candidate and company culture profiles compared across Collaborate, Create, Compete, and Control",
      clan: "Builds together, values teamwork and trust",
      create: "Drives new ideas, explores and innovates",
      compete: "Pushes to win, sets high standards and delivers",
      control: "Prefers structure, order and clarity",
    },
    values_hero: {
      alignment: "value alignment",
      comparison: "Values compared with company priorities",
      match_summary: "{matched} of {total} listed values align with company priorities",
      choice_consistency: "Scenario consistency",
      gap_badge: "Gap to explore",
      strong_badge: "Strong match",
      match_badge: "Match",
      strong_count: "Company-value matches",
      compatible_count: "Compatible preferences",
      gap_count: "Gaps to explore",
      key_signals: "Key value signals",
      more_values: "+{count} additional values shown in the supporting detail",
    },
    behavior_hero: {
      standards_aligned: "standards aligned",
      aligned_count: "{count} aligned",
      discuss_count: "{count} to discuss",
      overall_note: "Overall closeness across all {total} behaviors: {overall}%.",
      comparison: "You: {company} · Candidate: {candidate}",
      needs_attention: "Needs attention",
      worth_discussing: "Worth discussing",
      more_flagged: "+{count} more flagged scenarios in the supporting detail",
      severity: {
        acceptable: "Acceptable",
        frowned_upon: "Frowned upon",
        actively_discouraged: "Actively discouraged",
        reprimanded: "Reprimanded",
        zero_tolerance: "Zero tolerance",
      },
    },
    profile_hero: {
      highest_dimension: "Highest-scoring dimension",
      candidate_score: "Candidate score",
      profile_range: "Profile range {low} to {high}",
    },
    framing: {
      values_and_traits: "What this measures: whether {name} would make the same everyday tradeoffs your team makes. It compares their chosen values against yours. There are no right or wrong answers.",
      oaic_archetypes: "What this measures: the kind of culture {name} works best in, compared point by point with the culture your team described for itself.",
      acceptable_behaviors: "What this measures: where {name} draws the line on workplace behaviors, compared with where your company draws it.",
      human_skills: "What this measures: how {name} communicates and reasons in their own written words, scored for communication, empathy, awareness, and critical thinking.",
      logic_test: "What this measures: {name}'s accuracy on pattern, reasoning, and data questions with objectively correct answers.",
      work_style_identifier: "What this shows: the kind of work that energizes {name} most, across people, process, and product. This is a style, not a score.",
      big5: "What this shows: {name}'s personality profile across five research-backed traits. This is a profile, not a pass or fail.",
      ai_use_evaluator: "What this measures: how well {name} works with AI on a realistic task, including whether they caught a planted flaw.",
      role_skills_evaluator: "What this measures: {name}'s role-specific skills, probed in a live working conversation with cited evidence.",
      custom_survey: "Your own questions, answered by {name} in their own words.",
    },
    detail: {
      question: "Question",
      answer: "Answer",
      correct: "Correct",
      incorrect: "Incorrect",
      not_scored: "Not scored",
    },
    values_detail: {
      v4_shared: "Shared",
      v4_partly: "Partly shared",
      v4_not_shared: "Not shared",
      v4_scenarios: "For the interview",
      v4_matches: "Matches {values}",
      v4_not_a_fit: "Your company listed {values} as not a fit",
      fit_high: "High fit",
      fit_medium: "Medium fit",
      fit_low: "Low fit",
      alignment: "Alignment",
      consistency: "Scenario consistency",
      consistency_hint: "Choices matched stated values",
      traits: "Traits selected",
      unselected_company_values: "Company priorities not selected",
      company_matches: "Direct company-value matches",
      company_matches_hint: "{name} personally selected these values that your company also prioritizes.",
      company_core_value: "Company core value",
      company_expected_standard: "Company expected standard",
      potential_conflicts: "Potential value conflicts",
      potential_conflicts_hint: "The candidate selected a value your company marked non-essential.",
      no_conflicts: "No selected personal value was marked non-essential by your company.",
      company_non_essential: "Company marked non-essential",
      value_map: "How personal values map to your company",
      value_map_headline: "Three ways to read {name}'s personal values",
      value_map_intro: "A shared priority is a direct match. A value your company marked non-essential is a potential conflict. Everything else is neutral, not a negative signal.",
      neutral_selections: "Neutral personal selections",
      company_neutral: "Neither priority nor conflict",
      scenarios_title: "How they responded to value scenarios",
      scenarios_hint: "Each scenario checks whether behavior supports the stated value. It supports the conversation, but does not directly measure company alignment.",
      value_tested: "Value being tested",
      candidate_chose: "Candidate chose",
      use_in_conversation: "Use in conversation",
      verified: "Verified in scenario",
      not_verified: "Needs discussion",
      not_completed: "Not completed",
      probe_verified: "Ask for a real example where {value} shaped a similarly difficult tradeoff.",
      probe_gap: "Ask what drove this choice and when they would choose {value} instead.",
      probe_incomplete: "Work through this scenario live and ask how {value} would guide the decision.",
      aligned_choice: "Chose the option that matches this value",
      competing_choice: "Chose the option that competes with this value",
    },
    culture_detail: {
      dimension: "Dimension",
      alignment: "Alignment",
      dimension_alignment: "Alignment by organizational dimension",
      your_team: "Your team",
      competing_values: "Competing-value read",
      competing_values_hint: "The framework reveals which side of each opposing culture priority carries more weight.",
      points_toward: "{points} pts toward {direction}",
      relative_tilt: "{name} leans {points} points more toward {direction} than your team ideal.",
      same_tilt: "The candidate and your team place the same relative weight on these competing priorities.",
      incomplete_note: "Not completed, so left out of the overall score: {names}",
    },
    behaviors_detail: {
      behavior: "Behavior",
      your_rating: "Your rating",
      company_rating: "Company standard",
      candidate_rating: "{name}'s rating",
      rating_gap: "Rating gap",
      flag: "Flag",
    },
    human_skills_detail: {
      written_answers_title: "Written answers",
    },
    big_five_detail: {
      population_position: "Population position",
    },
    logic_detail: {
      your_average: "Your team's average",
      candidate_score: "{name}'s score",
      time_spent: "Time spent",
      points_vs_team: "points vs team average",
    },
    work_style_detail: {
      share: "Share of their preference",
      strengths: "Likely strengths",
      considerations: "What to manage",
    },
    ai_detail: {
      readiness: "Readiness",
      values_alignment: "Values under pressure",
    },
  },
  reportViewer: {
    back_to_results: "Back to results",
    assessment_report: "Assessment report",
    who_is_this_for: "Who is this for?",
    audience_hiring_team: "Hiring team · Includes interviewer guidance. Anyone with the report link can view it.",
    audience_candidate: "Candidate · Their results, without interviewer guidance.",
    preparing_link: "Preparing link…",
    copy_report_link: "Copy report link",
    please_try_again: "Please try again.",
    your_results: "Your assessment results",
    load_results_error: "We couldn't load your results",
    opening_report: "Opening your report…",
    loading_results: "Loading your results…",
    candidate: "Candidate",
    company: "Company",
    assessment: "Assessment",
    overall_result: "Overall result",
    shell: {
      footer_sample: "Sample report · Fictional data",
      footer_confidential: "Confidential · Assessment results",
      full_screen: "Full screen",
      exit_full_screen: "Exit full screen",
      report_options: "Report options",
      more: "More",
      download_pdf: "Download PDF",
      editable_pptx: "Editable PowerPoint",
      preparing_analysis: "Preparing analysis…",
      refresh_analysis: "Refresh analysis",
      fullscreen_unavailable: "Full screen is unavailable in this browser. You can still read the report here.",
      connecting: "Connecting to the analysis service…",
      summaries_up_to_date: "Evidence-based summaries are up to date.",
      preparing_analysis_progress: "Preparing analysis {current} of {total}…",
      refresh_partial: "Some analysis could not be refreshed. Evidence-based summaries remain available.",
      analysis_updated: "Analysis updated.",
      refresh_failed: "Analysis could not be refreshed. The report and evidence-based summaries remain available.",
      interpretation_unavailable: "Some interpretation is unavailable. The assessment evidence remains visible.",
      report_unavailable: "Report unavailable.",
      pptx_downloaded: "Editable PowerPoint downloaded.",
      pdf_downloaded: "PDF downloaded.",
    },
    nav: {
      report_navigation: "Report navigation",
      go_to_page: "Go to page",
      previous_page: "Previous page",
      next_page: "Next page",
      present_slides: "Present slides",
      all_pages: "All pages",
      no_results: "No assessment results are available yet.",
      page_label: "Page {n}: {title}",
    },
    subtitles: {
      oaic_archetypes: "Compare preferred ways of working with the company’s culture.",
      human_skills: "How the candidate communicates, understands others, and works through a situation.",
      logic_test: "Reasoning performance across different types of problems.",
      work_style_identifier: "The kinds of work the candidate prefers to contribute to.",
      big5: "Five descriptive dimensions of the candidate’s personality profile.",
      ai_use_evaluator: "What the assessment revealed about working effectively with AI.",
      role_skills_evaluator: "What the task revealed, and what still needs a conversation.",
      custom_survey: "Role-specific knowledge and experience selected by the company.",
    },
    culture: {
      collaborate: "Collaborate",
      create: "Create",
      compete: "Compete",
      control: "Control",
      points_note: "Company / candidate preference points. Higher is not better.",
      preference_points: "Preference points",
      difference: "Difference",
      unavailable: "Unavailable",
      row_description: "{label}: company {company}, candidate {candidate} points",
    },
    pageBody: {
      v4_pairs_title: "Where your values and the candidate's picks meet",
      v4_only_yours: "Only on your list",
      v4_only_yours_sub: "Your values with no pick nearby",
      v4_common: "Common ground",
      v4_common_sub: "≈ shared · ~ partly shared",
      v4_only_theirs: "Only on theirs",
      v4_only_theirs_sub: "Their picks outside your list",
      v4_map_title: "The candidate's picks on the values map",
      v4_anchor_on: "on {card}",
      v4_anchor_via: "via {pick}",
      v4_anchor_also: "also near {picks}",
      v4_credit_full: "Full",
      v4_credit_half: "Half",
      v4_credit_none: "Not shared",
      v4_legend_pick: "Their pick",
      v4_legend_close: "Close to a pick",
      v4_legend_related: "Related to a pick",
      v4_legend_none: "Not near their picks",
      v4_legend_picks_title: "Their picks",
      v4_legend_pick_shared: "Shares one of your values",
      v4_legend_pick_partly: "Partly shares one",
      v4_legend_pick_theirs: "Only theirs",
      v4_legend_pick_conflict: "Lowered the score",
      v4_legend_around_title: "Other cards",
      v4_legend_not_fit: "Doesn't fit here",
      v4_legend_tension: "Pulls against a value",
      v4_anchor_pulled: "{cards} pulls against it",
      v4_scenario_value: "Value tested",
      v4_scenario_text: "Scenario",
      v4_scenario_choice: "Their choice",
      v4_scenario_result: "Result",
      v4_result_held: "Held up",
      v4_result_leaned: "Leaned away",
      v4_result_incomplete: "Not answered",
      candidate_assessment: "Candidate assessment",
      prepared_for_hiring_team: "Prepared for the hiring team",
      status_completed: "Completed",
      status_results_available: "Results available",
      status_awaiting_results: "Awaiting results",
      profile: "Profile",
      ring_preference: "Preference",
      ring_alignment: "Alignment",
      ring_proficiency: "Proficiency",
      ring_result: "Result",
      what_scores_mean: "What the scores mean",
      what_to_follow_up: "What to follow up on",
      five_dimensions: "Five descriptive dimensions",
      preferred_contributing: "Preferred ways of contributing",
      values_title: "Company values × candidate choices",
      company_categories: "Company categories",
      selected_by_candidate: "Selected by candidate",
      not_selected: "Not selected",
      none: "None",
      culture_unavailable: "Culture comparison is not available.",
      where_expectations_differ: "Where expectations differ",
      scenarios_on_page_one: "{count} scenario on this page",
      scenarios_on_page_other: "{count} scenarios on this page",
      no_scenarios: "No scenario comparisons are available yet.",
      workplace_scenario: "Workplace scenario",
      scenario_number: "Scenario {n}",
      continued: "continued",
      what_to_clarify: "What to clarify",
      clarify_default: "Clarify the context behind these responses.",
      work_style_alt: "Work style preference distribution",
      lower_expression: "Lower expression",
      higher_expression: "Higher expression",
      no_scored_dimensions: "No scored dimensions are available.",
      interview_question: "Interview question",
      not_enough_info: "There is not enough information to explain this result yet.",
      missing_scores_many: "{count} sections have no score yet. Follow up with interview questions or a work sample.",
      missing_scores_one: "{name} has no score yet. Follow up in the interview or with a work sample.",
      follow_up_default: "Use the interview and work examples to clarify differences and areas this assessment did not cover.",
      group_alignment: "Alignment & company questions",
      group_skills: "Skills & reasoning",
      title_reasoning_by_dimension: "Reasoning by dimension",
      title_task_dimensions: "Task dimensions",
      title_skills_assessed: "Skills assessed",
      meaning_shared_priorities: "Shared priorities",
      meaning_ways_of_working: "Preferred ways of working",
      meaning_workplace_expectations: "Workplace expectations",
      meaning_written_evidence: "Evidence from written responses",
      meaning_reasoning_tasks: "Performance on reasoning tasks",
      meaning_ai_task: "Performance in the AI task",
      meaning_skills_in_task: "Skills demonstrated in the task",
      meaning_scored_questions: "Scored questions only",
      section_result: "Section result",
      page_ref: "p. {n}",
      not_assessed: "Not assessed",
    },
  },
  resultsPage: {
    behaviorDetails: {
      title: "Behavior details",
      inactivePercent: "Inactive {percent}",
      view: "View",
      eyebrow: "Hiring manager tool",
      modalTitle: "Assessment Behavior",
      subtitle: "Shows when the candidate left the assessment window and when they pasted text while completing it. Unusual patterns may be worth asking about, but they do not prove the candidate did anything wrong.",
      close: "Close assessment behavior details",
      windowInactive: "Window inactive",
      resumeCount: "Resume count",
      sectionsWithPaste: "Sections with paste detected",
      colSection: "Section",
      colActive: "Active",
      colInactive: "Inactive",
      colHidden: "Hidden",
      colBlurred: "Blurred",
      colFocusLosses: "Focus losses",
      colLongestInactive: "Longest inactive",
      colTextField: "Tracked text field",
      colFinalLength: "Final length",
      colTypedChars: "Typed chars",
      colPastedChars: "Pasted chars",
      colPasteEvents: "Paste events",
      colFirstInput: "First input",
      colTimeToFirstInput: "Time to first input",
      pasteSectionOne: "1 paste section",
      pasteSectionMany: "{count} paste sections",
      aiMessagesWithPaste: "AI Readiness Assessment messages with paste detected",
      aiPastedFiles: "AI Readiness Assessment pasted files",
      flagElevatedInactivity: "Elevated inactivity",
      flagMostlyInactiveSection: "Mostly inactive section: {section}",
      flagPasteHeavyResponse: "Paste-heavy response: {field}",
      flagMultipleResumes: "Multiple resumes",
      reviewSignalsNone: "No review signals",
      reviewSignalsOne: "1 review signal",
      reviewSignalsMany: "{count} review signals",
      inputTyped: "Typed",
      inputPasted: "Pasted",
      inputNone: "None",
    },
    resultsUnavailable: "Results unavailable",
    invalidResultsLink: "This results link is invalid or incomplete. Please request a fresh results link.",
    valuesScenario: {
      optionAligned: "Option A (Aligned with {value}):",
      optionCompeting: "Option B (Competing value):",
      choseAligned: "The candidate chose the option that aligns with their stated value",
      choseConflicting: "The candidate chose the option that conflicts with their stated value",
      notCompleted: "This scenario was not completed due to time constraints.",
      notCompletedDetail: "This scenario was not completed due to time constraints. The candidate did not have the opportunity to respond to this value-based scenario.",
      interviewSuggestion: "Interview suggestion:",
      interviewSuggestionText: "Ask the candidate to describe a specific situation where they demonstrated {value} in their work or personal life.",
    },
    loadingAiAnalysis: "Loading AI Analysis...",
    questionChecklist: "Question Checklist",
    data_analysis: "Data Analysis",
    exportResults: "Export Results",
    backToAssessments: "Back to assessments",
    loadingAssessmentDetails: "Loading assessment details",
    loadResultsError: "We couldn’t load these results. Please try again.",
    noValuesResponses: "No detailed values responses are available for this assessment.",
    valuesGroup: {
      title: "Values alignment: {score}%",
      titleNoScore: "Values alignment",
      description: "How closely each candidate's six chosen values match your company's values.",
      comparedOne: "1 candidate, compared on {scored} of your {total} values.",
      comparedMany: "{count} candidates, compared on {scored} of your {total} values.",
      tabCandidates: "Candidates",
      tabValues: "Values",
      candidatesHint: "Highest score first. Select a name to open their results.",
      keyShared: "shares it",
      keyPartly: "partly",
      keyNot: "nothing near it",
      colCandidate: "Candidate",
      colScore: "Score",
      band_high: "High",
      band_moderate: "Moderate",
      band_low: "Low",
      band_high_sub: "80% and above",
      band_moderate_sub: "50 to 79%",
      band_low_sub: "Under 50%, worth a closer look in the interview",
      countOne: "1 candidate",
      countMany: "{count} candidates",
      notScoredTitle: "Not scored",
      notScoredSub: "None of your values could be scored from their picks.",
      valuesHint: "Your values, in your order. Select one to see who shares it.",
      legendShared: "Shared",
      legendPartly: "Partly shared",
      legendNot: "Not shared",
      leastShared: "{value} is the value candidates share least: {count} of {total}. Worth asking about in every interview.",
      shareCount: "{count} of {total} share it",
      noOne: "No one",
      excludedScenarios: "No value card expresses this, so it isn't in the score. Explore it in the interview.",
      excludedUnmatched: "Couldn't be matched to the value cards, so it isn't in the score.",
      notAFitTitle: "Values you said don't fit here",
      pickedBy: "Picked by {count}: {names}",
      rankSuffix: "#{rank}",
      whyReason: "Why: {reason}",
      notCounted: "No reason was given, so it didn't lower their scores.",
      otherPicksTitle: "Popular picks outside your list",
      tensionOne: "{card} can pull against {value}. It lowered 1 score.",
      tensionMany: "{card} can pull against {value}. It lowered {count} scores.",
      averageLabel: "Average alignment",
      compareCandidates: "Compare candidates",
      empty: "No candidate has a values alignment result yet.",
      openResults: "Open {name}'s results",
    },
    aiModal: {
      capabilitiesSubtitle: "How candidates show key thinking skills when working with AI",
      behaviorsSubtitle: "What candidates actually did during the AI tasks",
      noCapabilityData: "No candidate data available for this capability.",
      noBehaviorData: "No candidate data available for this behavior.",
    },
    groupReport: {
      eyebrow: "Shared assessment report",
      preparingTitle: "Preparing group results",
      preparingText: "Bringing completed candidate scores into one clear view.",
      teamOverview: "Team overview",
      loadingNote: "This can take a moment when a report has several assessment areas.",
      defaultTitle: "Group analytics",
      heroTextOne: "A read-only view of group results across 1 completed candidate.",
      heroTextMany: "A read-only view of group results across {count} completed candidates.",
      markerHint: "Every marker represents one completed candidate.",
      completedCandidates: "Completed candidates",
      completed: "completed",
      overallDistribution: "Overall candidate score distribution",
      scoreGuide: "Score guide",
      below60: "Below 60",
      score80Plus: "80 and above",
      selectMarker: "Select a marker for details",
      assessmentAreas: "Assessment areas",
      groupResults: "Group results",
      groupResultsText: "Compare candidate distributions and group averages by area.",
      areaDistribution: "{area} candidate score distribution",
      percentileDistribution: "{area} candidate percentile distribution",
      individualReports: "Individual reports",
      individualCandidates: "Individual candidates",
      individualCandidatesText: "Open a candidate’s full report in a new tab.",
      overallScore: "Overall Score:",
      viewResults: "View Results",
      loadError: "Unable to load analytics. Please check the link.",
      loadFailed: "Failed to load analytics",
      importance: "importance",
      loading: "Loading...",
      writtenCommunication: "Written Communication",
      empathy: "Empathy",
      situationalAwareness: "Situational Awareness",
      criticalThinking: "Critical Thinking",
    },
  },
  candidateFlow: {
    company_logo: "Company logo",
    myculture_logo: "MyCulture logo",
    previous_question: "Previous question",
    next_question: "Next question",
    confirm: {
      tracking_notice: "Window activity and paste metadata may be recorded while you take this assessment. Clipboard contents are not stored.",
      already_completed_title: "You’ve already completed this assessment",
      already_completed_body: "Thank you for taking the time to complete the assessment with us. Your responses have already been submitted.",
      already_completed_contact: "If you have any questions, please contact us at {email}",
    },
    aiUse: {
      ai_assistant: "AI Assistant",
      conversation_label: "AI assistant conversation",
      attach_files: "Attach files or images",
      image_preview: "Preview",
      close_image_preview: "Close image preview",
      task_complete: "Task Complete",
      task_complete_message: "Your conversation has been recorded and will be analyzed to assess your AI readiness.",
      messages: "Messages",
      time_spent: "Time Spent",
      continue_next_section: "Continue to Next Section",
      complete_task_title: "Complete Task?",
      complete_task_confirm: "Are you sure you want to complete this task? You still have {time} remaining.",
      continue_working: "Continue Working",
      yes_complete: "Yes, Complete",
      file_too_large: "File \"{name}\" is too large. Maximum size is 10MB.",
      file_type_not_supported: "File type \"{type}\" is not supported.",
      time_seconds: "{seconds}s",
      time_minutes_seconds: "{minutes}m {seconds}s",
    },
  },
  setupFlow: {
    leave_dialog: {
      title: "Leave assessment setup?",
      body: "Any unsaved changes will be lost.",
      keep_editing: "Keep editing",
      leave: "Leave setup",
    },
    exit: "Exit",
    internal_assessment_name: "Internal assessment name",
    ai_setup_error: "AI setup could not finish. Your assessment is saved as a draft. Configure the affected sections manually or retry their AI setup.",
    messages: {
      ai_proficiency_ready: "AI Proficiency assessment ready for review",
      ai_readiness_task_configured: "AI Readiness Assessment task configured successfully",
      human_skills_configured: "Human Skills questions configured successfully",
      sections_save_failed: "We couldn't save the selected assessment sections. Please try again.",
      edit_errors: {
        not_available: "This assessment is no longer available for editing.",
        multiple_active: "More than one active assessment uses this link. Nothing was saved. Please contact support.",
        changed: "This assessment has changed since you opened it. Reopen it before saving.",
        reopen_required: "Reopen the assessment before saving your changes.",
        draft_missing: "We couldn't find your unsaved changes. Reopen the assessment and try again.",
        forbidden: "You don't have permission to edit this assessment.",
        values_mismatch: "Company values and Values Alignment do not match. Nothing was saved. Update the Values Alignment setup before publishing. If candidates have already taken this assessment, contact support before changing existing results.",
      },
    },
    quick_start: {
      preview_title: "{role} Culture Fit",
      roles: {
        sales_manager: "Sales Manager",
        customer_success_manager: "Customer Success Manager",
        software_engineer: "Software Engineer",
        marketing_manager: "Marketing Manager",
        operations_manager: "Operations Manager",
        account_executive: "Account Executive",
      },
      preview_rows: {
        handling_disagreement: "Handling disagreement",
        what_motivates_them: "What motivates them",
        giving_feedback: "Giving feedback",
        team_collaboration: "Team collaboration",
      },
    },
  },
  accountBilling: {
    nav: {
      greenhouse_integration: "Greenhouse integration",
      ai_connector: "AI Connector",
    },
    current_plan: "Current plan",
    included_in_plan: "Included in your plan",
    per_month: "/month",
    billed_annually: "{price} billed annually",
    checkout_note_annual: "Secure checkout · annual billing",
    checkout_note_one_time: "Secure checkout · one-time payment",
    test_checkout: "Test checkout",
    price_each: "{price} each",
    usage: {
      assessments_remaining: "assessments remaining",
      used_of_total: "used of {total}",
      progress_label: "{used} of {total} assessments used",
      used_count: "{count} used",
      total_count: "{count} total",
    },
    upgrade_options: {
      eyebrow: "Upgrade options",
      title: "Choose how to add more assessments",
      body: "Upgrade for predictable capacity and more team features, or buy credits when you only need a few more assessments.",
    },
    growth: {
      fit: "For growing teams",
      description: "A predictable annual allowance for teams running regular hiring and development assessments.",
      capacity_line1: "completed assessments",
      capacity_line2: "per year",
      feature_types: "All 10 assessment types",
      feature_comparison: "Team comparison tools",
      feature_members: "5 team members",
      feature_support: "Priority email support",
      choose: "Choose Growth",
    },
    business: {
      fit: "For high-volume programs",
      description: "Unlimited assessment capacity with advanced branding, reporting, and integration controls.",
      capacity: "completed assessments",
      no_limit: "No usage limit",
      feature_everything_growth: "Everything in Growth",
      feature_reports: "Presentation-ready reports",
      feature_branding: "Custom branding and surveys",
      feature_api: "API access and dedicated support",
      choose: "Choose Business Plus",
    },
    credit_pack: {
      divider: "Or buy only what you need",
      fit: "Flexible usage",
      title: "Flexible credit packs",
      body: "Add 10 to 100 credits to Free or Growth without changing your plan. Purchased credits never expire.",
      fact_no_recurring: "No recurring payment",
      fact_all_types: "All assessment types",
      fact_top_up: "Top up whenever needed",
      selected_pack: "Selected pack",
      credits_unit: "credits",
      one_time_payment: "One-time payment",
      remove_ten: "Remove 10 assessment credits",
      add_ten: "Add 10 assessment credits",
      size_label: "Assessment credit pack size",
      size_value: "{count} assessments, {price}",
      growth_hint: "Need 150 assessments? Growth offers better value at {price} per year.",
      preparing_checkout: "Preparing secure checkout…",
      buy_cta: "Buy {count} credits for {price}",
    },
    errors: {
      account_not_confirmed: "We could not securely confirm your account. Refresh this page and try again.",
      reauth_title: "Please sign in again",
      reauth_body: "For your security, your sign-in session has expired. Sign in again to continue to checkout. We'll bring you back to this page.",
      reauth_confirm: "Sign in again",
      reauth_cancel: "Cancel",
      session_mismatch: "Your secure session does not match this account. Sign out, sign in again, and retry.",
      checkout_not_configured: "Stripe checkout is not configured.",
      checkout_not_available: "Stripe checkout is not available on this page.",
      checkout_misconfigured: "Stripe checkout is not configured correctly.",
      checkout_failed: "Checkout could not start. Please try again.",
      checkout_title: "Checkout could not start",
      try_again: "Please try again.",
    },
  },
  bulkInvite: {
    title: "Invite people",
    close: "Close",
    minutes: "about {count} min",
    subject_label: "Subject",
    message_label: "Message",
    insert_label: "Insert",
    insert_first_name: "First name",
    insert_your_name: "Your name",
    insert_start_button: "Start button",
    token_RECIPIENT_FIRST_NAME: "First name",
    token_RECIPIENT_LAST_NAME: "Last name",
    token_SENDER_NAME: "Your name",
    token_SENDER_FIRST_NAME: "Your first name",
    token_SENDER_LAST_NAME: "Your last name",
    token_BUTTON_TO_ASSESSMENT: "Start button",
    sender_note: "Sent from {sender}. We add your logo at the top and a footer.",
    loading_message: "Preparing the message",
    recipients_label: "Recipients",
    count_one: "{count} person",
    count_other: "{count} people",
    paste_list: "Paste list",
    upload_csv: "Upload CSV",
    paste_help: "Paste email addresses, or rows copied from a sheet. One per line or separated by commas. Names are optional.",
    paste_found_one: "Found {count} person",
    paste_found_other: "Found {count} people",
    paste_found_none: "No email addresses found yet",
    paste_skipped_one: "1 line has no email address and will be skipped: {line}",
    paste_skipped_other: "{count} lines have no email address and will be skipped",
    paste_duplicates: "{count} already on the list",
    add_people: "Add people",
    add_count_one: "Add {count} person",
    add_count_other: "Add {count} people",
    clear: "Clear",
    cancel: "Cancel",
    add_by_hand: "Add one person by hand",
    drop_csv: "Or drop a CSV file anywhere in this panel.",
    col_first: "First name",
    col_last: "Last name",
    col_email: "Email",
    remove_row: "Remove row {row}",
    add_person: "Add person",
    issue_invalid: "Check this email address",
    issue_duplicate: "Already on this list (row {row})",
    partial: "Sent {sent} of {total}. The rows below didn't go through. Fix them and send again.",
    helper_ready: "Each person gets their own link.",
    helper_no_recipients: "Add at least one valid email to send.",
    helper_fix_rows: "{bad} rows need fixing. You can send to the other {good} now.",
    helper_fix_row: "1 row needs fixing. You can send to the other {good} now.",
    helper_no_subject: "Add a subject to send.",
    helper_no_message: "Write a message to send.",
    helper_no_button: "Add the start button to the message so people can open the assessment.",
    helper_paste_pending: "Add the people you pasted, then send.",
    send_test: "Send a test to me",
    send_count_one: "Send {count} invite",
    send_count_other: "Send {count} invites",
    send_none: "Send invites",
    sending: "Sending {done} of {total}",
    test_sent: "Test sent to {email}",
  },
};

export default en;
